window.slate = window.slate || {};
window.theme = window.theme || {};
window.theme.components = window.theme.components || {};
window.reactAPI = window.reactAPI || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  /**
   * Constructs an object of key / value pairs out of the parameters of the query string
   *
   * @return {Object}
   */
  getQueryParams: function () {
    var queryString = location.search && location.search.substr(1) || '';
    var queryParams = {};

    queryString
      .split('&')
      .filter(function (element) {
        return element.length;
      })
      .forEach(function (paramValue) {
        var splitted = paramValue.split('=');

        if (splitted.length > 1) {
          queryParams[splitted[0]] = splitted[1];
        } else {
          queryParams[splitted[0]] = true;
        }
      });

    return queryParams;
  },

  /**
   * Constructs a version of the current URL with the passed in key value pair as part of the query string
   *
   * @param {String} key
   * @param {String} value
   * @param {String} uri - optional, defaults to window.location.href
   * @return {String}
   */
  getUrlWithUpdatedQueryStringParameter: function (key, value, uri) {
    var uri = uri != undefined ? uri : window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  },

  /**
   * Constructs a version of the current URL with the passed in parameter key and associated value removed
   *
   * @param {String} key
   * @return {String}
   */
  getUrlWithRemovedQueryStringParameter: function (parameterKeyToRemove) {
    var sourceURL = window.location.href,
      rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";

    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === parameterKeyToRemove) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length > 0) {
        rtn = rtn + "?" + params_arr.join("&");
      }
    }

    return rtn;
  },

  /**
   * Check if we're running the theme inside the theme editor
   *
   * @return {bool}
   */
  isThemeEditor: function () {
    return location.href.match(/myshopify.com/) !== null && location.href.match(/theme_id/) !== null;
  },

  /**
   * Get the name of the correct 'transitionend' event for the browser we're in
   *
   * @return {string}
   */
  whichTransitionEnd: function () {
    var t;
    var el = document.createElement('fakeelement');
    var transitions = {
      'transition': 'transitionend',
      'OTransition': 'oTransitionEnd',
      'MozTransition': 'transitionend',
      'WebkitTransition': 'webkitTransitionEnd'
    };

    for (t in transitions) {
      if (el.style[t] !== undefined) {
        return transitions[t];
      }
    }
  },

  /**
   * Adds user agent classes to the document to target specific browsers
   *
   */
  userAgentBodyClass: function () {
    var ua = navigator.userAgent,
      d = document.documentElement,
      classes = d.className;

    // Detect iOS (needed to disable zoom on form elements)
    // http://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      classes += ' ua-ios';

      // Add class for version of iOS
      var matches = ua.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/);
      if (matches) {
        classes += ' ua-ios-' + matches[1];// e.g. ua-ios-7_0_2
      }

      // Add class for Twitter app
      if (/Twitter/.test(ua)) {
        classes += ' ua-ios-twitter';
      }

      // Add class for Chrome browser
      if (/CriOS/.test(ua)) {
        classes += ' ua-ios-chrome';
      }
    }

    // Detect Android (needed to disable print links on old devices)
    // http://www.ainixon.me/how-to-detect-android-version-using-js/
    if (/Android/.test(ua)) {
      var matches = ua.match(/Android\s([0-9\.]*)/);
      classes += matches ? ' ua-aos ua-aos-' + matches[1].replace(/\./g, '_') : ' ua-aos';
    }

    // Detect webOS (needed to disable optimizeLegibility)
    if (/webOS|hpwOS/.test(ua)) {
      classes += ' ua-webos';
    }

    // Detect Samsung Internet browser
    if (/SamsungBrowser/.test(ua)) {
      classes += ' ua-samsung';
    }

    d.className = classes;
  },

  /**
   * Generates a 32 bit integer from a string
   *
   * @param {string}
   * @return {int}
   */
  hashFromString: function (string) {
    var hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
      chr = string.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },

  chosenSelects: function ($container) {
    var $selects = $container ? $('select.form-control', $container) : $('select.form-control');
    $selects.not('[data-no-chosen]').chosen();
  },

  /**
   * Checks if the url has a query string passed in and it has a value
   * 
  * @param {string} relativeLink
  * @param {string} queryString
  * @param {string} checkForValue
  * @return {bool}
  *
  */
  linkHasQueryString: function (relativeLink, queryString, checkValue) {
    if (checkValue) {
      return (relativeLink.match(new RegExp('[?&]' + queryString + '=([^&]+)')) || [, false])[1].length >= 1;
    }
    else {
      return relativeLink.indexOf(queryString + '=') >= 0;
    }
  },
  /**
   * Get product handle from url
   * 
   * @param {string} absolute or relative product url
   */
  getProductHandleFromURL: function (productURL) {
    var url, handle = '', array = [];

    if (productURL) {
      if (productURL.indexOf('?')) {
        url = productURL.split('?')[0];
        array = url.split('/');
        handle = array[array.length - 1];
      }
      else {
        array = productURL.split('/');
        handle = array[array.length - 1];
      }
    }

    return handle;
  },
  /**
   * Send data over to Klaviyo when a user adds or removes something from their cart
   * @param {*} cartData json data - products from cart in json string
   */
  sendDataToKlaviyo: function (cartData) {
    var cart_items = { items: [] };
    var getUrl = window.location;
    var baseUrl = getUrl.protocol + "//" + getUrl.host + getUrl.pathname.split('/')[0];

    if (cartData.items) {
      cart_items.items = $.map(cartData.items, function (item) {
        return {
          Brand: item.vendor,
          Categories: "",
          CompareAtPrice: slate.Currency.formatMoney(item.discounted_price || item.line_price, theme.moneyFormat).substring(1),
          ImageURL: getImageURL(item),
          Name: item.product_title,
          Price: slate.Currency.formatMoney(item.price, theme.moneyFormat).substring(1),
          ProductID: item.product_id,
          URL: baseUrl + item.url
        };
      });

      cart_items.$value = slate.Currency.formatMoney(cartData.total_price, theme.moneyFormat).substring(1);
    }

    function getImageURL(item) {
      if (item.featured_image) {
        return item.featured_image.url;
      } else {
        return item.image;
      }
    }

    _learnq.push(['track', 'Add To Cart', cart_items]);
  },

  /**
   * Send data to Pinterest when a user adds to cart
   * 
   */
  sendDataToPinterest: function (cartData, variantID) {
    var lineItem = {};

    if (cartData.items) {
      lineItem = $.map(cartData.items, function (item) {
        if (item.id == variantID) {
          return {
            product_name: item.product_title,
            product_id: item.product_id,
            product_variant_id: item.id,
            product_price: slate.Currency.formatMoney(item.price, theme.moneyFormat).substring(1),
            product_quantity: item.quantity
          };
        }
      });
    }

    pintrk('track', 'addtocart', { line_items: lineItem });
  },

  sendDataToFacebook: function (cartData, variantID) {
    var lineItem = {};

    if (cartData.items) {
      lineItem = $.map(cartData.items, function (item) {
        if (item.id == variantID) {
          return {
            content_type: "product_group",
            content_ids: [item.product_id],
            value: slate.Currency.formatMoney(item.price, theme.moneyFormat).substring(1),
            currency: Shopify.currency.active || "",
            num_items: item.quantity,
            content_name: item.title || "",
            content_category: item.product_type || ""
          };
        }
      });
    }
    // fbq('trackCustom', 'OKAddToCart', lineItem[0]);        
  },
  /**
   * Validate user's email address
   */
  validateEmailAddress(emailAddres) {
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(emailAddres);
  },

  /**
   * Checks if total children width is larger than parent width
   */
  childrenLargerThanParent: function ($parent, $children) {
    if (!$parent || !$parent.length || !$children || !$children.length) {
      return false;
    }
    var parentWidth = $parent[0].offsetWidth,
      totalChildrenWidth = 0;

    $children.each(function () {
      totalChildrenWidth += $(this)[0].offsetWidth;
    });

    return parentWidth < totalChildrenWidth;
  },

  /**
   * Returns viewport width consistent with @media (width)
   * Source:
   * https://stackoverflow.com/questions/1248081/get-the-browser-viewport-dimensions-with-javascript
   */
  getViewportWidth: function () {
    return Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  fixTables: function() {
    $('.rte').find('table').each(function() {
      $(this).addClass('table');
      $(this).wrap('<div class="table-responsive"></div>');
    });
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Collection Filters
 * ------------------------------------------------------------------------------
 *
 * @namespace - collectionFilters
 */

slate.collectionFilters = (function(){

  var $body = $(document.body);
  var selectors = {
    filterSelect: '[data-filters-type][data-filters-type-select]',
    filtersClear: '[data-filters-clear]'
  };

  /**
   * CollectionFilters constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionFilters(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionFilters';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$container.on('change', selectors.filterSelect, this.applyFilters.bind(this));
    this.$container.on('click',  selectors.filtersClear, this.onFilterClearClick.bind(this));

    this._sortFilters();
  }

  CollectionFilters.prototype = $.extend({}, CollectionFilters.prototype, {

    /**
     * Returns a url for the current collection with selected filters
     *
     * @return {string} - url
     */
    _getCollectionUrlWithFilters: function() {
      var collectionUrl = this.collectionData.url;
      var tags = [];

      $(selectors.filterSelect, this.container).find('option:selected').each(function(){
        // Make sure we don't push empty strings
        if($(this).val()){
          tags.push( $(this).val() );
        }
      });

      tags = tags.map(function (str) {
        return str
          .toLowerCase()
          .replace(/[^\w\u00C0-\u024f]+/g, "-")
          .replace(/^-+|-+$/g, "");
      });

      return tags.length ? collectionUrl + '/' + tags.join('+') : collectionUrl;
    },

    /**
     * Filtering has nothing to do with the query string so make sure we don't mess with it.
     *
     * @return (string) - Empty string or query string with '?' prefix
     */
    _getQueryString: function() {
      var queryString = location.search && location.search.substr(1) || '';

      // Add the '?' prefix if there is an actual query
      if(queryString.length){
        queryString = '?' + queryString;
      }

      return queryString;
    },

    _sortingFunctions: {

      /**
       * Sorts sizes based on a predefined order
       *
       * @param (string) a
       * @param (string) b
       * @return (int)
       */
      size: function(a, b) {
        console.warn('[collectionFilters] - _sortingFunctions.size - This method hasn\'t been implemented yet.');
        // Implement this so sizes show up how we expect them to? small, med, large..
      }
    },

    /**
     * Sorts the filter options inside each select tag if there is an applicable sort function available
     */
    _sortFilters: function() {
      var self = this;

      $(selectors.filterSelect, this.$container).each(function(){
        var $select = $(this);
        var $toSort = $select.find('option');
        var sortingFunction = self._sortingFunctions[ $select.data('filters-type') ];

        if(sortingFunction){
          $toSort.sort(function(a, b) {
            return sortingFunction($(a).val(), $(b).val());
          });
        }
      });
    },

    /**
     * Redirects the browser to the collection page with any filters applied
     */
    applyFilters: function() {
      window.location.href = this._getCollectionUrlWithFilters() + this._getQueryString();
    },

    /**
     * Redirects the browser to the collection page without any filters applied
     */
    clear: function() {
      window.location.href = this.collectionData.url + this._getQueryString();
    },

    onFilterClearClick: function(e) {
      e.preventDefault();
      this.clear();
    }
  });

  return CollectionFilters;
})();
/**
 * Collection Sort
 * ------------------------------------------------------------------------------
 *
 * Dependencies
 *  - slate.utils
 *
 * @namespace - collectionSort
 */

slate.collectionSort = (function(){

  var $body = $(document.body);
  var selectors = {
    sortSelect: '[data-sort-select]'
  };

  /**
   * CollectionSort constructor
   *
   * @param {HTMLElement} container - Container element used for scoping any element selection
   * @param {Object} collectionData - see the bottom of `sections/collection.liquid`
   */
  function CollectionSort(container, collectionData) {
    this.$container = $(container);

    this.name = 'collectionSort';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection data
    if (!collectionData) {
      return;
    }

    this.collectionData = collectionData;

    this.$container.on('change', selectors.sortSelect, function() {
      var sortBy = $(this).val();
      var queryParams = slate.utils.getQueryParams();

      if(sortBy !== collectionData.sortDefault) {
        queryParams.sort_by = sortBy;
      }
      else {
        delete queryParams.sort_by;
      }

      location.search = $.param(queryParams);
    });
  }
  
  return CollectionSort;
})();
/**
 * AJAX Cart scripts
 * ------------------------------------------------------------------------------
 *
 * AJAX enabled cart
 * 
 * Usage: slate.AjaxCart.init(options);
 *
 * Requires:
 *  - Handlebars (for templating)
 *  - Slate
 *  - Flow (for international cart.  Can't pass as a dependency because properties get added to object asynchronously)
 */

(function ($, Handlebars, slate, undefined) {

  if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

  /*============================================================================
    API Functions
  ==============================================================================*/

  /**
   * AJAX submit an 'add to cart' form
   *
   * @param {jQuery} $form - jQuery instance of the form
   * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
   */
  ShopifyAPI.addItemFromForm = function ($form) {
    var promise = $.Deferred();
    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: $form.serialize(),
      success: function () {
        ShopifyAPI.getCart().then(function (data) {
          promise.resolve(data);
        });
      },
      error: function () {
        promise.reject({
          message: 'The quantity you entered is not available.'
        });
      }
    });

    return promise;
  };

  /**
   * AJAX add item to cart.  Same as above but consumes variant id and quantity instead of a form element
   *
   * @param {Number} variantId
   * @param {Number} quantity
   * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
   */
  ShopifyAPI.addItem = function (variantId, quantity, properties) {
    var promise = $.Deferred();

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: quantity,
        properties: properties
      },
      success: function () {
        ShopifyAPI.getCart().then(function (data) {
          promise.resolve(data);
        });
      },
      error: function () {
        promise.reject({
          message: 'The quantity you entered is not available.'
        });
      }
    });

    return promise;
  };

  /**
   * Retrieve a JSON respresentation of the users cart
   *
   * @return {Promise} - JSON cart
   */
  ShopifyAPI.getCart = function () {
    return $.getJSON('/cart.js');
  };

  /**
   * Retrieve a JSON respresentation of the users cart
   *
   * @return {Promise} - JSON cart
   */
  ShopifyAPI.getProduct = function (handle) {
    var json = [];

    $.getJSON('/products/' + handle + '.js', function () {

    }).done(function (data) {
      if (data != 'undefined' && data != undefined) {
        json.push(data);
      }
    }).fail(function (jqxhr, textStatus, error) {
      var err = textStatus + ", " + error;
      console.log("Request Failed for: /products/" + handle + ".js, " + err);
    });

    return json;
  };

  /**
   * Change the quantity of an item in the users cart
   *
   * @param {int} variantId - Variant to be adjust
   * @param {int} qty - New quantity of the variant
   * @return {Promise} - JSON cart
   */
  ShopifyAPI.changeItemQuantity = function (variantId, qty) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + variantId,
      dataType: 'json'
    });
  };

  /*============================================================================
    Cart Providers
  ==============================================================================*/

  /*
   * Cart providers must implement the following interface (functions + function signatures)
   */

  /**
   * Gets the JSON representation of the cart
   * Promise will either resolve with JSON cart or reject with an error message
   *
   * @return {$.Deferred} promise
   *   
   * this.getCart = function() { .. }
   */

  /**
   * Adds a variant to the cart with the requested quantity
   *
   * @return {$.Deferred} promise
   *   
   * this.addItem = function(variantId, quantity) { .. }
   */

  /**
   * Changes the quantity of a variant already in the cart
   *
   * @return {$.Deferred} promise
   *   
   * this.changeItemQuantity = function(variantId, quantity) { .. }  
   */

  // SHOPIFY
  function ShopifyCartProvider() {

    this.getCart = function () {
      return ShopifyAPI.getCart();
    };
    this.addItem = function (variantId, quantity, properties) {
      return ShopifyAPI.addItem(variantId, quantity, properties);
    };

    this.changeItemQuantity = function (variantId, quantity) {
      return ShopifyAPI.changeItemQuantity(variantId, quantity);
    }
  };

  // FLOW
  function FlowCartProvider() {

    this.getCart = function () {

      var promise = $.Deferred();

      Flow.cart.getCart({
        success: function (status, cart) {
          promise.resolve(cart);
        },
        error: function (status, error) {
          promise.reject({
            message: error.messages[0]
          });
        }
      });

      return promise;
    };

    this.addItem = function (variantId, quantity, properties) {
      var promise = $.Deferred();

      Flow.cart.addItem(variantId, quantity, {}, {
        success: function (status, cart) {
          promise.resolve(cart);
        },
        error: function (status, error) {
          promise.reject({
            message: error.messages[0]
          });
        }
      });

      return promise;
    };

    this.changeItemQuantity = function (variantId, quantity) {
      var promise = $.Deferred();

      Flow.cart.updateItem(variantId, quantity, {}, {
        success: function (status, cart) {
          promise.resolve(cart);
        },
        error: function (status, error) {
          promise.reject({
            message: error.messages[0]
          });
        }
      });

      return promise;
    };
  };

  /*============================================================================
    Ajax Shopify Add To Cart
  ==============================================================================*/
  slate.AjaxCart = (function () {

    var $window = $(window);
    var $body = $('body');

    var selectors = {
      layoutWrapper: '.layout-wrapper',
      container: '[data-ajax-cart-container]',
      template: 'script[data-ajax-cart-template]',
      trigger: '[data-ajax-cart-trigger]',
      close: '[data-ajax-cart-close]',
      addForm: 'form[action^="/cart/add"]',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      header: '[data-ajax-cart-header]',
      body: '[data-ajax-cart-body]',
      footer: '[data-ajax-cart-footer]',
      scrollList: '[data-ajax-cart-scroll-list]',
      itemList: '[data-ajax-cart-item-list]',
      item: '[data-ajax-item][data-id][data-qty]',
      itemRemove: '[data-ajax-cart-item-remove]',
      itemAdd: '[data-ajax-cart-item-add]',
      upsellItemId: '[data-upsell-product-id]',
      upsellItemDisplay: '[data-ajax-cart-upsell-item]',
      upsellItemError: '[data-ajax-cart-upsell-item-error]',
      upsellItemSizeSelect: '[data-ajax-cart-upsell-item-size-select]',
      cartBadge: '[data-cart-badge]',
      cartBadgeCount: '[data-cart-badge-count]',
      cartPageLink: '[data-ajax-cart-cart-page-link]', // "View Cart" button link
      freeShippingThreshold: '[data-free-shipping-threshold]',
      freeShippingSuccessMessage: '[data-free-shipping-success]'
    };

    var classes = {
      bodyCartOpen: 'ajax-cart-open',
      backdrop: 'AjaxCart-backdrop',
      backdropVisible: 'is-visible',
      cartOpen: 'is-open',
      cartHasOverflow: 'has-overflow',
      cartScrollTop: 'is-at-top',
      cartScrollBottom: 'is-at-bottom',
      cartBadgeHasItems: 'has-items',
      hideUpsell: 'hide-upsell',
      rowBeingRemoved: 'is-being-removed',
      upsellItemHidden: 'is-hidden'
    };

    var data = {
      giftPackageProductId: 'package-product-id',
      giftMessageProductId: 'message-product-id'
    };

    var cartContainer = document.querySelector(selectors.container);
    var FOCUSABLE_ELEMENT_SELECTORS = '.AjaxCart-container a[href], .AjaxCart-container area[href], .AjaxCart-container input:not([disabled]), .AjaxCart-container select:not([disabled]), .AjaxCart-container textarea:not([disabled]), .AjaxCart-container button:not([disabled]), .AjaxCart-container iframe, .AjaxCart-container object, .AjaxCart-container [tabindex="0"], .AjaxCart-container [contenteditable]';
    var KEY_CODE_MAP = {
      TAB: 9,
      ESC: 27
    };
    var firstFocusEl, lastFocusEl, focusableElements;
    // var FOCUSABLE_ELEMENT_SELECTORS = '.AjaxCart-container a[href]:hidden';

    /**
     * AjaxCart constructor
     *
     * Adds an `init` method with access to private variables inside the contructor
     */
    function AjaxCart() {

      this.name = 'ajaxCart'
      this.namespace = '.' + this.name;
      this.events = {
        RENDER: 'render' + this.namespace,
        DESTROY: 'destroy' + this.namespace,
        SCROLL: 'scroll' + this.namespace,
        REFRESH: 'refresh' + this.namespace
      };

      // Cache products here as we fetch them via ajax so we can make less successive requests
      this.productStore = {};

      var _this = this;
      var initialized = false;
      var settings = {
        disableAjaxCart: false
      };

      this.$el = $(selectors.container);
      this.$backdrop = null;
      this.stateIsOpen = null;
      this.transitionEndEvent = slate.utils.whichTransitionEnd();
      this.cartProvider = new ShopifyCartProvider();

      // Store boolean to determine if flow experience is enabled
      this.flowExperience = false;

      if (Flow) {
        Flow.set('on', 'ready', function () {
          _this.flowExperience = Flow.getExperience();

          if (_this.flowExperience) {
            _this.cartProvider = new FlowCartProvider(); // Flow.io integration means we need to use their cart for intl users instead of the shopify one
            _this._fetchAndBuild(); // Since we changed cart providers, we need to re-render the cart state            
          }

        });
      }

      /**
       * Initialize the cart
       *
       * @param {object} options - see `settings` variable above
       */
      this.init = function (options) {
        if (initialized) return;

        this.settings = $.extend(settings, options);

        if (!$(selectors.template).length) {
          console.warn('[' + this.name + '] - Handlebars template required to initialize AjaxCart');
          return;
        }

        // Compile this once during initialization
        this.template = Handlebars.compile($(selectors.template).html());

        // Add the AJAX part
        if (!this.settings.disableAjaxCart) {
          this._formOverride();
        }

        // Add event handlers here
        $body.on('click', selectors.trigger, this.onTriggerClick.bind(this));
        $body.on('click', selectors.close, this.onCloseClick.bind(this));
        $body.on('click', selectors.itemRemove, this.onItemRemoveClick.bind(this));
        $body.on('click', selectors.itemAdd, this.onItemAddClick.bind(this));
        $body.on('click', selectors.cartPageLink, this.onCartPageLinkClick.bind(this));
        $body.on('change', selectors.upsellItemSizeSelect, this.onUpsellItemSizeSelect.bind(this));
        $window.on(this.events.RENDER, this.onCartRender.bind(this));
        $window.on(this.events.DESTROY, this.onCartDestroy.bind(this));
        $window.on(this.events.REFRESH, this._fetchAndBuild.bind(this));
        $window.on('resize', $.throttle(60, this.onResize.bind(this)));

        this._fetchAndBuild();

        initialized = true;

        return initialized;
      };

      return this;
    }

    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

      /**
       * Call this function to AJAX-ify any add to cart forms on the page
       */
      _formOverride: function () {
        var _this = this;

        $body.on('submit', selectors.addForm, function (e) {
          e.preventDefault();

          var $form = $(e.target);
          var $submitButton = $form.find(selectors.addToCart);
          var $submitButtonText = $submitButton.find(selectors.addToCartText);
          var $variantId = $form.find('[name="id"]').val();
          var $qty = parseInt($form.find('[name="quantity"]').val());
          var $properties = {};

          $form.find('[name^="properties"]').each(function (i, element) {
            if (element.value != "") {
              var name = element.name.substr(element.name.indexOf('['));
              name = name.replace("[", "").replace("]", "");
              $properties[name] = element.value;
            }
          });

          //save button text before adding to cart so we can put it back after adding to cart
          var $addToCartButtonText = $submitButton.find(selectors.addToCartText).text();

          // Update the submit button text and disable the button so the user knows the form is being submitted
          $submitButton.prop('disabled', true);
          $submitButtonText.html(theme.strings.adding);
          _this.cartProvider.addItem($variantId, $qty, $properties)
            .then(function (cart) {
              return new Promise(function (resolve) {
                slate.utils.sendDataToKlaviyo(cart);
                slate.utils.sendDataToFacebook(cart, $variantId);
                resolve(cart);
              });
            })
            .then(function (cart) {
              // Reset button state
              $submitButton.prop('disabled', false);
              //$submitButtonText.html(theme.strings.addToCart);
              $submitButtonText.text($addToCartButtonText);
              _this.onItemAddSuccess.call(_this, cart);
            })
            .fail(function (data) {
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              _this.onItemAddFail.call(_this, data);
            });
        });
      },

      /**
       * Fetches cart data, product data and then calls 'buildCart'.
       * Used on initialization and when we changecartProviders
       */
      _fetchAndBuild: function () {
        this.cartProvider.getCart().then(this._getCartTemplateData.bind(this)).then(this.buildCart.bind(this));
      },

      /**
       * Gets data necessary to build the cart HTML.
       * Not only do we need the JSON cart, we need the JSON for all products in the cart too.
       * Check the productStore instance variable first, and then fetch JSON for each product that doesn't exist in the store
       *
       * @param {Object} cart - JSON representation of the cart.
       * @return {$.Deferred} promise
       */
      _getCartTemplateData: function (cart) {

        var _this = this;
        var promise = $.Deferred();
        var requests = [];
        var templateData = {
          cart: cart,
          products: []
        };

        for (var i = cart.items.length - 1; i >= 0; i--) {
          if (!_this.productStore.hasOwnProperty(cart.items[i].product_id)) {
            requests.push(ShopifyAPI.getProduct(cart.items[i].handle));
          }
        };

        $.when.apply($, requests).then(function (resp) {

          var products = arguments;

          // If we make one request, we get returned an array of plain objects
          // If we make more than one request, we get returned an array of arrays (of plain objects)
          // We have an array of arrays
          if ($.isArray(arguments[0])) {
            products = $.map(arguments, function (arg) { return arg[0]; });
          }

          // Update our product store with any products that don't already exist in there
          if (products && products.length) {
            for (var i = products.length - 1; i >= 0; i--) {
              var p = products[i];
              _this.productStore[p.id] = p;
            }
          }

          templateData.products = _this.productStore;
          promise.resolve(templateData);
        });

        return promise;
      },

      /**
       * Ensure we are working with a valid number
       *
       * @param {int|string} qty
       * @return {int} - Integer quantity.  Defaults to 1
       */
      _validateQty: function (qty) {
        return (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ? qty : 1;
      },

      _getItemRowAttributes: function (el) {
        var $el = $(el);
        var $row = $el.is(selectors.item) ? $el : $el.parents(selectors.item);

        return {
          $row: $row,
          id: $row.data('id'),
          qty: this._validateQty($row.data('qty'))
        };
      },

      addBackdrop: function (callback) {

        var _this = this;
        var cb = callback || $.noop;

        if (this.stateIsOpen) {
          this.$backdrop = $(document.createElement('div'));

          this.$backdrop.addClass(classes.backdrop)
            .appendTo($body);

          this.$backdrop.one(this.transitionEndEvent, cb);
          this.$backdrop.one('click', this.close.bind(this))

          // debug this...
          setTimeout(function () {
            _this.$backdrop.addClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

      removeBackdrop: function (callback) {

        var _this = this;
        var cb = callback || $.noop;

        if (!this.stateIsOpen && this.$backdrop) {
          this.$backdrop.one(this.transitionEndEvent, function () {
            _this.$backdrop && _this.$backdrop.remove()
            _this.$backdrop = null;
            cb();
          });

          setTimeout(function () {
            _this.$backdrop.removeClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

      /**
       * Ajax cart takes up the full window height.
       * Let the header and footer be as big as they need to be and set the ajaxCart-body height to the remainer
       *
       */
      cartOverflowCheck: function () {
        var windowHeight = $window.height();
        var headerHeight = $(selectors.header).outerHeight();
        var footerHeight = $(selectors.footer).outerHeight();
        var remainder = windowHeight - headerHeight - footerHeight;
        $(selectors.body).css('height', remainder);
        var $scrollList = $(selectors.scrollList);

        if (!$scrollList.length) {
          return;
        }

        if ($scrollList.get(0).scrollHeight > $scrollList.height()) {
          $scrollList.addClass(classes.cartHasOverflow);
        }
        else {
          $scrollList.removeClass(classes.cartHasOverflow);
        }
      },

      /**
        * Check to see if the upsell item should be shown
        *
        */
      upsellCheck: function () {
        var ajaxCart = $(selectors.upsellItemId);
        var $upsellItemId = ajaxCart.data('upsell-product-id');
        if ($upsellItemId != '') {
          this.cartProvider.getCart().then(this._getCartTemplateData.bind(this));
        }
      },


      /**
       * Callback when adding an item is successful
       *
       * @param {Object} cart - JSON representation of the cart.
       */
      onItemAddSuccess: function (cart) {

        this._getCartTemplateData(cart).then(function (data) {
          this.buildCart(data);
          this.open();
        }.bind(this));
      },

      /**
       * STUB - Callback when adding an item fails
 
       * @param {Object} data
       * @param {string} data.message - error message
       */
      onItemAddFail: function (data) {
        console.log('[' + this.name + '] - onItemAddFail');
        console.warn('[' + this.name + '] - ' + data.message);
      },

      /**
      * Callback for when the cart HTML is rendered to the page
      * Allows us to add event handlers for events that don't bubble
      */
      onCartRender: function (e) {
        var $scrollList = $(selectors.scrollList);

        $scrollList.on(this.events.SCROLL, $.throttle(250, this.onCartListScroll.bind(this, $scrollList)));
        this.cartOverflowCheck();
        this.onCartListScroll($scrollList);

        this.upsellCheck();
      },

      /**
       * Callback for when the cart HTML is removed from the page
       * Allows us to do cleanup on any event handlers applied post-render
       */
      onCartDestroy: function (e) {
        $(selectors.cartScrollList).off(this.events.SCROLL);
      },

      /**
       * Builds the HTML for the ajax cart.
       * Modifies the JSON cart for consumption by our handlebars template
       *
       * @param {object} cartTemplateData
       * @param {object} cartTemplateData.cart - JSON representation of the cart.  See https://help.shopify.com/themes/development/getting-started/using-ajax-api#get-cart
       * @param {object} cartTemplateData.products - Plain object of product JSON values, keyed with the product ID.
       * @return ??
       */
      buildCart: function (cartTemplateData) {
        var _this = this;
        var cart = cartTemplateData.cart;
        var products = cartTemplateData.products;

        // Make adjustments to the cart object contents before we pass it off to the handlebars template
        if (this.flowExperience && cart.hasOwnProperty('local')) {
          cart.total_price = cart.local.total_price.label;
        }
        else {
          cart.total_price = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);
        }

        // IDs to add aditional property for gift message or gift package products to disable click-through URLs from the cart
        var giftPackageProductId = _this.$el.data(data.giftPackageProductId);
        var giftMessageProductId = _this.$el.data(data.giftMessageProductId)
        cart.items.map(function (item) {
          if (item.product_id === giftPackageProductId || item.product_id === giftMessageProductId) {
            item.disableClickThrough = true;
          }

          // Flow returns the formatted price as the "label" property
          // Due to async nature of flow object, need to check for the properties that we need to use
          if (_this.flowExperience && item.hasOwnProperty('local')) {
            item.price = item.local.line_price.label;
          }
          else {
            item.price = slate.Currency.formatMoney(item.price, theme.moneyFormat);
          }

          if (item.image && !slate.Image.imageSize(item.image)) { // We have the OG image, need to rescale it.  Would be better to remove the image size defined in the url and *then* call slate.Image.getSizedImageUrl but I don't have time
            item.image = slate.Image.getSizedImageUrl(item.image, '200x');
          }

          if (item.properties) {
            item.propertiesArray = Object.keys(item.properties).map(function (k) {
              return {
                key: k, value: item.properties[k]
              }
            });
          }

          // Adjust the item's variant options to add "name" and "value" properties
          // Otherwise we have to use the variant title which is just "{ Product Title } - { option1 } / { option2 } / { option3 }" which is trash
          if (products.hasOwnProperty(item.product_id)) {
            var product = products[item.product_id];

            // This is pretty messy, but a quick way to check if a product has variant options
            // If it doesn't, Shopify makes a single variant with "Title" -> "Default Title" under the hood
            if (product.variants[0].option1 != "Default Title") {
              if (item.hasOwnProperty('variant_options')) {
                for (var i = item.variant_options.length - 1; i >= 0; i--) {
                  var value = item.variant_options[i];
                  item.variant_options[i] = {
                    name: product.options[i].name,
                    value: value
                  }
                }
              }
              else {
                // Item is getting returned by flow, which doesn't attach variant_options :_(
                // We have to do it manually by looking at the product level, finding the item among the product's variants and then setting the variant_options based on that
                for (var j = product.variants.length - 1; j >= 0; j--) {
                  var variant = product.variants[j];
                  if (variant.id == item.variant_id) {
                    item.variant_options = [];
                    for (var k = product.options.length - 1; k >= 0; k--) {
                      var productOption = product.options[k];
                      item.variant_options[k] = {
                        name: productOption.name,
                        value: variant.options[k]
                      }
                    }
                  }
                }
              }
            }
            else {
              // No variant options, so kill the defaults
              item.variant_options = [];
            }
          }
          return item;
        });

        Promise.all(cart.items.map(function (item) {
          return new Promise(function (resolve, reject) {
            $.getJSON('/products/' + item.handle + '.js', { _: Date.now() })
              .then(function (currProduct) {
                var currVariant = currProduct.variants.filter(function (v) {
                  return v.id == item.variant_id;
                })[0];

                if (currVariant && currVariant.compare_at_price > currVariant.price) {
                  if (_this.flowExperience) {
                    item.compare_at_price = Flow.cache.localizedVariants.getByIdAndExperience(currVariant.id, Flow.getExperience()).prices.compare_at.label;
                  }
                  else {
                    item.compare_at_price = slate.Currency.formatMoney(currVariant.compare_at_price, theme.moneyFormat)
                  }
                  resolve(currVariant.compare_at_price);
                }
                else if (!currVariant) {
                  reject(new Error("variant not found!"));
                } else {
                  resolve(0);
                }
              });
          })
        })).then(function () {
          $(selectors.container).empty().append(_this.template(cart));
          _this.getFocusableEls();
        });

        $window.trigger(this.events.DESTROY);
        $(selectors.container).empty().append(this.template(cart));
        $window.trigger(this.events.RENDER);

        this.updateCartCount(cart);

        // Update free shipping calculator if it is enabled 
        var ajaxCart = $(selectors.freeShippingThreshold);
        var freeShippingThreshold = ajaxCart.data('free-shipping-threshold');
        var freeShippingSuccessMessage = ajaxCart.data('free-shipping-success');

        $.getJSON('/cart.js', function (cart) {
          let cartTotal = cart.total_price;
          var freeShippingValueLeft = freeShippingThreshold - cartTotal;
          if (freeShippingValueLeft > 0) {
            var remainingAmountMessage = "You are " + slate.Currency.formatMoney(freeShippingValueLeft, theme.moneyFormat) + " away from free shipping!";
            $('#shopify-section-ajax-cart #freeShippingCalculator span').html(remainingAmountMessage);
          } else {
            $('#shopify-section-ajax-cart #freeShippingCalculator span').html(freeShippingSuccessMessage);
          }
        });

      },
      keyboardHandler: function (e) {
        if (e.keyCode === KEY_CODE_MAP.TAB) {
          if (e.shiftKey && document.activeElement === firstFocusEl) {
            e.preventDefault();
            lastFocusEl.focus();
          } else if (!e.shiftKey && document.activeElement === lastFocusEl) {
            e.preventDefault();
            firstFocusEl.focus();
          }
        } else if (e.keyCode === KEY_CODE_MAP.ESC) {
          this.close();
        }
      },


      updateCartCount: function (cart) {
        var $badge = $(selectors.cartBadge);
        var $count = $(selectors.cartBadgeCount);

        $count.html(cart.item_count);

        if (cart.item_count) {
          $badge.addClass(classes.cartBadgeHasItems);
        }
        else {
          $badge.removeClass(classes.cartBadgeHasItems);
        }
      },

      /**
       * Called when the list is scrolled, checks scroll progress and adds / removes necessary classes for visual effects
       * Allow us to pass in the $list variable as an argumnent to avoid doing DOM lookups everytime we call this function
       */
      onCartListScroll: function ($list) {
        if (!$list) {
          $list = $(selectors.scrollList);
        }

        if (!$list.length) {
          return
        }

        var scrollThreshold = 8; // px distance to determine 'at-top' or 'at-bottom'
        var scrollHeight = $list.get(0).scrollHeight;
        var outerHeight = $list.outerHeight();
        var scrollTop = $list.scrollTop();
        var scrollBottom = Math.round(scrollHeight - (outerHeight + scrollTop));

        window.requestAnimationFrame(function () {
          if (scrollTop < scrollThreshold) {
            $list.addClass(classes.cartScrollTop);
          }
          else {
            $list.removeClass(classes.cartScrollTop);
          }

          if (scrollBottom < scrollThreshold) {
            $list.addClass(classes.cartScrollBottom);
          }
          else {
            $list.removeClass(classes.cartScrollBottom);
          }
        });

      },

      onResize: function () {
        if (this.stateIsOpen) {
          this.cartOverflowCheck();
          this.onCartListScroll();
        }
      },

      /**
       * Remove the item from the cart.  Extract this into a separate method if there becomes more ways to delete an item
       *
       * @param {event} e - Click event
       */
      onItemRemoveClick: function (e) {
        e.preventDefault();

        var attrs = this._getItemRowAttributes(e.target);
        attrs.$row.addClass(classes.rowBeingRemoved);

        this.cartProvider.changeItemQuantity(attrs.id, 0)
          .then(function (cart) {
            return new Promise(function (resolve) {
              slate.utils.sendDataToKlaviyo(cart);
              resolve(cart);
            })
          })
          .then(this._getCartTemplateData.bind(this))
          .then(this.buildCart.bind(this));
      },

      /**
        * Add the upsell item to the cart. 
        *
        * @param {event} e - Click event
        */
      onItemAddClick: function (e) {
        e.preventDefault();
        var attrs = this._getItemRowAttributes(e.target);
        var variantId = document.getElementById('AddUpsellSize').value;
        var productTitle = $('.AjaxCart__upsell-item .AjaxCart-itemTitle a').text();

        if (variantId == '') {
          $('[data-ajax-cart-upsell-item-error]').removeClass('is-hidden');
          $('#AddUpsellSize').addClass('has-error');
        } else {
          ga('send', 'event', { eventCategory: 'Add to cart upsell', eventAction: 'Add to cart upsell', eventLabel: productTitle });
          $('[data-ajax-cart-upsell-item]').addClass(classes.upsellItemHidden);

          this.cartProvider.addItem(variantId, 1)
            .then(function (cart) {
              return new Promise(function (resolve) {
                slate.utils.sendDataToKlaviyo(cart);
                slate.utils.sendDataToFacebook(cart, variantId);
                resolve(cart);
              })
            })
            .then(this._getCartTemplateData.bind(this))
            .then(this.buildCart.bind(this));

          $('[data-ajax-cart-upsell-item]').addClass(classes.upsellItemHidden);
          $('body').addClass(classes.hideUpsell);
        }
      },

      /**
        * Check the value of the upsell size select 
        *
        * @param {event} e - Click event
        */
      onUpsellItemSizeSelect: function () {
        var variantId = document.getElementById('AddUpsellSize').value;
        if (variantId == '') {
          $('[data-ajax-cart-upsell-item-error]').removeClass('is-hidden');
          $('#AddUpsellSize').addClass('has-error');
        } else {
          $('[data-ajax-cart-upsell-item-error]').addClass('is-hidden');
          $('#AddUpsellSize').removeClass('has-error');
        }
      },

      /**
       * Handles click on "View Cart" button.  We redirect to flow.io checkout if necessary
       *
       * @param {event} e - Click event
       */
      onCartPageLinkClick: function (e) {
        if (this.flowExperience) {
          e.preventDefault();
          Flow.cart.redirectToCart();
        }
      },

      /**
       * Click the 'ajaxCart - trigger' selector
       *
       * @param {event} e - Click event
       */
      onTriggerClick: function (e) {
        e.preventDefault();
        $(selectors.layoutWrapper).attr('aria-hidden', true);
        $(selectors.container).attr('aria-hidden', false);
        this.toggleVisibility();


      },

      /**
       * Click the 'ajaxCart - close' selector
       *
       * @param {event} e - Click event
       */
      onCloseClick: function (e) {
        e.preventDefault();
        var urlPathname = window.location.pathname;
        // Do any cleanup before closing the cart
        this.close();
        $(selectors.trigger).focus();

        //reolad cart page if someone adds item from the product recommendation via quick add
        //this is to update the cart page with the newly added product
        if (urlPathname.length && urlPathname == "/cart") {
          window.location.reload();
        }
      },

      /**
       * Opens / closes the cart depending on state
       *
       */
      toggleVisibility: function () {
        return this.stateIsOpen ? this.close() : this.open();
      },

      /**
       * Check the open / closed state of the cart
       *
       * @return {bool}
       */
      isOpen: function () {
        return this.stateIsOpen;
      },

      /**
       * Returns true is the cart is closed.
       *
       * @return {bool}
       */
      isClosed: function () {
        return !this.stateIsOpen;
      },

      /**
       * Code for opening the cart
       */
      open: function (e) {
        if (this.stateIsOpen) return;
        this.stateIsOpen = true;
        $(selectors.layoutWrapper).attr('aria-hidden', true);
        $(selectors.container).attr('aria-hidden', false);

        $body.addClass(classes.bodyCartOpen);
        this.$el.addClass(classes.cartOpen);
        this.addBackdrop();
        this.cartOverflowCheck();
        this.getFocusableEls();
        cartContainer.addEventListener('keydown', this.keyboardHandler.bind(this));


      },
      getFocusableEls: function () {
        // When we open 
        focusableElements = $(FOCUSABLE_ELEMENT_SELECTORS);
        focusableElements.each(function () {
          if ($(this).is(':hidden')) {
            focusableElements.splice($.inArray(this, focusableElements), 1);
          }
        })
        if (focusableElements.length > 0) {
          firstFocusEl = focusableElements[0],
            lastFocusEl = focusableElements[(focusableElements.length - 1)];
        }
        firstFocusEl.focus();

      },

      /**
       * Code for closing the cart
       */
      close: function (e) {
        if (!this.stateIsOpen) return;
        this.stateIsOpen = false;

        this.$el.removeClass(classes.cartOpen);
        this.removeBackdrop(function () {
          $body.removeClass(classes.bodyCartOpen);
        });
        $(selectors.layoutWrapper).attr('aria-hidden', false);
        $(selectors.container).attr('aria-hidden', true);
        cartContainer.removeEventListener('keydown', this.keyboardHandler.bind(this));
      }
    });

    return AjaxCart;
  })();

})(jQuery, Handlebars, slate);
/**
 * AJAX Klaviyo Library
 * -----------------------------------------------------------------------------
 * Handles AJAX form submission and callback event
 *
 * @namespace ajaxKlaviyo
 */


slate.AjaxKlaviyoForm = (function($) {

 /**
  * AJAX Klaviyo Form Contrustor
  *
  * @param {HTMLElement | jQuery} form - Form element
  * @param {Object} options
  * @param {String} options.listId - Klaviyo List ID
  * @param {String} options.source - Klaviyo custom $source property
  * @param {Function} options.onInit
  * @param {Function} options.onBeforeSend
  * @param {Function} options.onSubmitFail  
  * @param {Function} options.onSubscribeSuccess
  * @param {Function} options.onSubscribeFail
  * @return {self}
  */
  function AjaxKlaviyoForm(form, options) {

    this.name = 'ajaxKlaviyoForm'
    this.namespace = '.' + this.name;
    this.events = {
      SUBMIT: 'submit' + this.namespace
    };

    var _this = this;
    var defaults = {
      source: "Shopify Form",
      onInit: $.noop,
      onBeforeSend: $.noop,
      onSubmitFail: $.noop,
      onSubscribeSuccess: $.noop,
      onSubscribeFail: $.noop
    };

    if (form.length === 0) {
      return false;
    }

    this.$form    = form instanceof jQuery ? form : $(form);
    this.$input   = this.$form.find('input[type="email"]');
    this.$segment   = this.$form.find('input[type="radio"]');
    this.$submit  = this.$form.find('[type="submit"]');
    this.settings = $.extend({}, defaults, options);

    if(!this.settings.listId) {
      console.warn('['+this.name+'] - Valid Klaviyo List ID required to initialize');
      return;
    }

    this.$form.on(this.events.SUBMIT, this.onFormSubmit.bind(_this));

    this.settings.onInit();

    return this;
  };

  AjaxKlaviyoForm.prototype = $.extend({}, AjaxKlaviyoForm.prototype, {
    onBeforeSend: function() {
      
      if(this.settings.onBeforeSend() == false) {
        return false;
      }

      if (this.$input.val() && this.$input.val().length && ($(this.$segment).is(":checked"))) {
        this.$submit.prop('disabled', true);
        return true;
      } else {
        this.$input.parents('.form-group').addClass('alert-info');
      }

      return false;
    },
    onSubmitDone: function(response) {

      this.$submit.prop('disabled', false);

      if(response.success) {
        this.settings.onSubscribeSuccess();
      }
      else {
        this.settings.onSubscribeFail();
      }
    },
    onSubmitFail: function(errors) {

      this.$submit.prop('disabled', false);

      if(errors instanceof Array && errors.length) {
        for (var i = errors.length - 1; i >= 0; i--) {
          console.warn('['+this.name+'] - onSubmitFail error: "' + errors[i] + '"');
        }
      }
      this.settings.onSubmitFail();
    },
    onFormSubmit: function(e) {    
      e.preventDefault();
      var _this = this;
      
      $.ajax({
          async: true,
          crossDomain: true,
          url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
          method: "POST",
          headers: {
              "content-type": "application/x-www-form-urlencoded",
              "cache-control": "no-cache"
          },
          data: {
              "g": this.settings.listId,
              "$fields": "$source,$list_segment",
              "email": this.$input.val(),
              "$source": this.settings.source,
              "$list_segment": $(this.$segment).filter(":checked").val()
          },
          beforeSend: _this.onBeforeSend.bind(_this)
        })
        .done(function(response) {
          _this.onSubmitDone(response);
        })
        .fail(function(jqXHR, textStatus) {        
          var errors = [];
          if(jqXHR.responseJSON.hasOwnProperty('errors')) {
            errors = jqXHR.responseJSON.errors;
          }

          _this.onSubmitFail(errors);
        });

      return false;
    }
  });

  return AjaxKlaviyoForm;
})(jQuery)
/**
 * Slideshows
 * ------------------------------------------------------------------------------
 *
 * Dependencies
 *  - slick.min.js
 *
 * @namespace - slideshow
*/

slate.Slideshow = (function($, Modernizr) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slideshow: '[data-slideshow]',
    slide: '[data-slideshow-slide]',
    pauseToggle: '[data-slideshow-pause-toggle]'
  };

  var KEYS = {
    left: 37,
    right: 39
  };

 /**
  * Slideshow constructor
  *
  * @param {HTMLElement | $} el - The actual slideshow or slideshow wrapper
  * @param {Object} options - Options passed into the slider initialize function
  */
  function Slideshow(el, options) {

    var $el = $(el);

    this.$wrapper   = $el.is(selectors.slideshowWrapper) ? $el : $el.closest(selectors.slideShowWrapper);
    this.$slideshow = this.$wrapper.find(selectors.slideshow);

    var settings = {
      accessibility: false, // prevents page from jumping on focus
      arrows: !Modernizr.touchevents,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      slidesToShow: this.$slideshow.data('slides-to-show') || 1,
      slidesToScroll: this.$slideshow.data('slides-to-scroll') || 1,
      autoplay: this.$slideshow.data('autoplay') || false,
      autoplaySpeed: this.$slideshow.data('speed') || 5000,
      prevArrow: '<a href="#" class="arrow arrow--left arrow--transparent" aria-label="Previous slide"><span class="arrow__icon"></span></a>',
      nextArrow: '<a href="#" class="arrow arrow--right arrow--transparent" aria-label="Next slide"><span class="arrow__icon"></span></a>'
    };

    this.settings = $.extend({}, settings, options);

    this.$wrapper.on('click', selectors.pauseToggle, this.onPauseToggleClick.bind(this));    
    this.$slideshow.on('init', this.slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);
  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
   /**
    * Adds events to the slideshow for improved accessibility
    *
    * @param {Event} evt - window event w/ type "init"
    * @param {Object} slick
    */
    slideshowA11y: function(evt, slick) {
      var self     = this;
      var $list    = slick.$list;
      var $dots    = slick.$dots;
      var $wrapper = this.$wrapper;
      var autoplay = this.settings.autoplay;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live.
      $wrapper.on('focusin', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');

        if (autoplay) {
          self.pause();
        }
      });

      // Resume autoplay
      $wrapper.on('focusout', function(evt) {
        if (!$wrapper.has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');

        if (autoplay) {
          self.play();
        }
      });

      // Add arrow key support when focused
      if ($dots) {
        $dots.on('keydown', function(evt) {
          if (evt.which === KEYS.left) {
            self.prev();
          }

          if (evt.which === KEYS.right) {
            self.next();
          }

          // Update focus on newly selected tab
          if ((evt.which === KEYS.left) || (evt.which === KEYS.right)) {
            $dots.find('.slick-active button').focus();
          }
        });
      }
    },

    next: function() {
      this.$slideshow.slick('slickNext');
    },

    prev: function() {
      this.$slideshow.slick('slickPrev');
    },

    pause: function() {
      this.$slideshow.slick('slickPause');
    },

    play: function() {
      this.$slideshow.slick('slickPlay');
    },

    unpause: function() {
      if(this.settings.autoplay) {
        this.play();
      }
    },

    togglePause: function() {
      var slick = this.$slideshow.slick('getSlick');

      if(this.settings.autoplay){
        if(slick.paused){
          this.unpause();
        }
        else {
          this.pause();
        }
      }
    },

   /**
    * Finds and displays a slide associated with the blockId passed in.
    * Note:  Block IDs are not required on slides for the slideshow to work
    *        If used, the element matching `selectors.slide` must have a data-block-id attribute
    *
    * @param {string} blockId
    */
    goToSlideByBlockId: function(blockId) {
      var $slide = $(selectors.slide, this.$slideshow).filter('[data-block-id="' + blockId + '"]:not(.slick-cloned)');

      this.$slideshow.slick('slickGoTo', $slide.data('slick-index') );
    },

    onPauseToggleClick: function(evt) {
      evt.preventDefault();
      this.togglePause();
    }
  });

  return Slideshow;
}(jQuery, Modernizr));

/**
 * Animation Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with animations in javascript
 *
 */

slate.animations = (function($) {

  // First add some extra easing equations
  // To add more see the full library - https://github.com/danro/jquery-easing/blob/master/jquery.easing.js
  $.extend( $.easing, {
    // t: current time, b: begInnIng value, c: change In value, d: duration
    easeInQuint: function (x, t, b, c, d) {
      return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
      return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
      if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
      return c/2*((t-=2)*t*t*t*t + 2) + b;
    }
  });

  // Match those set in variables.scss
  var _transitionTimingDurations = {
    base:     300,
    fast:     150,
    fastest:  50,
    slow:     600,
    none:     0
  };

  var _transitionTimingFunctions = {
    base:      'ease-in-out',
    in:        'ease-out',
    out:       'ease-in',
    inOutUI:   'cubic-bezier(0.42, 0, 0.13, 1.04)'
  };

 /**
  * Get one of the durations stored in the variable defined above
  * If the requested duration doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - duration in ms
  */
  function getTransitionTimingDuration(key) {
    var k = 'base';
    if(_transitionTimingDurations.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingDurations[k];
  };

 /**
  * Get one of the timing functions stored in the variable defined above
  * If the requested function doesn't exist, fallback to the base
  *
  * @param {string} key - string matching one of the key names
  * @return {string} - valid css timing function
  */
  function getTransitionTimingFunction(key) {
    var k = 'base';
    if(_transitionTimingFunctions.hasOwnProperty(key)) {
      k = key;
    }
    return _transitionTimingFunctions[k];
  };  

  return {
    getTransitionTimingDuration: getTransitionTimingDuration,
    getTransitionTimingFunction: getTransitionTimingFunction
  };

}(jQuery));
/**
 * User Scripts
 * -----------------------------------------------------------------------------
 * Mostly handles cookie setting / removal, logic around user sessions
 */

slate.user = (function(Cookies) {

  var cookiePrefix = '_ok_';

 /**
  * User constructor
  */
  function User() {
    this.name = 'user'
    this.namespace = '.' + this.name;

    // Do any initialization here
    // For instance, you could increment a cookie that tracks visits to the site

    return this;
  };

  User.prototype = $.extend({}, User.prototype, {

   /**
    * Library of cookies to use throughout the site.
    * Use the `createCookie` method below to create your own copies of these.  Don't access these directly.
    */
    _cookies: {
      subscriptionSlideUp2Seen: {
        name: cookiePrefix + 'subscriptionSlideUp2_seen',
        value: true
      },      
      subscriptionSlideUpSeen: {
        name: cookiePrefix + 'subscriptionSlideUp_seen',
        value: true
      },
      emailCollected: {
        name: cookiePrefix + 'emailCollected',
        value: true
      },
      canAccessSurfRanchPrivateSale: {
        name: cookiePrefix + 'canAccessPrivateSale',
        value: true
      }      
    },

   /**
    * Creates and returns a copy of one of the cookies available above
    *
    * @param {String} key
    * @return {Object | undefined}
    */
    createCookie: function(key) {
      if(this._cookies.hasOwnProperty(key)) {
        return $.extend(true, {}, this._cookies[key]);
      }
    },
    
   /**
    * Sets a browser cookie
    *
    * @param {Object} cookie
    * @param {String} cookie.name
    * @param {String} cookie.value
    * @param {Number} cookie.expiration - Time to expire in days, expires after session if left blank
    */
    setCookie: function(cookie) {
      if(this.hasCookie(cookie.name) && this.getCookieValue(cookie.name) != cookie.value){
        this.removeCookie(cookie.name);
      }

      var opts = cookie.hasOwnProperty('expiration') ? { expires : cookie.expiration } : {};
      Cookies.set( cookie.name, cookie.value, opts );

      return this;
    },

   /**
    * Checks for the presence of a browser cookie by name (doesn't check for value equality)
    *
    * @param {String} cookieName
    * @return {Boolean}
    */
    hasCookie: function(cookieName) {
      return typeof Cookies.get( cookieName ) !== "undefined";
    },

   /**
    * Returns value of browser cookie by name
    *
    * @param {String} cookieName
    * @return {String | Undefined}
    */
    getCookieValue: function(cookieName) {
      return this.hasCookie( cookieName ) ? Cookies.get( cookieName ) : undefined;
    },

   /**
    * Removes a cookie by name
    *
    * @param {String} cookieName
    * @return {Self}
    */
    removeCookie: function(cookieName) {
      Cookies.remove( cookieName )
      return this;
    }
  });

  return new User();

}(Cookies));
/**
 * Breakpoint Helper Functions / constants
 * -----------------------------------------------------------------------------
 * A collection of functions that help with dealing with site breakpoints in JS
 * All breakpoint properties should be defined here
 *
 */

slate.breakpoints = (function($) {

  var $window = $(window);
  var cachedWindowWidth = $window.width(); 

  // Match those set in variables.scss
  var _breakpointMinWidths = {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1480
  };

  var events = {
    BREAKPOINT_CHANGE: 'breakpointChange',
  };


 /**
  * Get one of the widths stored in the variable defined above
  *
  * @param {string} key - string matching one of the key names
  * @return {int} - pixel width
  */
  function getBreakpointMinWidth(key) {
    if(!key) return;

    if(_breakpointMinWidths.hasOwnProperty(key)) {
      return _breakpointMinWidths[key];
    }
  }

 /**
  * Gets the key for one of the breakpoint widths, whichever is closest but smaller to the passed in width
  * So if we pass in a width between 'sm' and 'md', this will return 'sm'
  *
  * @param {int} w - width
  * @return {undefined|string} foundKey
  */
  function getBreakpointMinWidthKeyForWidth(w) {
    var w = w != undefined ? w : $window.width();
    var previousKey;
    var foundKey;

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if(w > bpMinWidth) {
        previousKey = k;
      }
      else {
        foundKey = previousKey;
      }
    });

    return foundKey;
  }

 /**
  * Triggers a window event when a breakpoint is crossed, passing the new minimum breakpoint width key as an event parameter
  *
  */
  function onResize() {
    var newWindowWidth = $window.width();

    $.each(_breakpointMinWidths, function(k, bpMinWidth) {
      if( (newWindowWidth >= bpMinWidth && cachedWindowWidth < bpMinWidth) || (cachedWindowWidth >= bpMinWidth && newWindowWidth < bpMinWidth) ) {
        
        var bpMinWidthKey = getBreakpointMinWidthKeyForWidth(newWindowWidth);
        var e = $.Event(events.BREAKPOINT_CHANGE, { bpMinWidthKey: bpMinWidthKey });
        $window.trigger(e);
        return false;

      }
    });

    cachedWindowWidth = $window.width();
  }

  $window.on('resize', $.throttle(20, onResize) );

  return {
    getBreakpointMinWidth: getBreakpointMinWidth
  };

}(jQuery));
/**
 * Product Detail Form Script
 * ------------------------------------------------------------------------------
 *
 * Handles all functionality related to contents of snippets/product-detail-form.liquid
 * Core functionality includes:
 *  - Variant selecting + callbacks
 *  - Variant galleries + slideshow initializing
 *
 * Requires:
 *  - jQuery
 *  - Modernizr (for Modernizr.touchevents)
 *  - Slate (for slate.Currency)
 *  - Flow (for international cart.  Can't pass as a dependency because properties get added to object asynchronously)
 */

// Requires slate for slate.Currency

slate.ProductDetailForm = (function($, Modernizr, slate) {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productZoomButton: '[data-zoom-button]',
    productGallery: '[data-product-gallery]',
    productImageContainer: '[data-product-image-container]',
    productZoomImageLink: '[data-product-zoom-image]',
    productImage: '[data-product-image]',
    productGalleryFeatured: '[data-product-gallery-featured]',
    productImageThumbs: '[data-product-image-thumbs]',
    productImageThumb: '[data-product-image-thumb]',
    productFeaturedImageLink: '[data-product-featured-image-link]',
    productGalleryLoadingIcon: '[data-product-gallery-loading-icon]',
    initialSlide: '[data-initial-slide]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    singleOptionSelectedValue: '[data-single-option-selected-value][data-position]',
    singleOptionSelector: '[data-single-option-selector][data-index]',
    variantColorSwatch: '.product-detail__form--color-swatch',
    variantOptionColor: '.product-detail__form--color-swatch [data-single-option-selected-value]',
    variantOptionValueList: '[data-variant-option-value-list][data-option-position]',
    variantOptionValue: '[data-variant-option-value]',
    quantitySelect: '[data-product-quantity-select]',
    productCollectionProductSelect: '[data-product-collection-product-select]', // Select dropdown with product link as the value of each option
    fullDetailsLink: '[data-full-details-link]',
    lowInventoryMessage: '[data-low-inventory-msg]',
    lowInventoryThresholdQty: '[data-low-inventory-threshold]',
    variantInventoryQty: '[data-variant-inventory-qty]',
    productDetailForm: '[data-product-detail-form]',
    addToCartForm: '[data-add-to-cart-form]',
    productDetailContainer: '[data-product-detail-container]',
    productQuantitySelector: '[data-product-quantity-selector]',
    comingSoonText: '[data-coming-soon-text]',
    badgingComingSoon: '[data-badging-coming-soon]',
    badgingSoldOut: '[data-badging-sold-out]',
    badgingAlmostGone: '[data-badging-almost-gone]',
    backInStockBtn: '[data-back-in-stock]',
    flowVariant: '[flow-variant]',
    productUrls: '[data-product-url]',
    productColors: '[data-color]',
    productPreOrderBadge: '[data-product-pre-order-badge] img',   
    productPreOrderMessage: '[data-product-pre-order-message]',
    productEstimatedShipDate: '[data-product-estimated-ship-date]',
    productShipDateText: '[data-ship-date-text]'
  };


  var classes = {
    hide: 'hide',
    variantOptionValueActive: 'is-active',
    variantOptionValueDisabled: 'is-disabled',
    zoomReady: 'is-zoomable',
    zoomedIn: 'is-zoomed',
    comingSoon: 'product-detail__form--coming-soon',
    giftCard: 'product-detail__form--gift-card',
    isPreOrderProduct: 'is-pre-order-product'
  };

  var $window   = $(window);

  /**
   * ProductDetailForm constructor
   *
   * @param { Object } config
   * @param { jQuery } config.$el - Main element, see snippets/product-detail-form.liquid
   * @param { jQuery } config.$container - Container to listen to scope events / element to listen to events on.  Defaults to config.$el
   * @param { Boolean } config.enableZoom - Toggle zoom capabilities on / off
   * @param { Boolean } config.enableHistoryState - If set to "true", turns on URL updating when switching variants
   * @param { Function } config.onReady -  Called after the product form is initialized.
   */
  function ProductDetailForm(config) {

    this.settings = {};
    this.name = 'productDetailForm';
    this.namespace = '.'+this.name;

    this.events = {
      RESIZE: 'resize' + this.namespace,
      CLICK:  'click'  + this.namespace,
      SCROLL: 'scroll' + this.namespace,
      INIT:   'init'   + this.namespace,
      READY:  'ready'  + this.namespace
    };

    this.flowExperience = false;
    
    var _this = this;
    var ready = false;
    var options = options || {};
    var defaults = {
      enableZoom: true,
      enableHistoryState: true
    };

    if(Flow) {
      Flow.set('on', 'ready', function() {
        _this.flowExperience = Flow.getExperience();    
      });
    }    

    this.initialize = function() {
      if(ready) {
        return;
      }

      this.settings = $.extend({}, defaults, config);

      if (!this.settings.$el || this.settings.$el == undefined) {
        console.warn('['+this.name+'] - $el required to initialize');
        return;
      }

      this.$el = this.settings.$el;
      this.$container = this.settings.$container;

      if (!this.$container || this.$container == undefined) {
        this.$container = this.$el;
      }

      this.productSingleObject  = JSON.parse($(selectors.productJson, this.$container).html());

      this.QUANTITY_SELECT_LIMIT = $(selectors.quantitySelect, this.$container).first().data('max') || 4;

      slate.utils.chosenSelects(this.$container);

      var variantOptions = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(variantOptions);

      // See slate.Variants for these events
      this.$container.on('variantChange' + this.namespace, this.onVariantChange.bind(this));
      $(selectors.productCollectionProductSelect, this.$container).on('change' + this.namespace, this.onProductCollectionProductSelectChange.bind(this));

      var selectedOpts = $(".dot.is-active").map(function(o) { 
        return $(this).attr("title") || $(this).data("variant-option-value"); 
      }).toArray();
      
      var initialVariant = this.productSingleObject.variants.filter(function(v) {
        return selectedOpts.every(function(oo, idx) { 
          return v.options[idx] == oo;
        });
      })[0];

      this.checkAvailability(initialVariant);
      this.updateProductColorSelect(initialVariant); 
      this.updateVariantInventoryQtyMessage(initialVariant);     
      this.initProductImages();
      this.initGalleries();
      this.addHideAfterpayClass();
      this.setVariantNameToTitleCase();
      this.$container.on(this.events.CLICK, selectors.variantOptionValue, this.onVariantOptionValueClick.bind(this));

      if(this.flowExperience) {
        Flow.localize();
      }

      var e = $.Event(this.events.READY);
      this.$el.trigger(e);

      ready = true;
    };

    return this;
  };

  ProductDetailForm.prototype = $.extend({}, ProductDetailForm.prototype, {

    initGalleries: function() {
      var self = this;
      var $galleries = $(selectors.productGallery, this.$container);

      // Lifecycle methods for handling slideshow changes + hoverzoom initialization
      function initHoverZoom($zoomTarget) {
        var opts = {
          url: $zoomTarget.find(selectors.productFeaturedImageLink).attr('href'),
          on: 'click',
          touch: false,
          escToClose: true,
          zoomMagnify: 0.8,
          zoomDuration: 300,
          callback: function() {
            $zoomTarget.addClass(classes.zoomReadyClass);
          },
          onZoomIn: function() {
            $zoomTarget.addClass(classes.zoomedInClass);
          },
          onZoomOut: function() {
            $zoomTarget.removeClass(classes.zoomedInClass);
          }
        };

        $zoomTarget.zoom(opts);

        $zoomTarget.find(selectors.productZoomButton).on('click', function(e){
          $zoomTarget.trigger('click');
          return false;
        });

      }

      function destroyHoverZoom($zoomTarget) {
        $zoomTarget.trigger('zoom.destroy');
        $zoomTarget.find(selectors.productZoomButton).off('click');
      }

      function onFeaturedSlickBeforeChange(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        if(self.settings.enableZoom) {
          destroyHoverZoom($zoomTarget);
        }
      }

      function onFeaturedSlickAfterChange(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        if(self.settings.enableZoom) {
          initHoverZoom($zoomTarget);
        }
      }

      function onFeaturedSlickInit(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        if(self.settings.enableZoom) {
          initHoverZoom($zoomTarget);
        }
      }

      $galleries.each(function() {
        var $featured  = $(this).find(selectors.productGalleryFeatured);

        // Look for element with the initialSlide selector.
        var initialSlide = $(this).find(selectors.initialSlide).length ? $(this).find(selectors.initialSlide).index() : 0;

        $featured.on({
          init: onFeaturedSlickInit,
          beforeChange: onFeaturedSlickBeforeChange,
          afterChange: onFeaturedSlickAfterChange
        });

        // this.slideshow = new slate.Slideshow($($featured, this.$container));

        $featured.slick({
          speed: 600,
          dots: true,
          swipe: Modernizr.touchevents,
          arrows: true,
          prevArrow: '<div class="ProductGallery-arrowWrapper ProductGallery-arrowWrapper--left"><a class="arrow arrow--transparent arrow--left" aria-label="Previous slide"><span class="arrow__icon"></span></a></div>',
          nextArrow: '<div class="ProductGallery-arrowWrapper ProductGallery-arrowWrapper--right"><a class="arrow arrow--transparent" aria-label="Next slide"><span class="arrow__icon"></span></a></div>',
          initialSlide: initialSlide,
          accessibility: false,
          draggable: true
        });
      });

      // Because slick can get weird on initialization, make sure we call `refresh` on any visible galleries
      $galleries.not('.hide').each(function() {
        $(this).find(selectors.productGalleryFeatured).slick('getSlick').refresh();
      });
    },

    initProductImages: function() {
      var self = this;
      var $productThumbs = $(selectors.productImageThumbs, this.$container);
      var $productImageContainer = $(selectors.productImageContainer, this.$container);
      var $productThumbImages = $(selectors.productImageThumb, this.$container);
      var $productGalleryLoadingIcon = $(selectors.productGalleryLoadingIcon, this.$container);

      // Lifecycle methods for handling slideshow changes + hoverzoom initialization
      function initHoverZoom($zoomTarget) {
        var opts = {
          url: $zoomTarget.find(selectors.productZoomImageLink).attr('href'),
          on: 'click',
          touch: false,
          escToClose: true,
          zoomMagnify: 0.8,
          zoomDuration: 300,
          callback: function() {
            $zoomTarget.addClass(classes.zoomReadyClass);
          },
          onZoomIn: function() {
            $zoomTarget.addClass(classes.zoomedInClass);
          },
          onZoomOut: function() {
            $zoomTarget.removeClass(classes.zoomedInClass);
          }
        };

        $zoomTarget.zoom(opts);

        $zoomTarget.find(selectors.productZoomButton).on('click', function(e){
          $zoomTarget.trigger('click');
          return false;
        });
      }
      
      function destroyHoverZoom($zoomTarget) {
        $zoomTarget.trigger('zoom.destroy');
        $zoomTarget.find(selectors.productZoomButton).off('click');
      }      


      //Turn vertical thumbs to a slider for when there are more than enough thumbs to display
      $productThumbs.slick({
        speed: 500,
        dots: false,
        swipe: Modernizr.touchevents,
        infinite: false,
        vertical: true,
        slidesToShow: 3.5,
        slidesToScroll: 2,
        centerMode: true,
        centerPadding: '0 0 10% 0',
        prevArrow: '<div class="ProductThumbs-arrowWrapper ProductThumbs-arrowWrapper--up"><a class="arrow arrow--transparent arrow--up" aria-label="Arrow up"><span class="arrow__icon"></span></a></div>',
        nextArrow: '<div class="ProductThumbs-arrowWrapper ProductThumbs-arrowWrapper--down"><a class="arrow arrow--transparent arrow--up" aria-label="Arrow down"><span class="arrow__icon"></span></a></div>'        
      });

      if(self.settings.enableZoom) {
        initHoverZoom($productImageContainer);
      }

      $productThumbImages.click(function(e) {
        var $imageClicked = e.currentTarget;
        var $zoomImage =  $($imageClicked).data("product-image-zoom-url");
        var $productImage = $($imageClicked).data("product-image-url");

        $.ajax({
          type: 'GET',
          url: $productImage,
          dataType: 'image/jpg',
          async: true,
          complete: function() {
            //$productImageContainer.find('.ProductGallery__gallery-badging was-showing').fadeIn('slow', function() {});
            var $badges = $productImageContainer.find('.ProductGallery__gallery-badging');
            $badges.each(function () {
              if($(this).hasClass('was-showing')){
                $(this).removeClass('was-showing').delay(600).fadeIn();
              }
            }); 

            $productGalleryLoadingIcon.delay(500).hide();
            $(selectors.productImage).attr("src", $productImage).delay(500).show();
            $(selectors.productZoomImageLink).attr("href", $zoomImage);
            console.log("complete");

            destroyHoverZoom($productImageContainer);
            if(self.settings.enableZoom) {
              initHoverZoom($productImageContainer);
            }            
          }
        }).always(function() {
          var $badges = $productImageContainer.find('.ProductGallery__gallery-badging:visible');
          $badges.each(function () {
            $(this).hide().addClass('was-showing');
          });
          $(selectors.productImage).hide();
          $productGalleryLoadingIcon.show();
          console.log("always");
        }).fail(function(jqXHR, textStatus) {
          console.log("Request failed: " + textStatus);
        });
      });
    },

    /**
     * Slick sliders are annoying and sometimes need an ass kicking
     *
     */
    resizeGalleries: function() {
      $('.slick-slider', this.$container).resize();
    },

    onVariantChange: function(evt) {
      var variant = evt.variant;

      this.updateProductPrices(variant);
      this.updateAddToCartState(variant);
      this.updateQuantityDropdown(variant);
      this.updateVariantOptionValues(variant);
      this.updateFullDetailsLink(variant);
      this.updateVariantInventoryQtyMessage(variant);
      this.updateGalleries(variant);
      this.updateProductColorUrl(variant);
      this.updateProductColorSelect(variant);
      this.updatePreOrderDate(variant);

      $(selectors.singleOptionSelector, this.$container).trigger('chosen:updated');
    },

    /**
     * Handles change event to the ProductCollectionProductSelect element.
     * Grabs the value (product url) and navigates to that page
     *
     * @param {Event} e - select change event
     */
    onProductCollectionProductSelectChange: function(e) {
      var url = $(e.currentTarget).val();

      if(url) {
        window.location.href = url;
      }
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {Object} variant - Shopify variant object
     */
    updateAddToCartState: function(variant) {
      var $addToCartBtn             = $(selectors.addToCart, this.$container);
      var $addToCartBtnText         = $(selectors.addToCartText, this.$container);
      var $backInStockBtn           = $(selectors.backInStockBtn, this.$container);
      var $comingSoonText           = $(selectors.comingSoonText, this.$container);
      var $priceWrapper             = $(selectors.priceWrapper, this.$container);
      var $productDetailContainer   = $(selectors.productDetailContainer, this.$container);
      var $productQuantitySelector  = $(selectors.productQuantitySelector, this.$container);

      if (variant) {
        $priceWrapper.removeClass(classes.hide);
      } else {
        $addToCartBtn.prop('disabled', true);
        $addToCartBtnText.html(theme.strings.unavailable);
        $priceWrapper.addClass(classes.hide);
        return;
      }

      if (variant.available) {
        $addToCartBtn.prop('disabled', false);

        if(this.isPreOrderVariant(variant)) {
          $addToCartBtnText.html(theme.strings.preOrder);
        } else {
          $addToCartBtnText.html(theme.strings.addToCart);
        }

      } else {
        $addToCartBtn.prop('disabled', true);
        $addToCartBtnText.html(theme.strings.soldOut);
      }

      if($backInStockBtn.length) {
        if(variant && !variant.available) {
          $backInStockBtn.show();
          $addToCartBtn.hide();

          if ($productDetailContainer.hasClass(classes.comingSoon)) {
            $comingSoonText.show();
            $productQuantitySelector.hide();
          } 
          else {
            $comingSoonText.hide();
            $productQuantitySelector.show();
          }
        }
        else {
          $backInStockBtn.hide();
          $addToCartBtn.show();
          $comingSoonText.hide();
          $productQuantitySelector.show();
          if ($productDetailContainer.hasClass(classes.giftCard)) {
            console.log('is gift card - hide qty selector');
            $productQuantitySelector.hide();
          } 
        }
      }
      else {
        $addToCartBtn.show();
        $comingSoonText.hide();
        $productQuantitySelector.show();
      }
    },

    /**
     * Updates the quantity select dropdown based on the available quantity and inventory management setting of the selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateQuantityDropdown: function(variant) {

      var $select = $(selectors.quantitySelect, this.$container);

      // Close the dropdown while we make changes to it
      $select.trigger("chosen:close");

      if(variant && variant.inventory_management && variant.inventory_policy == "deny") {
        if(variant.inventory_quantity > 0) {
          $select.prop('disabled', false);
          
          // Update the select box to max out at the limit if less than 5?
          var limit = (variant.inventory_quantity > this.QUANTITY_SELECT_LIMIT ? this.QUANTITY_SELECT_LIMIT : variant.inventory_quantity);
          
          $select.empty();

          for (var i = 1; i <= limit; i++) {
            
            var option = document.createElement('option');
                option.value = i;
                option.text  = i;

            $select.append(option);
          }
        }
        else {
          $select.prop('disabled', true);
        }
      }
      else {
        $select.prop('disabled', false);
      }

      $select.trigger('chosen:updated');
      
    },    

    /**
     * Updates the DOM with specified prices
     *
    * @param {Object} variant - Shopify variant object
     */
    updateProductPrices: function(variant) {
      var $productPrice = $(selectors.productPrice, this.$container)
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls   = $comparePrice.add( $(selectors.comparePriceText, this.$container) );

      if(variant) {
        $productPrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          $compareEls.removeClass(classes.hide);
        } else {
          $comparePrice.html('');
          $compareEls.addClass(classes.hide);
        }

        if(this.flowExperience) {
          $(selectors.flowVariant, this.$container).attr('flow-variant', variant.id);
          $(selectors.productPrice, this.$container).text(Flow.cache.localizedVariants.getById(variant.id).prices.item.label);
          Flow.localize();
        }
      }
    },

    /**
     * Updates the DOM state of the elements matching the variantOption Value selector based on the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateVariantOptionValues: function(variant) {
      if(variant) {
        // Loop through all the options and update the option value
        for (var i = 3; i >= 1; i--) {
          var variantOptionValue = variant['option' + i];
          
          // Since we are finding the variantOptionValueUI based on the *actual* value, we need to scope to the correct list
          // As some products can have the same values for different variant options (waist + inseam both use "32", "34", etc..)
          var $variantOptionValueList = $(selectors.variantOptionValueList, this.$container).filter('[data-option-position="'+i+'"]');
          var $variantOptionValueUI = $('[data-variant-option-value="'+variantOptionValue+'"]', $variantOptionValueList);

          $variantOptionValueUI.addClass(classes.variantOptionValueActive);
          $variantOptionValueUI.siblings().removeClass(classes.variantOptionValueActive);

          // Update the text inside the label to reflect the selected value
          $(selectors.singleOptionSelectedValue, this.$container).filter('[data-position="' + i + '"]').text(variantOptionValue);
        }
        this.checkAvailability(variant);
      }
    },

    setVariantNameToTitleCase: function() {
      var currentVariant = $(selectors.variantOptionColor, this.$container)[0];
      if (currentVariant) {
        var textContent = currentVariant.textContent;
        $(currentVariant).text(this.toTitleCase(textContent));
        $(currentVariant).parents(selectors.variantColorSwatch).css('opacity', 1)
      }
    },

    toTitleCase: function(str) {
      var lowercase = str.toLowerCase();
      return lowercase.replace(/(?:^|\s)\w/g, function(match) {
          return match.toUpperCase();
      });
    },

    checkAvailability: function(variant) {
      //if(variant && variant.option3) {
      if(variant) {
        var context = this;
        // get variants for the options that didn't change to check if they are available
        // ie: Size changes and is position 2, then we check position 3 for inseam to see if there's a variant for it
        // and disable accordingly if there is not a variant available for it
        var selectedProduct = window.ShopifySeedData.collection.filter(function(prod) { 
          return prod.id == context.productSingleObject.id;
         })[0];

        selectedProduct.options_with_values.forEach(function(opt) { 
          opt.values.forEach(function(optVal) {
            var selectedOptions = [];

            switch(opt.position) {
              case 2: selectedOptions = [variant.option1, optVal, variant.option3]; break;
              case 3: selectedOptions = [variant.option1, variant.option2, optVal]; break;
              default: selectedOptions = [optVal, variant.option2, variant.option3]; break;
            }

            var foundVariant = selectedProduct.variants.filter(function(v) {
              return selectedOptions.every(function(oo, idx) { 
                return v.options[idx] == oo });
            })[0];

            var $el = $('[data-variant-option-value="'+ optVal+ '"]','[data-option-position="'+ opt.position +'"]');

            if(foundVariant) {
              if(foundVariant.available == false && selectedOptions[3] == null) {
                $el.addClass(classes.variantOptionValueDisabled);
              } else {              
                $el.removeClass(classes.variantOptionValueDisabled);
              }
            } else {
              $el.addClass(classes.variantOptionValueDisabled)
            }
          });
        });
      }
    },
    /**
     * Used on quick view, updates the "view full details" link to point to the currently selected variant
     *
     * @param {Object} variant - Shopify variant object
     */
    updateFullDetailsLink: function(variant) {
      var $fullDetailsLink = $(selectors.fullDetailsLink, this.$container);
      var updatedUrl;

      if(variant && $fullDetailsLink.length) {
        updatedUrl = slate.utils.getUrlWithUpdatedQueryStringParameter('variant', variant.id, $fullDetailsLink.attr('href'));
        $fullDetailsLink.attr('href', updatedUrl);
      }
    },

    /**
     * Updates low inventory messaging, hides it if inventory tracking is disabled or stock is high enough. Shows 'coming soon' badging if tagged 'Coming Soon'.
     *
     * @param {Object} variant - Shopify variant object
     */
    updateVariantInventoryQtyMessage: function(variant) {
      var context = this;
      var $msg = $(selectors.lowInventoryMessage, this.$container);
      var $qty = $(selectors.variantInventoryQty, this.$container);
      var threshold = parseInt($(selectors.lowInventoryThresholdQty, this.$container).data('low-inventory-threshold'));
      var $productDetailContainer = $(selectors.productDetailContainer, this.$container);
      var $badgingAlmostGone = $(selectors.badgingAlmostGone, this.$container);
      var $badgingComingSoon = $(selectors.badgingComingSoon, this.$container);
      var $badgingSoldOut = $(selectors.badgingSoldOut, this.$container);  
      var $comingSoonText   = $(selectors.comingSoonText, this.$container);

      if(!variant) {
        $msg.slideUp();
        return;
      }
      
      var currentProduct = window.ShopifySeedData.collection.filter(function(prod) { return prod.id == context.productSingleObject.id })[0];
      var myVariant = currentProduct.variants.filter(function(v) { return v.id == variant.id })[0];

      var qty = myVariant.inventory_quantity;
      var policy = variant.inventory_policy;
      var management = variant.inventory_management;

      if(qty <= 0 || qty > threshold || policy == "continue" || management == null) {
        $msg.slideUp(300, function(){
          $qty.text(qty);
        });
        if (qty <= 0) {
          $badgingAlmostGone.hide();
          
          if ($productDetailContainer.hasClass(classes.giftCard)) {
            $badgingSoldOut.hide();
          }
          else if ($productDetailContainer.hasClass(classes.comingSoon)) {
            $comingSoonText.show();
            $badgingComingSoon.show();
            $badgingSoldOut.hide();
          } else {
            $badgingComingSoon.hide();
            $badgingSoldOut.show();
          }
          
        } else if (qty > threshold) {
          $badgingComingSoon.hide();
          $badgingAlmostGone.hide();
          $badgingSoldOut.hide();
        }
      }
      else {
        $qty.text(qty);
        $badgingComingSoon.hide();
        $badgingSoldOut.hide();
        $badgingAlmostGone.show();       
        if(!$msg.is(':visible')) {
          $msg.slideDown(300);  
        }
      }
    },

    /**
     * Look for a gallery matching one of the selected variant's options and switch to that gallery
     * If a matching gallery doesn't exist, look for the variant's featured image in the main gallery and switch to that
     *
     * @param {Object} variant - Shopify variant object
     */
    updateGalleries: function(variant) {

      var $galleries = $(selectors.productGallery, this.$container);
      var $galleryFeatured = $(selectors.productGalleryFeatured, this.$container);

      if (variant) {
        if ($galleries.length > 1) {
          for (var i = 3; i >= 1; i--) {
            var option = variant['option' + i];
            var $variantGallery = $galleries.filter(function() {
              return $(this).data('variant-gallery') == option;
            });

            if ($variantGallery.length && $variantGallery.hasClass(classes.hide)) {
              $galleries.not($variantGallery).addClass(classes.hide);
              $variantGallery.removeClass(classes.hide);
              // Slick needs to make a lot of measurements in order to work, calling `refresh` forces this to happen
              $variantGallery.find(selectors.productGalleryFeatured).slick('getSlick').refresh();
            }
          }
        }
        else {
          // Slide to featured image for selected variant
          if (variant.featured_image) {
            var $imageSlide = $galleryFeatured.find('[data-image="'+variant.featured_image.id+'"]').first();

            if ($imageSlide.length) {
              $galleryFeatured.slick('slickGoTo', $imageSlide.data('slick-index'));
            }
          }
        }
      }
      else {
        // No variant - Don't do anything?
      }
    },

    /**
     * Handle variant option value click event.
     * Update the associated select tag and update the UI for this value
     *
     * @param {event} evt
     */
    onVariantOptionValueClick: function(e) {

      var $option = $(e.currentTarget);

      if ($option.hasClass(classes.variantOptionValueActive)) {
        return;
      }

      var value     = $option.data('variant-option-value');
      var position  = $option.parents(selectors.variantOptionValueList).data('option-position');
      var $selector = $(selectors.singleOptionSelector, this.$container).filter('[data-index="option'+position+'"]');

      $selector.val(value);
      $selector.trigger('change');

      $option.addClass(classes.variantOptionValueActive);
      $option.siblings().removeClass(classes.variantOptionValueActive);      
      this.setVariantNameToTitleCase();

    },
    /**
     * update the color swatch url to include the variant id of the size/inseam clicked
     * @param {Object} variant 
     */
    updateProductColorUrl:function(variant) {
      if (variant) {
        $('[data-color]').each(function() {
          var $el = $(this);
          var color = $(this).data('color');
          
          if(window.ShopifySeedData && window.ShopifySeedData.collection) {
            $.each(window.ShopifySeedData.collection, function(i, product) { 
              $.each(product.variants, function(idx, v) {
                if((v.options[0] == color || v.options[1] == color || v.options[2] == color) && 
                (v.options[1] == variant.option2) && 
                (v.options[2] == variant.option3)) {
                  var link = $el.attr("href");
                  if(slate.utils.linkHasQueryString(link, "variant", 'checkValue')) {
                    $el.attr("href", slate.utils.getUrlWithUpdatedQueryStringParameter('variant', v.id, link))    
                  }
                  else {
                    $el.attr("href", $el.attr("href") + "?variant=" + v.id);
                  }
                  
                  return;
                }
              });
            });
          }
        });
      }
    },
    /**
     * Update the color dropdown that shows in the sticky product bar that shows when the user scrolls down 
     * @param {Object} variant 
     */
    updateProductColorSelect(variant) {
      if(variant){
        var $selectOptions = $(selectors.productCollectionProductSelect, this.$container);

        $($selectOptions).find('option').each(function() {
          var $option = $(this);
          var color = $(this).text();

          if(window.ShopifySeedData && window.ShopifySeedData.collection) {
            $.each(window.ShopifySeedData.collection, function(i, product) { 
              $.each(product.variants, function(idx, v) {
                if((v.options[0] == color || v.options[1] == color || v.options[2] == color) && 
                (v.options[1] == variant.option2) && 
                (v.options[2] == variant.option3)) {
                  var link = $option.attr("value");
                  if(slate.utils.linkHasQueryString(link, "variant", 'checkValue')) {
                    $option.attr("value", slate.utils.getUrlWithUpdatedQueryStringParameter('variant', v.id, link))    
                  }
                  else {
                    $option.attr("value", $option.attr("value") + "?variant=" + v.id);
                  }
                  
                  return;
                }
              });
            });
          }
        });
      }
    },
    /**
     * update the main image url and zoom image based on thumbnail image clicked on left of main image
     * @param {event} e 
     */
    onProductThumbClick: function(e) {
      var $imageClicked = e.currentTarget;
      var $zoomImage =  $($imageClicked).data("product-image-zoom-url")
      var $productImage = $($imageClicked).data("product-image-url")

      $(selectors.productImage).attr("src", $zoomImage);
      $(selectors.productZoomImageLink).attr("href", $productImage);      
    },
    /**
     * Update the pre-order date for product where only some variant(s) are available for pre-order
     * @param {event} variant 
     */
    updatePreOrderDate: function(variant) {
      var context = this;

      if (variant) {
        //hiddenPreOrderBadge: '[data-hidden-pre-order-badge]',
        //variantPreOrderBadge: '[data-variant-pre-order-badge]',   
        //productPreOrderMessage: '[data-product-pre-order-message]',
        //productEstimatedShipDate: '[data-product-estimated-ship-date]',
        //productShipDateText: '[data-ship-date-text]'        
       var $preOrderDatesObj = window.VariantsWithPreOrder;
       var $preOrderDate = $preOrderDatesObj[variant.id];
       var $productPreOrderMessage = $(selectors.productPreOrderMessage, this.$container);
       var $productEstimatedShipDate = $(selectors.productEstimatedShipDate, this.$container);
       var $productShipDateText = $(selectors.productShipDateText, this.$container);
       var $productDetailContainer   = $(selectors.productDetailContainer, this.$container);
       var $addToCartForm            = $productDetailContainer.find($(selectors.addToCartForm));
       var $addToCartBtnText         = $(selectors.addToCartText, this.$container);
       var $preOrderBadge = $(selectors.productPreOrderBadge, this.$container);


       var currentProduct = window.ShopifySeedData.collection.filter(function(prod) { return prod.id == context.productSingleObject.id })[0];
       var myVariant = currentProduct.variants.filter(function(v) { return v.id == variant.id })[0];
       var qty = myVariant.inventory_quantity;
       
       if($preOrderDate != "" && (qty && Number.isInteger(qty) && qty > 0)) {
        $addToCartForm.find('[name^="properties"]').val($preOrderDate);
        $productShipDateText.empty().append($preOrderDate);
        $productPreOrderMessage.show();
        $productEstimatedShipDate.show();
        $preOrderBadge.show();    
       } else { 
        $addToCartBtnText.html(theme.strings.addToCart);
        $productPreOrderMessage.hide();
        $productEstimatedShipDate.hide();
        $addToCartForm.find('[name^="properties"]').val("");
        $preOrderBadge.hide();    
       }
      }
    },
    /**
     * check if the current variant is a pre-order variant
     * @param {Object} variant 
     */
    isPreOrderVariant: function(variant) {
      if(variant) {
        var isPreOrder = false;
        var $preOrderDatesObj = window.VariantsWithPreOrder;
        var $preOrderDate = $preOrderDatesObj[variant.id];
      
        if($preOrderDate != "") {         
          isPreOrder = true;
        }

        return isPreOrder;
      }
    },
    addHideAfterpayClass: function() {
      if (typeof window.afterpay_product != "undefined" && window.afterpay_product != null) {
        if (window.afterpay_product.tags != null && window.afterpay_product.tags.includes("pre-order")) {
          $('body').addClass("hide-afterpay");
        }
      }
    }
  });

  return ProductDetailForm;

})(jQuery, Modernizr, slate)
/**
 * Product Card Scripts
 * -----------------------------------------------------------------------------
 * Handles any events associated with the product card html (see snippets/product-card.liquid)
 */

slate.productCard = (function() {

  var selectors = {
    el: '.product-card',
    altLazyImg: '[data-product-card-alt-lazy]'
  };

  var classes = {
    altLoaded: 'alt-loaded' // added to the product card once the alt image is loaded to avoid a flash of white while loading
  }

  var $productCard = $(selectors.el);

  if(!$productCard.length) {
    return;
  }
  
  var events = window.PointerEvent ? {
              end:   "pointerup",
              enter: "pointerenter",
              leave: "pointerleave"
            } : {
              end: "touchend",
              enter: "mouseenter",
              leave: "mouseleave"
            };


  $(selectors.el).one(events.enter, onEnter);

  function onEnter(e) {
    var $productCard = $(e.currentTarget);
    var $lazyImg = $productCard.find( selectors.altLazyImg );

    if($lazyImg.length) {
      $lazyImg.on('load', function() {
        $productCard.addClass(classes.altLoaded);
      });

      $lazyImg.attr('src', $lazyImg.data('src'));
      $lazyImg.removeAttr('data-src');
    }
  };

}());
/**
 * Drawer Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of drawer elements that slide out from the side of the screen
 *
 * @namespace - drawer
 */

(function($, slate){
  slate.Drawer = (function() {
    
    var $window = $(window);
    var $body   = $('body');

    var selectors = {
      close: '[data-drawer-close]'
    }

    var classes = {
      drawer: 'drawer',
      drawerOpen: 'is-open',
      backdrop: 'drawer-backdrop',
      backdropVisible: 'is-visible',
      bodyDrawerOpen: 'drawer-open'
    };

  /**
    * Drawer constructor
    *
    * --
    */
    function Drawer(el) {
      this.name      = 'drawer'
      this.namespace = '.' + this.name;

      this.$el                = $(el);
      this.$backdrop          = null;
      this.stateIsOpen        = null;
      this.transitionEndEvent = slate.utils.whichTransitionEnd();

      if(this.$el == undefined || !this.$el.hasClass(classes.drawer)) {
        console.warn('['+this.name+'] - Element with class `'+classes.drawer+'` required to initialize.');
        return;
      }

      this.$el.on('click', selectors.close, this.onCloseClick.bind(this));

      return this;
    };

    Drawer.prototype = $.extend({}, Drawer.prototype, {

      onCloseClick: function(e) {
        e.preventDefault();
        this.close();
      },

      addBackdrop: function(callback) {

        var _this = this;
        var cb    = callback || $.noop;

        if(this.stateIsOpen) {
          this.$backdrop = $(document.createElement('div'));

          this.$backdrop.addClass(classes.backdrop)
                        .appendTo($body);

          this.$backdrop.one(this.transitionEndEvent, cb);
          this.$backdrop.one('click', this.close.bind(this))

          // debug this...
          setTimeout(function() {
            _this.$backdrop.addClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

      removeBackdrop: function(callback) {

        var _this = this;
        var cb    = callback || $.noop;

        if(!this.stateIsOpen && this.$backdrop) {
          this.$backdrop.one(this.transitionEndEvent, function(){
            _this.$backdrop && _this.$backdrop.remove()
            _this.$backdrop = null;
            cb();
          });

          setTimeout(function() {
            _this.$backdrop.removeClass(classes.backdropVisible);
          }, 10);
        }
        else {
          cb();
        }
      },

     /**
      * Opens / closes the cart depending on state
      *
      */
      toggleVisibility: function() {
        return this.stateIsOpen ? this.close() : this.open();
      },

     /**
      * Check the open / closed state of the cart
      *
      * @return {bool}
      */
      isOpen: function() {
        return this.stateIsOpen;
      },

     /**
      * Returns true is the cart is closed.
      *
      * @return {bool}
      */
      isClosed: function() {
        return !this.stateIsOpen;
      },

     /**
      * Code for opening the cart
      */
      open: function() {
        if(this.stateIsOpen) return;
        this.stateIsOpen = true;

        $body.addClass(classes.bodyDrawerOpen);
        this.$el.addClass(classes.drawerOpen);
        this.addBackdrop();
      },

     /**
      * Code for closing the cart
      */
      close: function() {
        if(!this.stateIsOpen) return;
        this.stateIsOpen = false;

        this.$el.removeClass(classes.drawerOpen);
        this.removeBackdrop(function() {
          $body.removeClass(classes.bodyDrawerOpen);
        });
      }

    });

    return Drawer;
  }());

})(jQuery, slate);

/**
 * Quick View Script
 * ------------------------------------------------------------------------------
 *
 * Handles all logic related to quick view inside .product-card elements
 * Attaches click handler to `[data-quickview-trigger]` elements which are links pointing to the quickview template of a product.
 * If the quick view has been seen before, it will display it
 * If not, it will AJAX in the quick view, and *then* display it
 *
 * Requires:
 *  - jQuery
 *  - jQuery.imagesLoaded 
 *  - Modernizr (for Modernizr.csstransitions)
 *  - Slate (for slate.ProductDetailForm)
 */

slate.quickView = (function($, Modernizr, slate) {

  var $window = $(window);
  var $body = $(document.body)

  var selectors = {
    quickView: '[data-quick-view]',
    quickViewContentsBody: '[data-quick-view-contents-body]',
    quickViewClose: '[data-quick-view-close]',
    quickViewTrigger: '[data-quick-view-trigger]',
    productCardContents: '[data-product-card-contents]',
    productDetailForm: '[data-product-detail-form]',
    productImageThumbs: '[data-product-image-thumbs]'
  };

  var classes = {
    quickViewIsOpen: 'is-open',
    triggerLoading: 'is-loading'
  };

  function QuickViewsManager(quickViewConstructor) {
    this.name = 'quickViewsManager';
    this.quickViews = {};

    var isLoadingQuickView = false;

    this.register = function(id, qv) {
      if( !(qv instanceof quickViewConstructor) ) {
        console.warn('['+this.name+'] - instance of quickView required when calling register');
        return;
      }

      if(!this.quickViews.hasOwnProperty(id)) {
        this.quickViews[id] = qv;
      }

      return this;
    };

    this.getQuickViewByID = function(id) {
      return this.quickViews[id];
    };

    this.onResize = function() {
      $.each(this.quickViews, function(i, qv){
        qv.onResize();
      });
    };

    this.getOpenQuickViews = function() {
      var opens = [];

      $.each(this.quickViews, function(i, qv) {
        qv.isOpen() && opens.push(qv);
      });

      return opens;
    },

    this.closeOpenQuickViews = function(cb) {
      var opens = this.getOpenQuickViews();
      
      if(opens.length == 0 ) {
        cb();
      }
      else {
        $.each(opens, function(i, qv) {
          if(i == 0) {
            qv.$productCard.one('closed.quickView', cb);  
          }
          qv.close();
        });
      }

    };

    this.onQuickViewTriggerClick = function($trigger) {
      if($trigger == undefined) {
        return;
      }

      var quickViewsManager = this;
      var $productCard      = $trigger.parents('.product-card');
      var id                = $productCard.attr('id');
      var quickView         = this.getQuickViewByID(id);

      if(quickView == undefined) {

        if(isLoadingQuickView) return; // Return early, we're already fetching a quick view, sorry!
        
        isLoadingQuickView = true;
        $trigger.addClass(classes.triggerLoading);

        // generate a new QV
        quickView = new QuickView({
          $productCard: $productCard,
          url: $trigger.attr('href'),
          transitionDuration: slate.animations.getTransitionTimingDuration('slow'),
          transitionTimingFunction: slate.animations.getTransitionTimingFunction('inOutUI')
        });

        $productCard.one('loaded.quickView', function() {
          isLoadingQuickView = false;
          $trigger.removeClass(classes.triggerLoading);
          quickViewsManager.closeOpenQuickViews( quickView.open.bind(quickView) ); // Make sure all the QVs are closed before opening this new one        
        });

        quickViewsManager.register(id, quickView);
      }
      else {
        if(!quickView.isOpen()) {
          quickViewsManager.closeOpenQuickViews( quickView.open.bind(quickView) );  
        }
      }
    };

    $window.on('resize', $.throttle(50, this.onResize.bind(this)));

    return this;
  };

  /**
   * QuickView constructor
   *
   * @param { Object } settings
   * @param { HTMLElement | jQuery } settings.$productCard
   * @param { String } settings.url - URL pointing to the quick view of the product
   * @param { Function } settings.onProductDetailFormReady - Called after the product form is initialized.  `this` references the QuickView instance
   */
  function QuickView(options) {
    
    this.name = 'quickView';
    this.namespace = '.'+this.name;

    var self = this;
    var defaults = {
      onProductDetailFormReady: $.noop,
      transitionDuration: 1000,
      transitionTimingFunction: 'ease-in-out'      
    };

    this.settings = $.extend({}, defaults, options);

    if(typeof this.settings.$productCard == undefined) {
      console.warn('['+this.name+'] - $productCard element required to initialize');
      return;
    };

    if(typeof this.settings.url != "string" || this.settings.url.length == 0 || this.settings.url.indexOf('quick-view') == -1) {
      console.warn('['+this.name+'] - valid URL required to initialize');
      return;
    };

    // Elements we'll need for everything to work
    this.$productCard           = this.settings.$productCard;
    this.$productCardContents   = this.$productCard.find(selectors.productCardContents);
    this.$productCardThumbs     = this.$productCard.find(selectors.productImageThumbs);
    this.$productDetailForm     = null;
    this.$preOrderDatesJson     = null;
    this.$quickView             = null;
    this.$quickViewContentsBody = null;
    this.$close                 = null;

    this.stateIsOpen               = false;
    this.supportsCssTransitions    = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions;
    this.productDetailFormInstance = null

    // All events are trigger on the $productCard element
    this.events = {
      OPEN:   'open'   + this.namespace,
      OPENED: 'opened' + this.namespace,
      CLOSE:  'close'  + this.namespace,
      CLOSED: 'closed' + this.namespace,
      LOADED: 'loaded' + this.namespace
    };

    this.$productCard.on('click', selectors.quickViewClose, this.onCloseClick.bind(this));

    this.$productCard.height( this.$productCardContents.outerHeight(true) );
    //this.$productCardThumbs.height( this.$productCardThumbs.outerHeight(true) );


    // Initial ajax request to get the quick view content
    $.get(this.settings.url, this._onAjaxSuccess.bind(this));

    return this;
  };

  QuickView.prototype = {

    /**
     * Initial AJAX Call callback
     * Gets the returned HTML, adds it to the DOM, sets the instance's dom element variables, initializes the product detail form
     *
     */
    _onAjaxSuccess: function(ajaxResponse) {
      this.$productCard.append( $(ajaxResponse) );

      this.$preOrderDatesJson     = this.$productCard.find("#variants-with-pre-order");
      this.$productDetailForm     = this.$productCard.find(selectors.productDetailForm);
      this.$quickView             = this.$productCard.find(selectors.quickView);
      this.$quickViewContentsBody = this.$productCard.find(selectors.quickViewContentsBody);
      this.$close                 = this.$quickView.find(selectors.quickViewClose);

      eval(this.$preOrderDatesJson.html());

      this.$productDetailForm.on('ready.productDetailForm', this.onProductDetailFormReady.bind(this));
      

      var config = {
        $el: this.$productDetailForm,
        zoomEnabled: true,
        enableHistoryState: false
      };

      this.productDetailFormInstance = new slate.ProductDetailForm(config);
      this.productDetailFormInstance.initialize();

      // Fire off the loaded event once all the images in the quick view are loaded
      this.$quickView.imagesLoaded()
        .always( function() {
          var e = $.Event(this.events.LOADED);
          this.$productCard.trigger(e);          
        }.bind(this));   
    },

    /**
     * Called after the product detail form is done initializing
     */
    onProductDetailFormReady: function() {
      // this.onResize();
      this.settings.onProductDetailFormReady.call(this);
    },

    open: function() {
      
      this.onOpen();

      if(this.isOpen()) {
        return;
      }
      
      this.stateIsOpen = true;
      this.doOpenAnimation();
    },

    close: function() {
      
      this.onClose();

      if(this.isClosed()) {
        return;
      }

      this.stateIsOpen = false;
      this.doCloseAnimation();
    },

    isOpen: function() {
      return this.stateIsOpen;
    },

    isClosed: function() {
      return !this.isOpen();
    },

    /**
     * Called after this.open is called but before any opening animation has run
     */
    onOpen: function() {
      var e = $.Event(this.events.OPEN);
      this.$productCard.trigger(e);

      this.scrollToQuickView();
    },

    /**
     * Called after this.close is called but before any closing animation has run
     */
    onClose: function() {     
      var e = $.Event(this.events.CLOSE);
      this.$productCard.trigger(e);

      // this.scrollToProductCard();
    },

    /**
     * Called after the opening animation has run
     */
    onOpened: function() {      
      var e = $.Event(this.events.OPENED);
      this.$productCard.trigger(e);
    },

    /**
     * Called after the closing animation has run
     */
    onClosed: function() {
      var e = $.Event(this.events.CLOSED);
      this.$productCard.trigger(e);
      this.$quickView.removeClass(classes.quickViewIsOpen);
    },

    doOpenAnimation: function() {

      this.$quickView.addClass(classes.quickViewIsOpen);

      var productCardContentsHeight = this.$productCardContents.outerHeight(true);
      var qvHeight = this.$quickViewContentsBody.outerHeight(true);
      
      this.$productCard.height(productCardContentsHeight);
      this.$quickView.height(0);

      this.setTransitions();
      
      this.$productCard.height(productCardContentsHeight + qvHeight);
      this.$quickView.height(qvHeight);

      if(this.supportsCssTransitions) {
        this.$quickView.one(slate.utils.whichTransitionEnd(), this.onOpened.bind(this));
      }
      else {
        this.onOpened();
      }
    },

    doCloseAnimation: function() {

      this.stateIsOpen = false;
      
      var productCardContentsHeight = this.$productCardContents.outerHeight(true);

      this.$productCard.height(productCardContentsHeight);
      this.$quickView.height(0);

      if(this.supportsCssTransitions) {
        this.$quickView.one(slate.utils.whichTransitionEnd(), this.onClosed.bind(this));
      }
      else {
        this.onClosed();
      }
    },

    onResize: function() {

      var qvHeight = this.$quickViewContentsBody.outerHeight(true);
      var pccHeight = this.$productCardContents.outerHeight(true);

      if(this.isClosed()) {
        this.$productCard.height(pccHeight);
      }
      else {
        this.$productCard.height(pccHeight + qvHeight);
        this.$quickView.height(qvHeight);
      }
    },

    setTransitions: function() {
      var trans = 'height ' + this.settings.transitionDuration + 'ms ' + this.settings.transitionTimingFunction;
      this.$quickView.css( 'transition', trans);
      this.$productCard.css( 'transition', trans);
    },

    scrollToProductCard: function() {
      $('html, body').animate( { scrollTop : (this.$productCard.offset().top - 100) } );
    },
    scrollToQuickView: function() {
      $('html, body').animate( { scrollTop : (this.$quickView.offset().top - 100) } );
    },
    onCloseClick: function(e) {
      e.preventDefault();
      this.close();
    }
  };

  var quickViewsManager = new QuickViewsManager(QuickView);

  $(function() {
    $body.on('click', selectors.quickViewTrigger, function(e) {
      e.preventDefault();
      quickViewsManager.onQuickViewTriggerClick($(this));
    });
  });

}(jQuery, Modernizr, slate));
/**
 * Social Sharing
 * -----------------------------------------------------------------------------
 * Enables centered popup window when clicking on any share links (instead of standard "new tab" behavior)
 */

slate.socialSharing = (function() {

  var selectors = {
    socialSharing: '[data-social-sharing]'
  };

  var POPUP_WIDTH  = 550;
  var POPUP_HEIGHT = 450;

  function centerPopup(url, title) {
      // Fixes dual-screen position                         Most browsers      Firefox
      var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
      var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

      var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      var left = ((width / 2) - (POPUP_WIDTH / 2)) + dualScreenLeft;
      var top = ((height / 2) - (POPUP_HEIGHT / 2)) + dualScreenTop;
      var newWindow = window.open(url, title, 'scrollbars=yes, width=' + POPUP_WIDTH + ', height=' + POPUP_HEIGHT + ', top=' + top + ', left=' + left);

      // Puts focus on the newWindow
      if (window.focus) {
          newWindow.focus();
      }
  }

  $(function() {
    $(selectors.socialSharing).on('click', 'a', function(e) {
      e.preventDefault();

      centerPopup($(this).attr('href'), $(this).attr('title'), )
    });
  });

}());
/**
 * Video Cover
 * -----------------------------------------------------------------------------
 * Background videos - woohoo!
 * Right now this only supports Vimeo videos and uses their javascript API to control playback
 *
 */

slate.videoCover = (function($, Vimeo) {

  var $document = $(document);
  var $window   = $(window);

  var name = 'videoCover';
  var namespace = '.' + name;
  var baseClass = 'video-cover';
  var uniqueIdCount = 0;

  var selectors = {
    videoCover: '.video-cover[data-video-id][data-video-type]'
  };

  var classes = {
    playerLoaded: 'is-loaded',
  };

  var events = {
    RESIZE: 'resize' + namespace,
    LOAD: 'load' + namespace
  };

  var postResizeTimeout;

  // See http://codetheory.in/html5-fullscreen-background-video/ for more info on how this works
  // Resizes the video to make sure it fills the container
  function setSize($el) {
    var $video = $el.find('iframe');
 
    var w = parseInt($video.attr('width')).toFixed(2);
    var h = parseInt($video.attr('height')).toFixed(2);
     
    var videoRatio = (w / h).toFixed(2);
     
    var minW = $el.outerWidth();
    var minH = $el.outerHeight();
     
    var widthRatio  = minW / w;
    var heightRatio = minH / h;
     
    if (widthRatio > heightRatio) {
      var newWidth = minW;
      var newHeight = Math.ceil( newWidth / videoRatio );
    }
    else {
      var newHeight = minH;
      var newWidth = Math.ceil( newHeight * videoRatio );
    }

    var leftMarginToCenter = (minW - newWidth) / 2;
    var topMarginToCenter = (minH - newHeight) / 2;

    $video.css({
      'height': newHeight,
      'width' : newWidth,
      'margin-left': leftMarginToCenter,
      'margin-top' : topMarginToCenter
    });
  }

  function initializeVideoCover($el) {
    // Check if we've already made a player for this $el or we're on a mobile device
    if($el.children('iframe').length != 0 || /iPhone|iPod/.test(navigator.platform)) return;
    
    var player;
    var videoId   = $el.data('video-id');
    var videoType = $el.data('video-type');
    var uniqueId  = baseClass + '-' + videoId + '-' + uniqueIdCount++; // Construct a unique ID to use on the element

    if(videoId && videoType == "vimeo") {

      $el.attr('id', uniqueId);
      player = new Vimeo.Player(uniqueId, {
        id: videoId,
        loop: true,
        background: 1
      });

      player.on('loaded', function() {
        setSize($el);
        $el.addClass(classes.playerLoaded);
        this.play();
      });

    }
  }

  function onResize() {
    $(selectors.videoCover).each(function() {
      setSize($(this));
    });
  }

  function onLoad() {
    $(selectors.videoCover).each(function() {
      initializeVideoCover($(this));
    });  
  }

  $window.on(events.LOAD, onLoad);

  $window.on(events.RESIZE, $.throttle(50, function() {
    onResize();
    clearTimeout(postResizeTimeout);
    postResizeTimeout = setTimeout(onResize, 50); // Hit this one time *after* we're done with window resize events to make sure everything is good
  }));

  // Reinitialize video cover incase this gets used on a section
  $document.on('shopify:section:load', function(evt) {
    $(evt.target).find(selectors.videoCover).each(function() {
      initializeVideoCover($(this));
    });
  });

}(jQuery, Vimeo));
/**
 * Video Player Script
 * -----------------------------------------------------------------------------
 *
 * Creates a Video Player player out of basic markup
 * Requires some basic styling to make things work correctly - see components/video-player.scss
 *
 * Mark up looks like...
 * <div data-section-type="video-player">
 *   <div id="video-player-{{ yt_video_id }}" class="video-player" data-video-player data-video-id="{{ yt_video_id }}" data-video-type="vimeo / youtube" data-background="{{ true / false }}" data-embed-color="{{ hex_color }}">
 *     <div class="video-player__cover" data-video-player-cover>
 *       <div class="video-player__cover-still" style="background-image: url(...);"></div>
 *       <span class="video-player__cover-play">{% include 'icon-play-button' %}</span>
 *     </div>
 *     <div class="video-player__embed" data-video-player-embed></div>
 *   </div>
 * </div>
 *
 */

slate.models = slate.models || {};

slate.models.VideoPlayer = (function($) {
  
  var $body = $("body");

  var selectors = {
    videoPlayer: "[data-video-player]",
    videoPlayerEmbed: "[data-video-player-embed]",
    videoPlayerCover: "[data-video-player-cover]",
    videoPlayerStill: "[data-video-player-cover-still]",
    videoPlayerCoverTitle: "[data-video-player-cover-title]"
  };

  var classes = {
    state: {
      playing: "video-player--playing",
      ended: "video-player--ended",
      paused: "video-player--paused",
      buffering: "video-player--buffering"
    }
  };

  var VIDEO_TYPES = {
    VIMEO: "vimeo",
    YOUTUBE: "youtube"
  };

  var dataKey = "video-player-instance";

  /**
   * videoPlayer constructor
   *
   * @param {HTMLElement | $} el - Element containing required markup.  All settings are passed as data attributes on this element
   */

  function VideoPlayer(el) {
    this.name = "videoPlayer";
    this.namespace = "." + this.name + "";

    this.$el = $(el);

    if (!this.$el.is(selectors.videoPlayer)) {
      console.warn(
        "[" +
          this.name +
          "] - Element matching " +
          selectors.videoPlayer +
          " required to initialize"
      );
      return;
    }

    this.player = null;
    this.state = null;
    this.type = this.$el.data("video-type");
    this.id = this.$el.data("video-id");
    this.background = this.$el.data("background");
    this.controls = this.$el.data("controls") == 0 ? 0 : 1;
    this.autoplay = this.$el.data("autoplay");
    this.muted = this.$el.data("muted");
    this.embedColor = this.$el.data("embed-color") || "000";
    this.height = this.$el.data("video-height");
    this.width = this.$el.data("video-width");

    if (
      !this.id ||
      !(this.type === VIDEO_TYPES.VIMEO || this.type === VIDEO_TYPES.YOUTUBE)
    ) {
      console.warn(
        `[${this.name}] - Video ID and valid video type required to initialize`
      );
      return;
    }

    this.$embed = this.$el.find(selectors.videoPlayerEmbed);
    this.$cover = this.$el.find(selectors.videoPlayerCover);

    // These bind functions create a player from their respective JS libraries
    // and add a click handlers on the cover
    if (this.type === VIDEO_TYPES.VIMEO) {
      this.bindVimeoPlayer();
    } else if (this.type === VIDEO_TYPES.YOUTUBE) {
      this.bindYouTubePlayer();
    }

    if (this.$cover) {
      this.initVideoCover();
    }
  }

  VideoPlayer.prototype = {
    bindVimeoPlayer: function() {
      const opts = {
        id: this.id,
        color: this.embedColor.replace("#", "")
      };

      opts.background = this.background || false;
      opts.muted = this.muted || false;
      opts.controls = this.controls || false;
      opts.autoplay = this.autoplay || false;
      opts.height = this.height || null;
      opts.width = this.width || null;

      this.player = new Vimeo.Player(this.$embed, opts);

      this.player.on("ended", this.onEnded.bind(this));
      this.player.on("play", this.onPlay.bind(this));
      this.player.on("pause", this.onPaused.bind(this));
      this.player.on("bufferstart", this.onBuffering.bind(this));

      if (this.background && this.$cover.length) {
        this.$cover.remove();
        this.$cover = null;
      } else {
        this.$cover.on("pointerdown", this.onCoverPointerDown.bind(this));
      }
    },

    bindYouTubePlayer: function() {
      var self = this;

      function createPlayer() {
        var uniqID = `${this.$el.attr("id")}-player`;
        this.$embed.attr({
          sandbox: "allow-same-origin allow-scripts allow-presentation",
          id: uniqID,
          frameborder: 0
        });

        this.player = new window.YT.Player(uniqID, {
          videoId: this.id,
          width: this.width || null,
          height: this.height || null,
          playerVars: {
            rel: 0,
            autohide: 1,
            controls: this.controls,
            playsinline: 1,
            modestbranding: 1,
            wmode: "transparent",
            autoplay: this.autoplay
          },
          events: {
            onReady: function(e) {
              // this.$cover.on('click', this.onCoverClick.bind(this));
            },
            onStateChange: function(e) {
              switch (e.data) {
                case window.YT.PlayerState.PLAYING:
                  self.onPlay();
                  break;
                case window.YT.PlayerState.PAUSED:
                  self.onPaused();
                  break;
                case window.YT.PlayerState.ENDED:
                  self.onEnded();
                  break;
                case window.YT.PlayerState.BUFFERING:
                  self.onBuffering();
                  break;
              }
            }
          }
        });
      }

      var _createPlayer = createPlayer.bind(this);

      // If YT player doesn't exist, we need to keep track of any players that try to initialize before it loads.
      if (window.YT === undefined) {
        if (window.YT_PLAYERS_TO_LOAD) {
          window.YT_PLAYERS_TO_LOAD.push(_createPlayer);
        } else {
          window.YT_PLAYERS_TO_LOAD = [_createPlayer];

          // Once the YT API is ready, we can load each of the players in the queue.
          window.onYouTubeIframeAPIReady = function() {
            window.YT_PLAYERS_TO_LOAD.forEach(function(createPlayer) {
              createPlayer();
            });
          };

          var tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";

          var firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
      } else {
        _createPlayer();
      }
    },

    initVideoCover: function() {
      var self = this;

      // Bind pointer events
      this.$cover.on("pointerdown", this.onCoverPointerDown.bind(this));

      // If the cover doesn't have a bg image, we'll fetch it
      this.$coverStill = $(selectors.videoPlayerStill, this.$cover);
      this.$coverTitle = $(selectors.videoPlayerCoverTitle, this.$cover);
      if (
        this.$coverStill.length &&
        this.$coverStill.css("background-image") == "none"
      ) {
        this.fetchVideoThumbnail().then(function(image) {
          self.$coverStill.css("background-image", "url(" + image + ")");
        });
      }

      if (this.$coverTitle.length && !this.$coverTitle.text()) {
        this.fetchVideoData().then(function(data) {
          if (data.title) {
            self.$coverTitle.html(data.title);
          } else {
            self.$coverTitle.remove();
          }
        });
      }
    },

    /**
     * Method to fetch the video data over the oembed standard.
     *
     * @return {Promise}
     */
    fetchVideoData: function() {
      var self = this;
      var promise = $.Deferred();

      if (this.videoData) {
        promise.resolve(this.videoData);
      }

      // YT apparently has CORS blockers on their oembed stuff, so using noembed to get around it.
      if (this.type == "youtube") {
        $.get(
          "http://noembed.com/embed?url=https://www.youtube.com/watch?v=" +
            this.id
        ).then(function(data) {
          promise.resolve(JSON.parse(data));
        });
      } else if (this.type == "vimeo") {
        $.get(
          "https://vimeo.com/api/oembed.json?url=https://vimeo.com/" + this.id
        ).then(function(data) {
          self.videoData = data;
          promise.resolve(data);
        });
      }

      return promise;
    },

    /**
     * Method to fetch the video thumbnail.
     *
     * @return {Promise}
     */
    fetchVideoThumbnail: function() {
      var promise = $.Deferred();

      if (this.type == "youtube") {
        var imgUrl =
          "https://img.youtube.com/vi/" + this.id + "/maxresdefault.jpg";
        promise.resolve(imgUrl);
      } else if (this.type == "vimeo") {
        $.get(
          "http://vimeo.com/api/v2/video/" +
            this.id +
            ".json?callback=showThumb"
        ).then(function(data) {
          promise.resolve(data.thumbnail_large);
        });
      }

      return promise;
    },

    switchToState: function(state) {
      this.$el.removeClass(classes.state[this.state]);
      this.$el.addClass(classes.state[state]);

      this.$el.parents('.video-module').removeClass(classes.state[this.state]);
      this.$el.parents('.video-module').addClass(classes.state[state]);
      this.state = state;
    },

    play: function() {
      if (this.type === VIDEO_TYPES.YOUTUBE) {
        this.player.playVideo();
        this.onPlay();
      } else if (this.type === VIDEO_TYPES.VIMEO) {
        this.player.play();
      }
    },

    pause: function() {
      if (this.type === VIDEO_TYPES.YOUTUBE) {
        this.player.pauseVideo();
        this.onPaused();
      } else if (this.type === VIDEO_TYPES.VIMEO) {
        this.player.pause().then(this.onPaused.bind(this));
      }
    },

    togglePlay: function() {
      if (this.state == "playing") {
        this.pause();
      } else {
        this.play();
      }
    },

    onPlay: function() {
      this.switchToState("playing");
    },

    onEnded: function() {
      this.switchToState("ended");
    },

    onPaused: function() {
      this.switchToState("paused");
    },

    onBuffering: function() {
      this.switchToState("buffering");
    },

    // Since the videos can be used in slideshows, we're differentiating between clicks and moves.
    onCoverPointerDown: function(e) {
      this.xStart = e.clientX;

      function detectDrag(e) {
        // anything under 50px of lateral movement gets treated as a click.
        var dragThreshold = 50;
        if (e.type === "pointerup") {
          if (Math.abs(e.clientX - this.xStart) < dragThreshold) {
            this.togglePlay();
          }
          $body.off("pointerup.videoPlayer");
        }
      }
      $body.one("pointerup.videoPlayer", detectDrag.bind(this));
    },

    ensure: function(el) {
      let $el = $(el);

      if (!$el.is(selectors.videoPlayer)) {
        $el = $el.parents(selectors.videoPlayer);
      }

      let data = $el.data(dataKey);

      if (!data) {
        $el.data(dataKey, (data = new VideoPlayer($el)));
      }

      return data;
    },

    refresh: function($container) {
      $(selectors.videoPlayer, $container).each(function(i, el) {
        VideoPlayer.ensure(el);
      });
    },

    getDataKey: function() {
      return dataKey;
    }
  };

  return VideoPlayer;
})(jQuery);
/**
 * Flickity
 * ------------------------------------------------------------------------------
 *
 * This wrapper is not required to use flickity and you can use out of the box
 * This is a good place to decorate flickity functionality if needed
 *
 * Put here any flickity functionality that you repeatedly use in templates/sections/components
 *
 * When initializing Flickity manually do not use `data-flickity` attibute,
 * This is default flickity's attibute and flickity will initialize it for you automatically
 *
 * A lot of good stuff comes from the box, so check it first:
 * https://flickity.metafizzy.co/options.html
 *
 * Custom arrows:
 * Flickity can consume SVG path string to draw custom arrows
 * https://flickity.metafizzy.co/options.html#arrowshape
 *
 * Accesibility:
 * When flickity is focused, by default users can navigate the carousel with their keyboard.
 *
 *
 * CUSTOM OPTIONS enhancing Flicity functionality:
 * - `pagerNav`  - initializes Flickity with a pager navigation, that shows an active slide index
 * - `initOnOverflow` - { boolean } - initalizes Flickity when items overflow the carousel
 * - `breakpoint` - { number } - initializes Flickity below a certain breakpoint
 * - `numberOfSlides`: { number } - initializes Flickity when there is more than provided # of slides
 * - `fadingEdges`: { boolean } - adds modifier class to have overlay gradients on the carousel edges
 *
 * TODO logging for missing elements
 * TODO `numberOfSlides` is not tested
 *
 * @namespace - flickity
 */

slate.models = slate.models || {};

slate.models.Flickity = (function($, utils) {
  var navigationTemplate =
    '\
    <div class="flickity__nav visible-xs visible-sm"  data-carousel-nav>\
      <span data-carousel-nav-current-index>01</span>/<span>{productsCount}</span>\
    </div>';

  var selectors = {
    carouselSlideIndex: "[data-carousel-nav-current-index]",
    carouselNav: "[data-carousel-nav]"
  };

  // Flag to enable/disable the iOS bugfix.  Only enables itself when iOS is detected
  var iosBugfixEnabled = true;

  function Flickity($el, options) {
		this.$carousel = $el;
    this.$slides = $el.children();
    this.initialNumberOfSlides = this.$slides.length;

    this.options = options;
    this.flickity = null;
  }

  Flickity.prototype = $.extend({}, Flickity.prototype, {
    init: function() {
      if (this.flickity) {
        return;
      }

      if (this.options.fadingEdges) {
        this.$carousel.addClass(classes.fadingEdges);
      }

      // Assemble conditionals into array.
      var predicates = [],
        initFlickityConditionally;

      if (this.options.breakpoint) {
        predicates.push(this.belowBreakpoint.bind(this));
      }

      if (this.options.initOnOverflow) {
        predicates.push(this.carouselHasOverflow.bind(this));
      }

      if (this.options.numberOfSlides) {
        predicates.push(
          this.moreThanNumberOfSlides.bind(this, this.options.numberOfSlides)
        );
      }

      if (predicates.length) {
        if (predicates.length == 1) {
          initFlickityConditionally = this.flickityToggle(predicates[0]);
        } else {
          initFlickityConditionally = this.flickityToggle(predicates);
        }
        $(window).on("resize", $.debounce(200, initFlickityConditionally));
        initFlickityConditionally();
      } else {
        this.initFlickity();
      }

      if (this.options.pagerNav) {
        this.initNav();
      }
    },

    initNav: function() {
      if (this.flickity) {
        var max = this.flickity.slides.length;
        max = max < 10 ? "0" + max : max;
        this.$nav = $(navigationTemplate.replace("{productsCount}", max));

        this.$carousel.append(this.$nav);
        this.$carousel.on(
          "change.flickity",
          this.changeNavCurrentIndex.bind(this)
        );
      }
    },

    changeNavCurrentIndex: function(event, index) {
      var count = index + 1;
      count = count < 10 ? "0" + count : count;
      this.$nav.find(selectors.carouselSlideIndex).text(count);
    },

    /**
     *
     * This is a plain method that initializes flickity
     * Do not add any enhacing flickity logic here
     * Since this function executes on callbacks
     *
     */
    initFlickity: function() {
      if (!this.flickity) {

        this.$carousel.flickity(this.options);
        this.flickity = this.$carousel.data("flickity");

        if (iosBugfixEnabled) {
          // Didnt wanna make these methods/muddy up the model, so inlining the function declarations to easily remove them later.
          this.$carousel.on("touchstart.iosbugfix", function(e) {
            startX = e.touches[0].clientX;
          });

          this.$carousel.on("touchmove.iosbugfix", function(e) {
            if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
              e.preventDefault();
            }
          });
        }
      }
    },

    destroy: function() {
      if (this.flickity) {
        if (this.options.pagerNav && this.$nav && this.$nav.length) {
          this.$nav.remove(); //remove pagerNav
        }

        this.$carousel.flickity("destroy");
        this.flickity = null;

        if (iosBugfixEnabled) {
          this.$carousel.off("touchstart.iosbugfix");
          this.$carousel.off("touchmove.iosbugfix");
        }
      }
    },

    getFlickityInstance: function() {
      return this.flickity;
    },

    resize: function() {
      if (this.$carousel && this.$carousel.length) {
        this.$carousel.flickity("resize");
      }
    },

    /**
     * If flickity is initialized,
     * Scrolls to a slide by index
     * @param { Number} slideIndex
     * @param { Boolean } isWrapped - optional. If true, the first slide will be selected if at the last slide.
     * @param { isInstant } isInstant - optional. If true, immediately view the selected slide without animation.
     */
    selectSlide: function(slideIndex, isWrapped, isInstant) {
      if (this.flickity) {
        this.$carousel.flickity("select", slideIndex, isWrapped, isInstant);
      }
    },

    /**
     *
     * @param { function, array } predicate - function or array of functions that checks a condition for flickity to be initialized
     *
     * @returns { function } - flickity toggl-er function
     */
    flickityToggle: function(predicate) {
      var self = this;

      // Bail if predicate isn't a function or an array of functions.
      if (typeof predicate !== "function" && !Array.isArray(predicate)) {
        return $.noop;
      }

      if (
        Array.isArray(predicate) &&
        predicate.some(function(f) {
          return typeof f !== "function";
        })
      ) {
        return $.noop;
      }

      if (typeof predicate == "function") {
        var verifyPredicate = predicate;
      } else {
        var verifyPredicate = function() {
          return predicate.every(function(f) {
            return f();
          });
        };
      }

      return function() {
        if (verifyPredicate()) {
          self.initFlickity();
        } else {
          self.destroy();
        }
      };
		},
		
    /////// Predicates used to initialize flickity
    belowBreakpoint: function() {
      var bp = this.options.breakpoint;
      if (!bp || !$.isNumeric(bp)) {
        return false;
      }
      return utils.getViewportWidth() < bp;
    },

    carouselHasOverflow: function() {
      var $slidesToCheck = this.$slides;
      return utils.childrenLargerThanParent(this.$carousel, $slidesToCheck);
    },

    moreThanNumberOfSlides: function(numberOfSlides) {
      return this.$slides.length > numberOfSlides;
    },

    /**
     * Method that can toggle the 'draggable' property on/off.  Note, not all properties have this ability. Originally seen here:
     * https://codepen.io/desandro/pen/xZWqWM/
     */
    toggleDraggable: function() {
      if (this.flickity) {
        this.flickity.options.draggable = !this.flickity.options.draggable;
        this.flickity.updateDraggable();
      }
    }
  });

  return Flickity;
})(jQuery, slate.utils);


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 * Uses slate.ProductDetailForm to handle core product form functionality.
 *
 * - Attaches the `Product` constructor to window.theme.Product.
 *
 * Requires:
 *  - jQuery
 *  - jQuery.fn.zoom - http://www.jacklmoore.com/zoom/
 *  - Slate
 *
 * See:
 * - product.liquid
 * - product-detail-form.liquid
 * - product-detail-gallery-new.liquid
 * - product-detail-merch-mosaic.liquid
 *
 * @namespace product
 */

theme.Product = (function($, slate) {

  var selectors = {
    header: '[data-header]',
    headerProductBar: '[data-header-product-bar]',
    headerProductBarFormSlot: '[data-header-product-bar-form-slot]',
    addToCartForm: '[data-add-to-cart-form]',
    addToCartFormWrapper: '[data-add-to-cart-form-wrapper]',
    productMosaic: '[data-product-mosaic]',
    yotpoSummaryTarget: '[data-product-yotpo-summary-target]',
    yotpoNoReviews: '.yotpo-no-reviews',
    productInseamSelector: '#SingleOptionSelector-2',
    isSurfRanchProduct: '[data-surf-ranch-product]'
  };

  var classes = {
    headerProductBarVisible: 'is-visible',
    productInseamAvailable: 'has-inseam'
  };

  var $window   = $(window);
  var $document = $(document);
  var $header   = $(selectors.header);

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    this.settings = {};
    this.name = 'product';
    this.namespace = '.'+this.name;

    this.events = {
      RESIZE: 'resize'  + this.namespace,
      CLICK: 'click'   + this.namespace,
      SCROLL: 'scroll' + this.namespace
    };

    var productDetailForm = new slate.ProductDetailForm({
      $el: this.$container,
      $container: $document, // hmm this is confusing
      enableHistoryState: this.$container.data('enable-history-state') || false,
      enableZoom: this.$container.data('zoom-enabled') || false
    });

    productDetailForm.initialize();
    
    //redirect the user to the login page if they have not logged in and it's a surf ranch product
    if(this.$container.data('surf-ranch-product') == true && slate.user.getCookieValue('_ok_canAccessSurfRanchPrivateSale') == undefined) {
      window.location.replace("/pages/surf-ranch-shop-login");
    }
    
    if(this.$container.data('surf-ranch-product') == true){
      $("body").addClass("is-surf-ranch-product")
    }

    this.formIsSticky = false;
    this.stickyFormMinBreakpoint = slate.breakpoints.getBreakpointMinWidth('sm');
    this.isBelowStickyFormMinBreakpoint = false;

    this.$addToCartFormWrapper = $(selectors.addToCartFormWrapper);

    this.initMosaics();

    $document.on(this.events.SCROLL, $.throttle(50, requestAnimationFrame.bind(window, this.onScroll.bind(this)))); // throttle + rAF = smooth scrolling :)
    $document.on(this.events.RESIZE, $.throttle(100, this.onResize.bind(this)));

    // hit these one time on init to make sure everything is good
    this.onScroll();
    this.onResize();


    var observer;
    var $yotpoSummaryTarget = $(selectors.yotpoSummaryTarget, this.$container);

    // If the setting to hide the review summary when there are no reviews is turned *on*
    if(this.$container.data('hide-reviews-summary-for-no-reviews')) {
      
      // Hide the summary by default and then *only* show it if we have reviews
      $yotpoSummaryTarget.hide();

      if($yotpoSummaryTarget.length && window.MutationObserver) {
        
        // YOTPO doesn't give us a 'ready' event to hook into so we have to watch for attribute changes on the target element... *sigh*
        observer = new MutationObserver(function(mutationList){

          // This is terrible but yotpo doesn't give us an easy way to find review count
          if($(selectors.yotpoNoReviews, this.$container).length == 0 || $yotpoSummaryTarget.find('[class*="empty-star"]').length != 5) {
            $yotpoSummaryTarget.show();
          }
          this.disconnect();
        });

        observer.observe($yotpoSummaryTarget.get(0), { attributes: true });
        observer.disconnect();
      }
    }

  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Intializes merchandising mosaic on product & product variant basis, and toggles mosaic
     * visibility on variantChange
     */
    initMosaics: function() {
      var self = this;
      var $mosaics = $(selectors.productMosaic);

       // Variant change callback.
      // Look for a gallery matching one of the selected variant's options and switch to that gallery
      $document.on('variantChange', function(e) {
        var variant = e.variant;

        if (variant) {
          if ($mosaics.length > 1) {
            for (var i = 3; i >= 1; i--) {
              var option = variant['option' + i];
              var $mosaicGallery = $mosaics.filter(function() {
                return $(this).data('variant-mosaic') == option;
              });

              if ($mosaicGallery.length && $mosaicGallery.hasClass('hide')) {
                $mosaics.not($mosaicGallery).addClass('hide');
                $mosaicGallery.removeClass('hide');
              }
            }
          }
        }

      });
    },

    /**
     * Sticks the product form into and displays the header product bar
     *
     */
    stickAddToCartForm: function() {
      if(this.formIsSticky == false) {
        $(selectors.addToCartFormWrapper).css('height', $(selectors.addToCartForm).outerHeight());
        $(selectors.addToCartForm).fadeOut(10, function(){
          $(this).detach().appendTo(selectors.headerProductBarFormSlot);
          $(selectors.headerProductBar).addClass(classes.headerProductBarVisible);
          
          if($(selectors.productInseamSelector).length) {
            $(selectors.headerProductBar).addClass(classes.productInseamAvailable);            
          }
          $(this).fadeIn(150);
        });
        this.formIsSticky = true;
      }
    },

    /**
     * Removes the product form from the header product bar and hides the bar.
     *
     */
    unstickAddToCartForm: function() {
      if(this.formIsSticky == true) {
        // Un stick it
        $(selectors.headerProductBar).removeClass(classes.headerProductBarVisible);
        $(selectors.headerProductBar).removeClass(classes.productInseamAvailable);

        $(selectors.addToCartForm).fadeOut(10, function(){
          $(this).detach().appendTo(selectors.addToCartFormWrapper);
          $(selectors.addToCartFormWrapper).css('height', '');
          $(this).fadeIn(150);
        });
        this.formIsSticky = false;
      }
    },

    /**
     * Checks the window size and scroll position to determine if the product form should be stuck or unstuck from the header
     *
     */
    stickyAddToCartFormCheck: function() {
      if(this.isAboveStickyFormMinBreakpoint) {
        $window.scrollTop() > (this.$addToCartFormWrapper.offset()['top'] - $header.outerHeight()) ? this.stickAddToCartForm() : this.unstickAddToCartForm();
      }
      else {
        this.unstickAddToCartForm();
      }
    },

    onScroll: function(e) {
      this.stickyAddToCartFormCheck();
    },

    onResize: function() {
      this.isAboveStickyFormMinBreakpoint = ( $window.width() >= this.stickyFormMinBreakpoint );
      this.stickyAddToCartFormCheck();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      $(selectors.headerProductBarFormSlot).empty(); // Since we're moving the form *outside* of the section, we need to make sure we reset the form when we unload
      this.$container.off(this.namespace);
    }
  });

  return Product;
})(jQuery, slate);

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

 theme.Collection = (function(slate) {

  var $window = $(window);

  var selectors = {
    collectionJson: '[data-collection-json]',
    filters: '[data-filters]',
    filterTags: '[data-filter-type][data-filter-tags]',
    productGrid: '.product-grid',
    productGridItem: '.product-grid__item',
    productGridItemProduct: '[data-product-grid-product]',
    productGridItemContentBlock: '[data-product-grid-content-block]',
    productCard: '.product-card',
    productCardGallery: '[data-product-card-gallery]',
    productCardMainLazy: '[data-product-card-main-lazy]',
    collectionProductCount: '[data-collection-product-count]',
    collectionProductCountLabel: '[data-collection-product-count-label]',
    collectionFilterEmpty: '[data-collection-filter-empty]',
    filterControlsToggle: '[data-filter-controls-toggle]',
    filterControls: '[data-filter-controls]',
    clearAllFilters: '[data-clear-all-filters]',
    currentFiltersSlot: '[data-current-filters-slot]',
    currentFiltersSlotMobile: '[data-current-filters-slot-mobile]',
    mobileFiltersDrawer: '[data-mobile-filters-drawer]',
    mobileFiltersEmpty: '[data-mobile-filters-empty]',
    contentBlockStore: '[data-content-block-store]',
    collectionFilterSticky: '[data-collection-filter-bar-sticky]',
    header: '[data-header]',
    showFilter: '[data-show-filter]',
    hideFilter: '[data-hide-filter]',
    productGridContainer: '[data-product-grid-container]'
  };

  var classes = {
    filterActive: 'is-active',
    filterControlsOpen: 'is-open'
  };

  /**
   * TagFilter constructor.
   *
   * @param {String} type - Filter type (ex. "color", "size")
   * @param {String} value - Filter Value (ex. "color-blue", "size-small")
   * @param {String} title - Display title (ex. "Blue", "Extra Large")
   * @param {String} html - outerHTML of the filter, used to recontruct it if necessary (tags can come in tags or dots (or anything really?))
   * @param {Bool} active - You can specify that the filter is active when you construct it
   */
  function TagFilter(type, value, title, html, active) {
    if(!type || !value) {
      return;
    }

    this.type   = type;
    this.value  = value;
    this.title  = title;
    this.html   = html;
    this.active = active || false;

    return this;
  };

  TagFilter.prototype = {
    activate: function() {
      this.active = true;
      return this;
    },

    deactivate: function() {
      this.active = false;
      return this;
    }
  };

  /**
   * TagFilterController constructor.
   * - Manages the tag filters applied to the collection page.
   * - All modifications to / queries for filters should go through this guy
   *
   */
  function TagFilterController() {

    this.name = 'tagFilterController';
    this.tagFilters = [];

    /**
     * Constructs an object of tag filter data to be consumed by other functions inside this controller
     *
     * @return {Object} obj
     * @return {Array}  obj.types
     * @return {Array}  obj.activeTypes
     * @return {Array}  obj.values
     * @return {Array}  obj.activeValues
     * @return {Object} obj.filtersForType
     */
    this._getTagFilterData = function() {
      var data = {
        types: [],
        activeTypes: [],
        actives: [],
        values: [],
        activeValues: [],
        filtersForType: {}
      };

      for (var i = this.tagFilters.length - 1; i >= 0; i--) {
        var tf   = this.tagFilters[i];
        var val  = tf.value;
        var type = tf.type;
        
        // Update data.types
        if(data.types.indexOf(type) == -1) {
          data.types.push(type);
        }
        
        // Update data.values
        if(data.values.indexOf(val) == -1) {
          data.values.push(val);
        }
        
        // Update data.filtersForType
        if(!data.filtersForType.hasOwnProperty(type)) {
          data.filtersForType[type] = [];
        }

        data.filtersForType[type].push(tf);

        // Update data.actives / data.activeTypes / data.activeValues
        if(tf.active) {
          data.actives.push(tf);
          if(data.activeTypes.indexOf(type) == -1) {
            data.activeTypes.push(type);
          }
          if(data.activeValues.indexOf(val) == -1) {
            data.activeValues.push(val);
          }
        }

      }

      return data;
    },

    /**
     * Register an instance of a TagFilter
     *
     * @param {TagFilter} tagFilter
     */
    this.registerTagFilter = function(tagFilter) {    
      this.tagFilters.push(tagFilter);
    };

    this.activateTagFilterByValue = function(val) {
      // console.log('['+this.name+'] ActivateTagFilterByValue - ' + val);
      var tf = this.getTagFilterByValue(val);

      if(tf) {
        tf.activate();
      }
    };

    this.deactivateTagFilterByValue = function(val) {
      // console.log('['+this.name+'] DeactivateTagFilterByValue - ' + val);
      var tf = this.getTagFilterByValue(val);

      if(tf) {
        tf.deactivate();
      }
    };

    this.toggleFilterByValue = function(val){
      var tf = this.getTagFilterByValue(val);
      if(tf) {
        tf.active ? tf.deactivate() : tf.activate();
      }
    };

    this.deactivateAllFilters = function() {
      $.each(this.getActiveTagFilters(), function(i, tf){
        tf.deactivate();
      });
    }

    this.getTagFilterTypes = function() {
      return this._getTagFilterData().types;
    };

    this.getActiveTagFilterTypes = function() {
      return this._getTagFilterData().activeTypes;
    };

    this.getActiveTagFilterValues = function() {
      return this._getTagFilterData().activeValues;
    };

    this.getTagFiltersForType = function(type) {
      var filterData = this._getTagFilterData();

      return filterData.filtersForType.hasOwnProperty(type) ? filterData.filtersForType[type] : [];
    };

    this.getActiveTagFilters = function() {
     return this._getTagFilterData().actives;
    };

    this.getActiveTagFiltersForType = function(type) {
      var tfs = this.getTagFiltersForType(type);

      return tfs.filter(function(f) { return f.active; });
    };

    this.getTagFilterByValue = function(val) {
      for (var i = this.tagFilters.length - 1; i >= 0; i--) {
        var tf = this.tagFilters[i];
        if(tf.value == val) {
          return tf;
        }
      }
    };

    this.getTagFilters = function() {
      return this.tagFilters;
    };
  };
  

  /**
   * Collection section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Collection(container) {
    var self = this;

    this.$container = $(container);

    this.name = 'collection';
    this.namespace = '.'+this.name;

    // Stop parsing if we don't have the collection json script tag
    if (!$(selectors.collectionJson, this.$container).html()) {
      console.warn('['+this.name+'] - Element matching ' + selectors.collectionJson + ' required.')
      return;
    }

    this.queryStringFilterParamKey      = 'applied_filters';
    this.$productGrid                   = $(selectors.productGrid, this.$container);
    this.$collectionProductCount        = $(selectors.collectionProductCount, this.$container);
    this.$collectionProductCountLabel   = $(selectors.collectionProductCountLabel, this.$container);
    this.$filterTags                    = $(selectors.filterTags, this.$container);
    this.collectionData                 = JSON.parse($(selectors.collectionJson, this.$container).html()); // Might not need this?
    this.mobileBreakpoint               = slate.breakpoints.getBreakpointMinWidth('sm');

    this.sort                           = new slate.collectionSort( container, this.collectionData );
    this.tagFilterController            = new TagFilterController();
    this.mobileFilterDrawer             = new slate.Drawer( $(selectors.mobileFiltersDrawer, this.$container) );

    // Register all the tag filters
    $(selectors.filterTags).each(function() {

      var $ft   = $(this);
      var type  = $ft.data('filter-type');
      var title = $ft.attr('title') && $ft.attr('title').length ? $ft.attr('title') : $ft.text();
      var tags  = $ft.data('filter-tags').split(" "); // Handle single filterElements that map to multiple tags (space separated)

      $.each(tags, function(i, value) {
        self.tagFilterController.registerTagFilter( new TagFilter(type, value, title, $ft.prop('outerHTML')) );
      });
    });

    // When we load the page, check for filter tag parameters in the URL
    var queryParams = slate.utils.getQueryParams();
    var queryParamFilters = [];

    if(queryParams.hasOwnProperty(this.queryStringFilterParamKey) && queryParams[ this.queryStringFilterParamKey ].length) {
      
      queryParamFilters = decodeURIComponent(queryParams[ this.queryStringFilterParamKey ]).split('+');

      $.each(queryParamFilters, function(i, param) {
        self.tagFilterController.activateTagFilterByValue(param);
      });
    }

    // Unveil plugin to lazy load main product card images
    $(selectors.productCardMainLazy, this.$container).unveil(200, function() {
      var $img = $(this);
      $img.on('load', function() {
        $img.parents(selectors.productCardGallery).addClass('is-loaded');
      });
    });

    // Add any event handlers
    this.$container.on('click', selectors.filterTags, this.onFilterTagsClick.bind(this));
    this.$container.on('click', selectors.clearAllFilters, this.onClearAllFiltersClick.bind(this));
    this.$container.on('click', selectors.filterControlsToggle, this.onFilterControlsToggleClick.bind(this));
    $window.on('resize', $.throttle(20, this.onResize.bind(this)) );
    $window.on('breakpointChange', this.onBreakPointChange.bind(this)); // see slate.breakpoints;

    if(Flow) {
      Flow.set('on', 'ready', this._clearFlowRestrictedProducts.bind(this));
    }  

    // If we have any active filters, hide all the content, apply the filters + place content blocks, and then fade in the content
    if(this.tagFilterController.getActiveTagFilters().length) {
      this.fadeOutProductGrid(function() {
        self.placeContentBlocks();
        self.applyTagFilters();
      }, 10);
    }
    // Otherwise, just worry about placing the content blocks
    else {
      this.placeContentBlocks();
    }

    // If someone clicks a product from this collection page and then clicks "back" in their browser, they will be returned the scroll position they clicked or scrolled from
    var pathName = document.location.pathname;
    
    window.onbeforeunload = function () {
      var scrollPosition = $(document).scrollTop();
      sessionStorage.setItem("scrollPosition_" + pathName, scrollPosition.toString());
    }

    if (sessionStorage["scrollPosition_" + pathName]) {
      $(document).scrollTop(sessionStorage.getItem("scrollPosition_" + pathName));
    }

    $(function() {
      var filterTopOffset = $(selectors.collectionFilterSticky, this.$container).offset().top;

      if(!$(selectors.collectionFilterSticky, this.$container).hasClass('affix-top') && filterTopOffset > 465) {
        var backHeaderHeight = $(selectors.header, this.$container).outerHeight();
        $(selectors.collectionFilterSticky, this.$container).animate({ top: backHeaderHeight + 20 });
      }

      $(selectors.collectionFilterSticky, this.$container).affix({ 
        offset: { 
            top: 150,
            bottom: 30
          } 
      });

      $(selectors.collectionFilterSticky, this.$container).on('affix.bs.affix', function() {
        var headerHeight = $(selectors.header, this.$container).outerHeight();
        $(this).animate({ top: headerHeight + 20 });
      });

      $(selectors.collectionFilterSticky, this.$container).on('affix-top.bs.affix', function() { 
        $(this).animate({ top: 440 });
      });
      
      $(selectors.showFilter, this.$container).on('click', function() {
        $(selectors.productGridContainer, this.$container).animate({ width:'75%' }, 300);
        $(selectors.collectionFilterSticky, this.$container).css('visibility', 'visible').animate({opacity: 1.0}, 500);
        $(selectors.showFilter, this.$container).hide();
      });

      $(selectors.hideFilter, this.$container).on('click', function() {
        $(selectors.collectionFilterSticky, this.$container).css('visibility', 'hidden').animate({opacity: 0.0}, 400);
        $(selectors.productGridContainer, this.$container).animate({ width:'100%' }, 500);
        $(selectors.showFilter, this.$container).show();
      });
    });
  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    /**
     * Removes products from the page that are flagged as "excluded" or "restricted" by Flow.
     *
     */
    _clearFlowRestrictedProducts: function() {
      if(window.Flow) {
        var removedProductCount = 0;
        var experienceKey = Flow.getExperience();
        var productCount  = parseInt(this.$collectionProductCount.text());
        var flowVariants  = Flow.cache.localizedVariants.store;
        var restrictedVariants;

        if(experienceKey) {
          
          restrictedVariants = flowVariants.filter(function(variant) { 
            return variant.experience.key === experienceKey;
          }).filter(function(variant) { 
            return variant.status === 'excluded' || variant.status === 'restricted';
          });

          restrictedVariants.forEach(function(variant) {
            var $el = $('[flow-localized-variant='+variant.id+']');
            if($el.length) {
              $el.parents(selectors.productGridItemProduct).remove();
              removedProductCount++;
            }
          });

          this.updateProductCountUI( productCount - removedProductCount );
          this.placeContentBlocks();
        }
      }
    },

    onResize: function() {
      if($window.width() < this.mobileBreakpoint) {
        this.closeDesktopFilterControls();
      }
      else {
        this.mobileFilterDrawer.close();
      }
    },

    onBreakPointChange: function(e) {
      this.placeContentBlocks();
    },

    /**
     * Handle filter tags element click event.
     * Toggles the state of the filter that was clicked on and then applies the tag filters to the collection
     *
     * @param {event} evt
     */
    onFilterTagsClick: function(e) {
      e.preventDefault();

      var self          = this;
      var $filterTagsEl = $(e.currentTarget);
      var tags          = $filterTagsEl.data('filter-tags').split(" ");
      var type          = $filterTagsEl.data('filter-type');

      $.each(tags, function(i, t) {
        self.tagFilterController.toggleFilterByValue(t);
      });

      self.applyTagFilters();
    },

    onClearAllFiltersClick: function(e) {
      e.preventDefault();
      this.tagFilterController.deactivateAllFilters();
      this.applyTagFilters()
    },

    onFilterControlsToggleClick: function(e) {
      e.preventDefault();
      if($window.width() < this.mobileBreakpoint) {
        // Toggle the mobile drawer
        this.mobileFilterDrawer.toggleVisibility();
      }
      else {
        this.toggleDesktopFilterControls();
      }
    },

    toggleDesktopFilterControls: function() {
      if($(selectors.filterControlsToggle).hasClass(classes.filterControlsOpen)) {
        this.closeDesktopFilterControls();
      }
      else {
        this.openDesktopFilterControls();
      }
    },

    openDesktopFilterControls: function(d) { 
      
      var duration = slate.utils.defaultTo(d, 500);

      $(selectors.filterControlsToggle).addClass(classes.filterControlsOpen);
      $(selectors.filterControls).slideDown({
        duration: duration,
        easing: 'easeOutQuint'
      });
    },

    closeDesktopFilterControls: function(d) {
      
      var duration = slate.utils.defaultTo(d, 500);

      $(selectors.filterControlsToggle).removeClass(classes.filterControlsOpen);
      $(selectors.filterControls).slideUp({
        duration: duration,
        easing: 'easeOutQuint'
      });        
    },

    /**
     * Updates the filter UI to reflect the state of active / deactive filters
     *
     */
    updateFilterUI: function() {
      var self = this;
      var filters = this.tagFilterController.getTagFilters();
      var activeFilters = this.tagFilterController.getActiveTagFilters();
      var filtersSlotHTML = '';
      var filtersSlotMobileHTML = '';

      $.each(filters, function(i, f) {

        var $filterTag = self.$filterTags.filter(function(){
          return $(this).data('filter-tags').indexOf(f.value) != -1;
        });

        f.active ? $filterTag.addClass(classes.filterActive) : $filterTag.removeClass(classes.filterActive);

      });

      if(activeFilters.length) {
        $(selectors.clearAllFilters).show();
        $(selectors.mobileFiltersEmpty).hide();
        
        filtersSlotHTML = activeFilters.map(function(tf) {
          return '<a href="#" class="filter-tag filter-tag--alt is-active" title="Remove filter" data-filter-type="'+tf.type+'" data-filter-tags="'+tf.value+'">'+tf.title+'</a>';
        });
        $(selectors.currentFiltersSlot).html( filtersSlotHTML );
        $(selectors.currentFiltersSlot).show();

        filtersSlotMobileHTML = '<ul class="mobile-active-filter-list list-inline">';
          filtersSlotMobileHTML += activeFilters.map(function(tf) {
            var $tf = $(tf.html);
                $tf.addClass('is-active');
            return '<li>' + $tf.prop('outerHTML') + '</li>';
          }).join('');
        filtersSlotMobileHTML += '</ul>';

        $(selectors.currentFiltersSlotMobile).html( filtersSlotMobileHTML );
      }
      else {
        $(selectors.clearAllFilters).hide();
        $(selectors.currentFiltersSlot).hide();
        $(selectors.currentFiltersSlot).html('');
        $(selectors.currentFiltersSlotMobile).html('');
        $(selectors.mobileFiltersEmpty).show();
      }

    },

    /**
     * Updates the product count
     *
     * @param {integer} count
     */
    updateProductCountUI: function(count) {
      // Update the collection product count
      this.$collectionProductCount.text(count);
      this.$collectionProductCountLabel.text(count == 1 ? 'Product' : 'Products');
    },

    /**
     * Updates the current URL to reflect the state of the applied filters
     * Appends a query string like ?filter-tags={{ tag1 }}+{{ tag2 }}
     *
     */
    updateURL: function() {
      var queryStringFilterParamValues = this.tagFilterController.getActiveTagFilterValues().join('+');
      var updatedUrl;

      if(window.history) {
        if(queryStringFilterParamValues.length) {
          updatedUrl = slate.utils.getUrlWithUpdatedQueryStringParameter(this.queryStringFilterParamKey, queryStringFilterParamValues);
        }
        else {
          updatedUrl = slate.utils.getUrlWithRemovedQueryStringParameter(this.queryStringFilterParamKey);
        }
        
        window.history.replaceState({path: updatedUrl}, '', updatedUrl);
      }

    },

    fadeOutProductGrid: function(cb, duration) {
      var d = (duration == undefined ? 250 : duration);
      this.$productGrid.fadeTo(d, 0, cb);
      return this;
    },

    fadeInProductGrid: function(cb, duration) {
      var d = (duration == undefined ? 250 : duration);
      $window.trigger("lookup"); // unveil plugin
      this.$productGrid.fadeTo(d, 1, cb);
      return this;
    },

    /**
     * Returns a jQuery set of product card elements that satisfy the currently applied filtering
     * If there are no filters, we return the entire set of cards
     *
     * @return {jQuery}
     */
    getProductCardsThatPassTheFilter: function() {
      var self = this;
      var $productCardSet          = $(selectors.productCard);
      var $productCardSetFilterOut = $(selectors.productCard); // Start with all the cards, and filter out the ones that pass, leaving the ones that need to be hidden
      var activeFilterTypes        = this.tagFilterController.getActiveTagFilterTypes();
      var activeTagFilters         = this.tagFilterController.getActiveTagFilters();
      var filterTypes              = this.tagFilterController.getTagFilterTypes();

      // We don't have active filters - show everything, nothing needs to be hidden!
      if(!activeFilterTypes.length) {
        return $productCardSet;
      }

      // We DO have active filters - Loop through each product card
      $(selectors.productCard).each(function(i){

        var passesActiveFilters = true; // If this is still "true" at the end of all this logic, then the product passes the applied filters and should be displayed
        var $productCard       = $(this);
        var dataTags           = $productCard.data('tags');
        
        // If there aren't any tags, return early
        if(!dataTags) {
          passesActiveFilters = false;
          return;
        }

        // Loop through each active filter
        for (var i = activeFilterTypes.length - 1; i >= 0; i--) {
          var activeFilterTypeMatch        = false;
          var activeTagFiltersForType      = self.tagFilterController.getActiveTagFiltersForType( activeFilterTypes[i] ); // [TagFilter, TagFilter]
          var activeTagFilterValuesForType = activeTagFiltersForType.map(function(tf){ return tf.value; }); // ["color-blue", "color-red"]

          for (var k = activeTagFilterValuesForType.length - 1; k >= 0; k--) {
            var activeTagFilterVal = activeTagFilterValuesForType[k]; // "color-blue"

            // as soon as we find a match for this filter type (doesn't matter which value), return it as a match
            // this is how we satisfy the requirement to match ANY filter for a particular filter type (match "red" OR "blue")
            if(dataTags.indexOf(activeTagFilterVal) != -1) {
              activeFilterTypeMatch = true;
              break;
            }
          }
          
          // Not a match :(
          if(activeFilterTypeMatch == false) {
            passesActiveFilters = false;
            break;
          }
        }

        if(passesActiveFilters) {
          $productCardSetFilterOut = $productCardSetFilterOut.not($productCard); // remove it from the matched set
        }
      });

      return $productCardSet.not($productCardSetFilterOut);
    },

    /**
     * Applies the currently active filters to the collection page
     *
     * @return {self}
     */
    applyTagFilters: function() {

      var self = this;
      var $productCardSet   = $(selectors.productCard);
      var $productGridItems = $(selectors.productGridItem);
      var $productCardSetThatPasses = this.getProductCardsThatPassTheFilter();
      var passingProductCardCount = $productCardSetThatPasses.length;
      var cb;

      // Nothing Matches
      if(passingProductCardCount == 0) {  
        $(selectors.collectionFilterEmpty).show();
        cb = function() {
          $productGridItems.hide();
          self.fadeInProductGrid();
        };
      }
      // Everything matches
      else if(passingProductCardCount == $productCardSet.length) {
        $(selectors.collectionFilterEmpty).hide();
        cb = function() {
          $productGridItems.show();
          self.fadeInProductGrid();
        }
      }
      // Partial match
      else {
        $(selectors.collectionFilterEmpty).hide();
        cb = function() {
          $productGridItems.hide();
          $productCardSetThatPasses.parent(selectors.productGridItem).show();
          self.fadeInProductGrid();
        }
      }

      this.fadeOutProductGrid(cb);

      self.updateFilterUI();
      self.updateProductCountUI(passingProductCardCount);   
      self.updateURL();

      return this;
    },

    placeContentBlocks: function(sortNeeded) {
      var sortNeeded = slate.utils.defaultTo(sortNeeded, false);
      var desktop = $window.width() > slate.breakpoints.getBreakpointMinWidth('md');
      var $productGridProducts       = $(selectors.productGridItemProduct, this.$container);
      var $productGridContentBlocks  = $(selectors.productGridItemContentBlock, this.$container);
      var $contentBlockStore         = $(selectors.contentBlockStore, this.$container);
      var outputtedContentBlockCount = 0;

      // First put all the content blocks into the store
      $productGridContentBlocks.detach().appendTo($contentBlockStore);

      if(sortNeeded) {
        // Then sort them by index in case they get mixed up
        // Theme editor screws with the ordering
        $productGridContentBlocks.sort(function(a, b) {
          var aI = parseInt($(a).data('product-grid-content-block'));
          var bI = parseInt($(b).data('product-grid-content-block'));

          if(aI > bI) {
            return 1;
          }
          if(aI < bI) {
            return -1;
          }
          return 0;
        });
      }

      // Then loop through all the product grid products and insert a content block where needed until we run out of content blocks or places to put them
      $productGridProducts.each(function(i) {
        var $gridProduct = $(this);
        var positionFlag;

        if( outputtedContentBlockCount >= $productGridContentBlocks.length ) {
          return false; // break $.each
        }
        
        /*
         * For desktop
         * - Product grid is 3 across
         * - Insert a content block after every 5 product blocks starting *after* the 3rd
         *
         * For mobile
         * - Product grid is 2 across
         * - Insert a content block after every 6 product blocks starting *after* the 4th
         */
        positionFlag = desktop ? (i + 3) % 5 : (i + 3) % 6;

        if(positionFlag == 0) {
          $productGridContentBlocks.eq(outputtedContentBlockCount).detach().insertAfter($gridProduct);
          outputtedContentBlockCount += 1;
        }
      });
    },

    /**
     * Theme Editor section events below
     */

    onBlockSelect: function(evt) {
      var $selectedProductGridContentBlock = $(selectors.productGridItemContentBlock, this.$container).filter('[data-block-id="' + evt.detail.blockId + '"]');
      // Since they're editing it, make sure that it's visible, insert it at the top of the grid;
      if(!$selectedProductGridContentBlock.is(':visible')) {
        $(selectors.productGrid, this.$container).prepend($selectedProductGridContentBlock);
      }
      
    },

    // Reset blocks
    onBlockDeselect: function() {
      this.placeContentBlocks(true);
    }
  });

  return Collection;

 })(slate)
/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - pencilBanner
 */

theme.PencilBanner = (function($) {

  var $window = $(window);

  var selectors = {
    modal: '[data-pencil-banner-modal]',
    modalBackdrop: '.modal-backdrop',
    pencilBannerTickerContent: '[pencil-banner-ticker-content]',
    pencilBannerModals: '[data-pencil-banner-modal]'
  };

  /**
   * Pencil Banner section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function PencilBanner(container) {
    this.$container = $(container);

    this.name = 'pencilBanner',
    this.namespace = '.'+this.name;

    if($(selectors.pencilBannerTickerContent).length) {
      this.initPencilBannerTicker();
    }

    $(selectors.pencilBannerModals).on('hidden.bs.modal', function () {
      this.initPencilBannerTicker();
    });
  }

  PencilBanner.prototype = $.extend({}, PencilBanner.prototype, {
    /**
     * Init the ticker version of the pencil banner using slick slider
     */
    initPencilBannerTicker: function() {
      $(selectors.pencilBannerTickerContent).slick({
          dots: false,
          arrows: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          vertical: true,
          autoplay: true,
          autoplaySpeed: 3000
      });
    },
    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      $(selectors.modalBackdrop).remove();
    }

  });

  return PencilBanner;
})(jQuery);

/**
 * Subscription Slideup Section Script
 * ------------------------------------------------------------------------------
 * 
 * This implementation is incomplete, there are empty methods that need to be wired up and filled in.
 * Details are dependent on:
 *  - Mailing list provider (See settings_schema.json)
 *  - 3rd party ajax / validation scripts
 *
 * @namespace - subscriptionSlideup
 */

theme.SubscriptionSlideUp = (function($, slate) {

  var selectors = {
    slideUp: '[data-subscription-slideup]',
    klaviyoForm: 'form[data-klaviyo-list-id]',
    close: '[data-subscription-slideup-close]',    
    formContent: '[data-subscription-slideup-form-content]',
    formMessage: '[data-subscription-slideup-form-message]',
    isSurfRanchProduct: '[data-surf-ranch-product]'
  };

  var classes = {
    slideUpVisible: 'is-visible',
    showMessage: 'show-message'
  };

  /**
   * Subscription Slideup section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function SubscriptionSlideUp(container) {
    this.$container = $(container);

    this.name = 'subscriptionSlideUp';
    this.namespace = '.'+this.name;

    var enabled        = this.$container.data('enabled');
    var delay          = !isNaN(parseInt( this.$container.data('delay'))) ? (parseInt( this.$container.data('delay'))*1000) : 3000;
    var seenExpiration = !isNaN(parseInt( this.$container.data('seen-expiration'))) ? parseInt( this.$container.data('seen-expiration')) : 30;

    // if seenExpiration is set to 0, set it to 1 year (very far into the future)  See section settings schema.
    if(seenExpiration == 0) {
      seenExpiration = 365;
    }
        
    this.settings = {
      enabled        : enabled, // turn this functionality on / off
      delay          : delay, // delay before showing the popup on pageload,
      seenExpiration : seenExpiration // days before showing the popup again
    };

    /**
     * These are the cookies that we'll use to keep track of how much the user has seen / interacted with the popup
     */
    this.cookies = {}

    this.cookies.seen = slate.user.createCookie('subscriptionSlideUpSeen');
    this.cookies.seen.value = slate.utils.hashFromString($(selectors.slideUp).text()).toString(); // Set the cookie value based on the content
    this.cookies.seen.expiration = seenExpiration;

    this.cookies.emailCollected = slate.user.createCookie('emailCollected');
    this.cookies.emailCollected.expiration = seenExpiration;

    this.$slideUp     = $(selectors.slideUp, this.$container);
    this.$formContent = $(selectors.formContent, this.$container);
    this.$formMessage = $(selectors.formMessage, this.$container);
    this.$klaviyoForm = $(selectors.klaviyoForm, this.$container);

    this.ajaxKlaviyoForm = new slate.AjaxKlaviyoForm(this.$klaviyoForm, {
      listId: this.$klaviyoForm.data('klaviyo-list-id'),
      source: this.$klaviyoForm.data('klaviyo-source'),
      onSubscribeSuccess: this.onSubscribeSuccess.bind(this),
      onSubmitFail: this.onSubmitFail.bind(this)
    });    

    /***
     * Attach event handlers
     */
    this.$container.on('click', selectors.close, this.onCloseClick.bind(this));

    /**
     * Checks the show logic and displays the popup if everything checks out
     */
    if(this.shouldShow()) {
      setTimeout(this.show.bind(this), this.settings.delay);
    }

  }

  SubscriptionSlideUp.prototype = $.extend({}, SubscriptionSlideUp.prototype, {

    /**
     * Resets everything to it's initial state.  Only call when slideup isn't visible.
     */
    reset: function() {
      this.$formContent.find('input[type="email"]').val('');
      this.$formContent.find('input[type="radio"]').prop('checked', false);
      this.$formMessage.html('');
      this.$formContent.removeClass(classes.showMessage);
    },

    onSubscribeSuccess: function() {
      this.$formMessage.html( this.$formMessage.data('message-success') );
      this.$formContent.addClass(classes.showMessage);
      
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.emailCollected);
      }      
    },

    onSubmitFail: function() {
      this.$formMessage.html( this.$formMessage.data('message-fail') );     
      this.$formContent.addClass(classes.showMessage);
      setTimeout(function(){
        this.$formContent.removeClass(classes.showMessage);
      }.bind(this), 5000);
    },

    onCloseClick: function(e){
      e.preventDefault();
      this.hide();
    },

    hide: function() {
      this.$slideUp.removeClass(classes.slideUpVisible);
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.seen);
      }
    },

    show: function() {
      this.$slideUp.addClass(classes.slideUpVisible);
    },

    shouldShow: function() {
      // Checks should be done in this order!

      if(slate.utils.isThemeEditor() || !this.settings.enabled) {
        return false;
      }

      if(slate.user.hasCookie('_ok_canAccessSurfRanchPrivateSale') && $(selectors.isSurfRanchProduct).length > 0) {
        return false;
      }
      
      if(this.isSurfRanchURL()){
        return false;
      }      

      if(slate.user.hasCookie(this.cookies.emailCollected.name)) {
        return false;
      }

      if( slate.user.hasCookie(this.cookies.seen.name) && slate.user.getCookieValue(this.cookies.seen.name) == this.cookies.seen.value) {
        return false
      }

      if(slate.user.hasCookie('_ok_subscriptionSlideUp2_seen')) {
        return false;
      }      

      if (window.matchMedia("only screen and (max-width: 767px)").matches && theme.strings.enableVoyageSMSPopup == true) {
        return false
      }      

      return true;
    },

    onHidden: function() {
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.seen);
      }
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.show();
    },

    onDeselect: function() {
      this.hide();
    },
    /**
     * redirect to the Surf Ranch Shop login page if user haven't logged in yet (_ok_canAccessSurfRanchPrivateSale not set)
     */
    isSurfRanchURL: function() {
      var urlPathname = window.location.pathname;
      if(urlPathname.length && urlPathname == "/pages/surf-ranch-collection-mens" || urlPathname == "/pages/surf-ranch-collection-womens" || urlPathname == "/pages/surf-ranch-shop-login") {
        return true;
      } else {
        return false;
      }
    }    
  });

  return SubscriptionSlideUp;
})(jQuery, slate);

/**
 * Instagram Feed Section Script
 * ------------------------------------------------------------------------------
 * 
 * Uses Instafeed.js to interact with Instagram API
 *   - See instafeedjs.com for documentation
 *   - See scripts/vendor directory for source file
 *
 * @namespace - InstagramFeed
 */

theme.InstagramFeed = (function($, Instafeed) {

  var selectors = {
    target: '[data-instagram-feed-target]'
  };

  var classes = {

  };

  /**
   * Instagram Feed section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function InstagramFeed(container) {
    this.$container = $(container);

    this.name = 'instagramFeed';
    this.namespace = '.'+this.name;

    this.settings = {
      accessToken: this.$container.attr('data-access-token'),
      target: $(selectors.target).get(0), // Instafeed needs a bare DOM element to work with
      get: 'user'
    };

    /*
     *  Set 'mock' to true in order to override the default behavior (auto inserting images in the target element)
     *
     *  this.settings.mock = true;
     *  this.settings.success = onInstafeedMockSuccess.bind(this)
     *
     */

    if(!this.settings.accessToken) {
      console.warn('[InstagramFeed] - An access token is required to interact with the Instagram API');
      return;
    }

    this.init();
  }

  InstagramFeed.prototype = $.extend({}, InstagramFeed.prototype, {

    /**
     * Kick off the network requests.  Retrieve the user profile from the API and then fire up the feed.
     *
     */
    init: function() {
      $.ajax({
        type: 'GET',
        url: 'https://api.instagram.com/v1/users/self?access_token=' + this.settings.accessToken,
        dataType: 'jsonp'
      })
      .then(function(response){
        
        // Handle invalid response
        if(response.meta.hasOwnProperty('error_message')){
          console.warn('['+this.name+'] - ' + response.meta.error_message);
          return;
        }

        this.settings.userId = response.data.id;

        /*
         *  Use this space to make any adjustments to the section now that you have access to the user profile object
         */

        this.feed = new Instafeed(this.settings);
        this.feed.run();
      }.bind(this));
    },

  /**
   * Callback that runs after Instafeed.run() if the 'mock' setting is set to true
   * Use this function to sort through images, select proper resolution, and construct a gallery of images to insert into the DOM
   *
   * @param {Object} feed - object returned from Instagram API
   * @param {Array} feed.data - Array of feed data objects containing images + info
   */
    onInstafeedMockSuccess: function(feed) {
      
      /*
       *  Add implementation details here
       *
       *  e.g. Loop through the feed data to return an array of images with src + caption properties, then append them to the DOM
       *
       *  var $target = $(selectors.target);
       *  var photos  = feed.data.map(function (photo) {
       *                 return {
       *                   src: photo.images && photo.images.standard_resolution && photo.images.standard_resolution.url,
       *                   caption: photo.caption && photo.caption.text || ''
       *                 };
       *               });
       *
       *
       *  photos.forEach(function(photo){
       *     var $i = $(new Image);
       *
       *     $i.attr('src', photo.src);
       *     $target.append($i)
       *  });
       *
       */

    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      console.log('['+this.name+'] - section:select');
    },

    onShow: function() {
      console.log('['+this.name+'] - section:show');
    },

    onLoad: function() {
      console.log('['+this.name+'] - section::load');
    },

    onUnload: function() {
      console.log('['+this.name+'] - section::unload');
    }
  });

  return InstagramFeed;
})(jQuery, Instafeed);

/**
 * Slideshow Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - Slideshow
 */

theme.Slideshow = (function($, Modernizr, slate) {

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
  };

  /**
   * Slideshow section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Slideshow(container) {
    this.$container = $(container);

    this.name = 'slideshow';
    this.namespace = '.'+this.name;

    this.$slideshow = this.$container.is(selectors.slideshowWrapper) ? this.$container : $(selectors.slideshowWrapper, this.$container);

    if( !this.$slideshow.length ){
      console.warn('['+this.name+'] - Element matching '+selectors.slideshowWrapper+' required to initialize');
      return;
    }

    var settings = {
      fade: false,
      arrows: !Modernizr.touchevents,
      dots: false,
      centerMode: true,
      centerPadding: '80px',
      responsive: [
        {
          breakpoint: (slate.breakpoints.getBreakpointMinWidth('lg') - 1),
          settings: {
            centerPadding: '40px'
          }
        },
        {
          breakpoint: (slate.breakpoints.getBreakpointMinWidth('sm') - 1),
          settings: {
            centerPadding: '20px',
            arrows: false
          }
        },
        {
          breakpoint: (slate.breakpoints.getBreakpointMinWidth('xs') - 1),
          settings: {
            centerPadding: '5px',
            arrows: false
          }
        }
      ]
    };

    this.slideshow = new slate.Slideshow( this.$slideshow, settings);

  }

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.slideshow.goToSlideByBlockId( evt.detail.blockId );
      this.slideshow.pause();
    }
  });

  return Slideshow;
})(jQuery, Modernizr, slate);

/**
 * Header Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - header
 */

theme.Header = (function($) {

  var $window = $(window);
  var $body   = $(document.body);
  var $pencilBanner = $('[data-pencil-banner]'); // Technically this section shouldn't be aware of the pencil banner section but I think it's okay for now...

  var selectors = {
    dropdownTrigger: '[data-dropdown-trigger][data-block]',
    header: '[data-header]',
    search: '[data-search]',
    searchOpen: '[data-search-open]',
    searchClose: '[data-search-close]',
    searchInput: '[data-search-input]',
    countrySelectLink: '[data-country-selector-open]',
    flagContainer: '[data-flag-container]'
  };

  var classes = {
    dropdownOpen: 'is-open',
    headerActive: 'is-active',
    headerFixed: 'is-fixed',
    searchActive: 'is-active'
  };

  /**
   * Dropdown - Exposes methods for opening and closing the dropdown.  All logic is handled externally
   *
   * @constructor
   * @param {jQuery} $trigger - Element matching selectors.dropdownTrigger
   */
  function Dropdown($trigger) {
    this.$trigger = $trigger;
    this.$el = $( this.$trigger.data('dropdown-trigger') );
    this.blockId = this.$trigger.data('block').toString();
  };

  Dropdown.prototype = {
    isOpen: function() {
      return this.$el.hasClass( classes.dropdownOpen );
    },
    open: function() {
      this.$el.addClass( classes.dropdownOpen );
    },
    close: function() {
      this.$el.removeClass( classes.dropdownOpen );
    }
  };

  /**
   * DropdownManager - Manages opening / closing of all dropdowns.  Makes sure only one shows at a time.
   *
   * @constructor
   * @param {function} dropdownConstructor
   */
  function DropdownManager() {

    this.closeDropdownTimeout = null;
    this.closeDropdownTimeoutDuration = 80;
    this.dropdowns = [];
    this.activeDropdown = undefined;

    var events = window.PointerEvent ? {
                  end:   "pointerup",
                  enter: "pointerenter",
                  leave: "pointerleave"
                } : {
                  end: "touchend",
                  enter: "mouseenter",
                  leave: "mouseleave"
                };

    this.register = function($trigger) {
      var dd = new Dropdown($trigger);

      // Trigger events - the link that you interact with to display the dropdown
      dd.$trigger.on(events.enter,  this.onTriggerMouseEnter.bind(this, dd));
      dd.$trigger.on(events.leave,  this.onTriggerMouseLeave.bind(this, dd));
      dd.$trigger.on(events.end,    this.onTriggerTouchEnd.bind(this, dd));

      // Dropdown events - what happens when you interact with the dropdown itself
      dd.$el.on(events.leave, this.onDropdownMouseLeave.bind(this, dd));
      dd.$el.on(events.enter, this.onDropdownMouseEnter.bind(this, dd));
      dd.$el.on(events.end,   this.onDropdownTouchEnd.bind(this, dd));

      this.dropdowns.push(dd);
    };

  };

  DropdownManager.prototype = {
    getDropdownByBlockId: function(id) {
      return slate.utils.findInstance(this.dropdowns, 'blockId', id);
    },
    onTriggerMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
        this.openDropdown(dd);
      }
    },
    onTriggerMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },
    onTriggerTouchEnd: function(dd, e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown(dd);
    },
    onDropdownMouseEnter: function(dd, e) {
      if(e.pointerType != "touch") {
        this.stopCloseTimeout();
      }
    },
    onDropdownMouseLeave: function(dd, e) {
      if(e.pointerType != "touch") {
        this.startCloseTimeout(dd);
      }
    },
    onDropdownTouchEnd: function(dd, e) {
      e.stopPropagation();
    },
    toggleDropdown: function(dd) {
      return this.activeDropdown == dd ? this.closeDropdown(dd) : this.openDropdown(dd);
    },
    openDropdown: function(dd) {
      if(this.activeDropdown !== dd) {
        this.activeDropdown = dd;
        this.closeAllDropdowns();
        dd.open();
      }
    },
    closeDropdown: function(dd) {
      dd.close();

      if(this.activeDropdown == dd) {
        this.activeDropdown = undefined;
      }
    },
    closeAllDropdowns: function() {
      $.each(this.dropdowns, function(i, dd) {
        if(dd.isOpen()) {
          dd.close();
        }
      });
      this.activeDropdown = undefined;
    },
    startCloseTimeout: function(dd) {
      this.closeDropdownTimeout = setTimeout(this.closeDropdown.bind(this, dd), this.closeDropdownTimeoutDuration);
    },
    stopCloseTimeout: function() {
      clearTimeout(this.closeDropdownTimeout);
    }
  };

  /**
   * Header
   *
   * @constructor
   * @param {HTMLElement} container
   */
  function Header(container) {

    var _this = this;

    this.$container = $(container);
    this.$el = $(selectors.header, this.$container);
    this.name = 'header';
    this.namespace = '.'+this.name;
    this.dropdownManager = new DropdownManager();

    this.events = {
      SCROLL: 'scroll' + this.namespace
    };

    // Construct a new dropdown from each trigger and add to our array of dropdowns to keep track
    $(selectors.dropdownTrigger).each(function(i, trigger) {
      _this.dropdownManager.register( $(trigger) );
    });

    this.$container.on('pointerenter mouseenter', this.onMouseEnter.bind(this));
    this.$container.on('pointerleave mouseleave', this.onMouseLeave.bind(this));
    this.$container.on('keydown', selectors.search, this.onSearchKeyDown.bind(this));
    this.$container.on('click',   selectors.searchOpen, this.onSearchOpenClick.bind(this));
    this.$container.on('click',   selectors.searchClose, this.onSearchCloseClick.bind(this));

    $window.on('ready.countrySelector', this.onCountrySelectorReady.bind(this)); // see sections/countrySelector.js
    $window.on(this.events.SCROLL, $.throttle(20, requestAnimationFrame.bind(window, this.onScroll.bind(this)))); // throttle + rAF = smooth scrolling :)
    this.onScroll(); // hit this one time on init to make sure everything is good

    // On the search page, pop open the search functionality if there are no results
    if($body.hasClass('template-search') && $('.product-grid__item').length==0 && $('.content-grid__item').length==0) {
      this.openSearch();
    }

  };

  Header.prototype = $.extend({}, Header.prototype, {

    // Scroll stuff to make sure the ticker + header work correctly together
    scrollCheck: function() {
      var $pb = $pencilBanner;
      var scrollTop = $window.scrollTop();

      if(slate.utils.isThemeEditor()) {
        // The theme editor screws screws up the $ticker variable outside of this scope when we load / unload the section
        // so we have to reset it here
        // only do it if we're in the theme editor though to avoid dom lookups on the user facing site.
        $pb = $('.pencil-banner');
      }

      // If ticker is there, visible, and we haven't scrolled past it... OR we're at the very top of the page
      if( ($pb.length && $pb.get(0).style.display !== "none" && scrollTop < $pb.outerHeight()) || scrollTop == 0){
        this.$el.removeClass( classes.headerFixed );
      }
      else {
        this.$el.addClass( classes.headerFixed );
      }
    },

    onScroll: function() {
      this.scrollCheck();
    },

    onMouseEnter: function() {
      this.$el.addClass(classes.headerActive);
    },

    onMouseLeave: function() {
      this.dropdownManager.closeAllDropdowns();
      this.$el.removeClass(classes.headerActive);
    },

    onSearchKeyDown: function(e) {
      if(e.which == 27) { // esc key
        this.closeSearch();
        // return focus?
      }
    },

    onSearchOpenClick: function(e) {
      e.preventDefault();
      this.openSearch();
    },

    onSearchCloseClick: function(e) {
      e.preventDefault();
      this.closeSearch();
    },

    openSearch: function() {
      $(selectors.search, this.$container).addClass(classes.searchActive);
      $(selectors.searchInput, this.$container).first().focus();
    },

    closeSearch: function() {
      $(selectors.search, this.$container).removeClass(classes.searchActive);
    },


    /**
     * Updates the header UI after the country selector is done initializing
     *
     * @param {event} e
     * @param {string} e.countryTitle - e.g. "United States"
     * @param {string} e.countryKey - e.g. "united-states"
     * @param {string} e.countryCode3 - e.g. "US"
     * @param {string} e.countryCode2 - e.g. "USA"
     * @param {string} e.imgSrc - url for flag image
     * @param {string} e.shippingMessage - "Shipping to United States"
     */
    onCountrySelectorReady: function(e) {
      if(e.imgSrc) {
        var i = new Image();
        i.src = e.imgSrc;

        $(selectors.flagContainer, this.$container).html(i);
      }

      $(selectors.countrySelectLink, this.$container).attr('title', e.shippingMessage);
    },

    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(e) {
      var blockId  = e.detail.blockId;
      var dropdown = this.dropdownManager.getDropdownByBlockId(blockId);

      // Bypass dropdown manager since we're inside the theme editor
      if(dropdown) {
        dropdown.open();
      }
    },

    onBlockDeselect: function(e) {
      var blockId  = e.detail.blockId;
      var dropdown = this.dropdownManager.getDropdownByBlockId(blockId);

      // Bypass dropdown manager since we're inside the theme editor
      if(dropdown) {
        dropdown.close();
      }
    }
  });

  return Header;
})(jQuery);

/**
 * Footer Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - footer
 */

theme.Footer = (function($, slate) {

  var $window = $(window);

  var selectors = {
    klaviyoForm: 'form[data-klaviyo-list-id]',
    formMessage: '[data-form-message][data-message-success][data-message-fail]',
    countrySelectorLink: '[data-country-selector-open]'
  };

  var classes = {
    showFormMessage: 'is-visible'
  };

  function Footer(container) {

    _this = this;
    this.$container = $(container);

    this.name = 'footer';
    this.namespace = '.'+this.name;

    /**
     * These are the cookies that we'll use to keep track of how much the user has interacted with the footer
     */
    this.cookies = {};

    this.cookies.emailCollected = slate.user.createCookie('emailCollected');

    this.$klaviyoForm = $(selectors.klaviyoForm, this.$container);
    this.$formMessage = $(selectors.formMessage, this.$container);

    if(this.$klaviyoForm.length) {
      this.ajaxKlaviyoForm = new slate.AjaxKlaviyoForm(this.$klaviyoForm, {
        listId: this.$klaviyoForm.data('klaviyo-list-id'),
        source: this.$klaviyoForm.data('klaviyo-source'),
        onSubscribeSuccess: this.onSubscribeSuccess.bind(this),
        onSubmitFail: this.onSubmitFail.bind(this)
      });
    }

    $window.on('ready.countrySelector', this.onCountrySelectorReady.bind(this)); // see sections/countrySelector.js

  };

  Footer.prototype = $.extend({}, Footer.prototype, {

    onSubscribeSuccess: function() {
      this.$formMessage.html( this.$formMessage.data('message-success') );
      this.$formMessage.addClass(classes.showFormMessage);
      
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie(this.cookies.emailCollected);
      }

      setTimeout(function(){
        this.$klaviyoForm.find('input[type="email"]').val('');
        this.$klaviyoForm.find('input[type="radio"]').prop('checked', false);
        this.$formMessage.removeClass(classes.showFormMessage);
      }.bind(this), 5000);
    },

    onSubmitFail: function() {
      this.$formMessage.html( this.$formMessage.data('message-fail') );
      this.$formMessage.addClass(classes.showFormMessage);
      setTimeout(function(){
        this.$formMessage.removeClass(classes.showFormMessage);
      }.bind(this), 3000);
    },

    /**
     * Updates the footer UI after the country selector is done initializing
     * Since selected country is only known through cookies / flow on the frontend, we have to update the UI after it loads
     * Default text is "Select Country"
     *
     * @param {event} e
     * @param {string} e.countryTitle - e.g. "United States"
     * @param {string} e.countryKey - e.g. "united-states"
     * @param {string} e.countryCode3 - e.g. "US"
     * @param {string} e.countryCode2 - e.g. "USA"
     * @param {string} e.imgSrc - url for flag image
     * @param {string} e.shippingMessage - "Shipping to United States"
     */
    onCountrySelectorReady: function(e) {
      $(selectors.countrySelectorLink, this.$container).text(e.shippingMessage);
    }
    
  });

  return Footer;
})(jQuery, slate);

/**
 * Mobile menu Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the mobile menu
 *
 * @namespace - mobileMenu
 */

theme.MobileMenu = (function($) {

  var $window = $(window);
  var $body = $('body');

  var selectors = {
    drawer: '[data-mobile-menu-drawer]',
    toggle: '[data-mobile-menu-toggle]',
    submenu: '[data-mobile-submenu]',
    submenuTrigger: '[data-mobile-submenu-trigger]',
    close: '[data-drawer-close]',
    layoutWrapper: '.layout-wrapper'
  };
  var menu = document.getElementsByClassName('mobile-menu')[0];

  var FOCUSABLE_ELEMENT_SELECTORS = '.mobile-menu a[href], .mobile-menu area[href], .mobile-menu input:not([disabled]), .mobile-menu select:not([disabled]), .mobile-menu textarea:not([disabled]), .mobile-menu button:not([disabled]), .mobile-menu iframe, .mobile-menu object, .mobile-menu [tabindex="0"], .mobile-menu [contenteditable]';
  var KEY_CODE_MAP = {
    TAB: 9,
    ESC: 27
  };
  var focusableElements, lastFocusEl, firstFocusEl;


  function MobileMenu(container) {
    this.$container = $(container);

    this.name = 'mobileMenu';
    this.namespace = '.'+this.name;
    this.mobileMenuDrawer = new slate.Drawer( $(selectors.drawer, this.$container) );

    $(selectors.toggle).on('click', this.onToggleClick.bind(this));
    $(selectors.submenuTrigger, this.$container).on('click', this.onSubmenuTriggerClick.bind(this));
    $(selectors.close).on('click', this.onCloseClick.bind(this));
  }

  MobileMenu.prototype = $.extend({}, MobileMenu.prototype, {

    onToggleClick: function(e) {
      e.preventDefault();
      $(selectors.layoutWrapper).attr('aria-hidden', true);
      $(selectors.drawer).attr('aria-hidden', false);
      $(firstFocusEl).focus();
      this.mobileMenuDrawer.toggleVisibility();
      this.getFocusableEls();
      menu.addEventListener('keydown', this.keyboardHandler.bind(this));
    },

    onCloseClick: function(e) {
      $(selectors.layoutWrapper).attr('aria-hidden', false);
      $(selectors.drawer).attr('aria-hidden', true);
      menu.removeEventListener('keydown', this.keyboardHandler.bind(this));
      this.mobileMenuDrawer.close();
      $(selectors.toggle).focus();
    },
    keyboardHandler: function(e) {
      if (e.keyCode === KEY_CODE_MAP.TAB) {
        if (e.shiftKey && document.activeElement === firstFocusEl) {
          e.preventDefault();
          lastFocusEl.focus();
        } else if (!e.shiftKey && document.activeElement === lastFocusEl) {
          e.preventDefault();
          firstFocusEl.focus();
        }
      } else if (e.keyCode === KEY_CODE_MAP.ESC) {
        this.mobileMenuDrawer.close();
        $(selectors.toggle).focus();
      }
    },
    getFocusableEls: function() {
      focusableElements = $(FOCUSABLE_ELEMENT_SELECTORS);
      focusableElements.each(function(){
        if ($(this).is(':hidden')) {
          focusableElements.splice( $.inArray(this, focusableElements), 1);
        }
      })
      if (focusableElements.length > 0) {
        firstFocusEl = focusableElements[0],
        lastFocusEl = focusableElements[(focusableElements.length - 1)];
      }
      firstFocusEl.focus();
    },

    onSubmenuTriggerClick: function(e) {
      e.preventDefault();
      var $trigger = $(e.currentTarget);
      $trigger.toggleClass("is-closed is-open");
      var $submenu = $trigger.siblings(selectors.submenu); // Trigger has to be sibling to the submenu element!

      $submenu.slideToggle({
        duration: this.transitionDuration,
        easing: 'easeOutQuint'
      });
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.mobileMenuDrawer.open();
    },

    onDeselect: function() {
      this.mobileMenuDrawer.close();
    }
  });

  return MobileMenu;
})(jQuery);

/**
 * Hero Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - hero
 */

theme.Hero = (function($) {

  var $window = $(window);

  var selectors = {
    hero: '[data-hero]',
    pencilBanner: '[data-pencil-banner]'
  };

  var classes = {

  };

  function Hero(container) {

    _this = this;
    this.$container = $(container);

    this.name = 'hero';
    this.namespace = '.'+this.name;
    this.$hero = $(selectors.hero, this.$container);

    var events = {
      RESIZE: 'resize' + this.namespace
    };

    $window.on(events.RESIZE, $.throttle(20, this.onResize.bind(this)) );
    this.onResize();
  };

  Hero.prototype = $.extend({}, Hero.prototype, {
    onResize: function() {
      
      if($window.width() < slate.breakpoints.getBreakpointMinWidth('sm')) {
        this.$hero.css('height', 'auto');
        return;
      }

      var $pencilBanner = $(selectors.pencilBanner);
      var pageOffsetHeight = $pencilBanner.length ? $pencilBanner.outerHeight() : 0;
      var windowHeight = $window.height();
      
      this.$hero.css('height', windowHeight - pageOffsetHeight);
    },
  });

  return Hero;
})(jQuery);

/**
 * Ajax Cart Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the interacting with the ajax cart section.
 * All logic is handled in slate.AjaxCart, this file is strictly for handling section settings and them editor interactions
 *
 * @namespace - ajaxCart
 */

theme.AjaxCart = (function($) {

  var $body = $(document.body);

  /**
   * AjaxCart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function AjaxCart(container) {
    this.$container = $(container);

    this.name = 'ajaxCart',
    this.namespace = '.'+this.name;

    this.ajaxCart = new slate.AjaxCart();
    
    this.ajaxCart.init();
    window.findifyCart = this;
    window.globalCart = this;
  }

  AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.ajaxCart.open();
    },

    onDeselect: function() {
      this.ajaxCart.close();
    },

    onShow: function() {

    },

    onLoad: function() {

    },

    onUnload: function() {

    }
  });

  return AjaxCart;
})(jQuery);

/**
 * Collection List Page Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - collectionListPage
 */

theme.CollectionListPage = (function($, slate) {

  var $window = $(window);
  var $body = $('body');

  var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
    slickContent: '#page-hero__title-special-copy-ticker',
    productCards: '.product-card',
    productSize: '[data-variant-option-value]',
    variantOptionValueList: '[data-variant-option-value-list][data-option-position]',
    variantOptionValue: '[data-variant-option-value]',
    variantHasInseam: '[data-variant-option-value-type]',
    quickAddCopy: '.product-card__quick-add-copy',
    quickAddSubCopy: '.product-card__quick-add-sub-copy',
    quickAddWrap: '.product-card__quick-add-wrap',
    productInseamContainer: '[data-inseam-container]' 
  };

  function CollectionListPage(container) {

    var self = this;
    var urlParts = window.location.href.split('/');
    var pageHandle =  urlParts.pop() || urlParts.pop();

    this.$container = $(container);

    this.name = 'collectionListPage';
    this.namespace = '.'+this.name;
    this.slideshows = [];

    //redirect the user to the surf ranch login page if they have not logged in
    if(pageHandle == 'surf-ranch-collection-mens' || pageHandle == 'surf-ranch-collection-womens' || pageHandle == 'surf-ranch-collection-kids') {
      if(slate.user.getCookieValue('_ok_canAccessSurfRanchPrivateSale') == undefined && slate.utils.isThemeEditor() == false) {
        window.location.replace("/pages/surf-ranch-shop-login");
      }  
    } 

    this.$container.on('click', selectors.productSize, this.onSizeClick.bind(this));
    this.$container.on('mouseenter mouseleave', selectors.quickAddWrap, this.updateQuickAddState.bind(this));

    var settings = {
      fade: false,
      arrows: !Modernizr.touchevents,
      dots: false,
      centerMode: true,
      centerPadding: '80px',
      responsive: [
        {
          breakpoint: (slate.breakpoints.getBreakpointMinWidth('lg') - 1),
          settings: {
            centerPadding: '40px'
          }
        },
        {
          breakpoint: (slate.breakpoints.getBreakpointMinWidth('sm') - 1),
          settings: {
            centerPadding: '20px',
            arrows: false
          }
        },
        {
          breakpoint: (slate.breakpoints.getBreakpointMinWidth('xs') - 1),
          settings: {
            centerPadding: '5px',
            arrows: false
          }
        }
      ]
    };

    $(selectors.slideshowWrapper, this.$container).each(function(i, el) {
      self.slideshows.push( new slate.Slideshow($(el), settings) );
    });

    this.initTicker();
  };

  CollectionListPage.prototype = $.extend({}, CollectionListPage.prototype, {
    initTicker: function() {
      $(selectors.slickContent).slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        vertical: true,
        autoplay: true,
        autoplaySpeed: 1000
      });         
    },
    /**
     * Add an item to the cart if it's available
     */
    addToCart(variantId, qty, properties, callback) {
      window.globalCart.ajaxCart.cartProvider.addItem(variantId, qty, properties)
      .then(function(cart){
        return new Promise(function(resolve) {
          slate.utils.sendDataToKlaviyo(cart);
          slate.utils.sendDataToFacebook(cart, variantId);
          resolve(cart);
        });
      })
      .then(function(cart){
        window.globalCart.ajaxCart.onItemAddSuccess(cart);
      })
      .fail(function(data){
        window.globalCart.ajaxCart.onItemAddFail(data);
      });

      if (callback) callback();
    },
    onSizeClick:function(e) {
      var $currentProduct = $(e.currentTarget).parents(".product-card");
      var productId = $($currentProduct).data("product-id");  
      var $option = $(e.currentTarget);
      var value     = $option.data('variant-option-value');
      var position  = $option.data('option-position');
      var Option2List = $('[data-variant-option-value-list][data-option-position="2"]', $currentProduct);
      var Option3List = $('[data-variant-option-value-list][data-option-position="3"]', $currentProduct);
      var productInseam = $(selectors.productInseamContainer, $currentProduct);
      var subCopy = $(selectors.quickAddSubCopy, $currentProduct);
      var $properties = {};

      if($option.hasClass("is-disabled")){
        return;
      }

      var $product = window.ShopifySeedData.collection.find(function(c) {
        return c.id == productId;
      });

      if($product.options_with_values.length <= 2) {
        $product.options_with_values[position -1].selected_value = value;

        var selectedVariant = $product.variants.find(function(v) {
          return $product.options_with_values.every(function(option) {
            return option.selected_value == v.options[option.position -1];
          });
        });
        //add product with color/size to cart
        if($option.hasClass("is-pre-order") && selectedVariant.pre_order_estimated_ship_date != "") {
          $properties["Estimated Shipping"] = selectedVariant.pre_order_estimated_ship_date;
        }
        this.addToCart(selectedVariant.id, 1, $properties);

      } else if($product.options_with_values.length > 2) {
        $product.options_with_values[position -1].selected_value = value;

        if(position == 2) {

          $('.dot', Option3List).hide();

          $product.variants.filter(function(v) {
            return v.options[1] == value && v.available;
          }).forEach(function(v) {
            var currOpts = $('[data-variant-option-value="' + v.options[2] + '"]', Option3List);
            currOpts.show();
          });

          $currentProduct.find('[data-variant-option-value-list][data-option-position="2"]', $currentProduct).hide();
          if(productInseam.length > 0) {
            subCopy.text("Select your inseam");
          }
          Option3List.show();
        } else if(position == 3) {
          
          var selectedVariant = $product.variants.find(function(v) {
            return $product.options_with_values.every(function(option) {
              return option.selected_value == v.options[option.position -1];
            });
          });
    
          //add product with color/size/inseam to cart
          this.addToCart(selectedVariant.id, 1, $properties, function() {
            Option3List.delay(1200).hide(0);
            Option2List.delay(1500).show(0);
          });
        }
      }
    },
    updateQuickAddState: function(e) {
      var $currentProduct = $(e.currentTarget).parents(".product-card");
      var option = $(selectors.variantOptionValue, $currentProduct);
      var copy = $(selectors.quickAddCopy, $currentProduct);
      var subCopy = $(selectors.quickAddSubCopy, $currentProduct);
      var productInseam = $(selectors.productInseamContainer, $currentProduct);
      var Option2List = $('[data-variant-option-value-list][data-option-position="2"]', $currentProduct);
      var Option3List = $('[data-variant-option-value-list][data-option-position="3"]', $currentProduct);

      if(e.type == 'mouseleave') {
        copy.text("Quick Add");

        if(productInseam.length > 0){
          subCopy.text("");
          Option2List.show();
          Option3List.hide();
        }
      }

      if(e.type == 'mouseenter' && productInseam.length > 0) {
        subCopy.text("Select your waist size"); 
      }

      option.on('mouseenter', function(){
        if($(this).hasClass("is-disabled")) {
          copy.text("Notify me when restocked");
        } else if($(this).hasClass("is-pre-order")){
          copy.text("Pre-order this product");
        } else {
          copy.text("Quick Add");
        }
      });
    }
  });

  return CollectionListPage;
})(jQuery, slate);

/**
 * Size Guide Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - sizeGuide
 */

 theme.SizeGuide = (function($, slate) {

  var selectors = {
    sizeGuideTableToggle: '[data-size-guide-table-toggle]',
    sizeGuideTable: '[data-size-guide-table]',
    modal: '.modal',
    sizeGuideModal: '.modal--size-guide',
    sizeGuideTableCell: 'td'
  };

  var classes = {
    sizeGuideTableToggleActive: 'is-active',
    sizeGuideTableColumnRowHover: 'hover',
    sizeGuideTableCellHighlight: 'highlight'
  };

  function SizeGuide(container) {

    _this = this;
    this.$container = $(container);
    this.$document = document;
    this.name = 'sizeGuide';
    this.namespace = '.'+this.name;

    this.$sizeGuideModal = $(selectors.sizeGuideModal, this.$document);
    this.$toggles     = $(selectors.sizeGuideTableToggle, this.$container);
    this.$tables      = $(selectors.sizeGuideTable, this.$container);
    this.$tableCell   = $(selectors.sizeGuideTableCell, this.$container);
    this.$sizeGuideModal.on('show.bs.modal', this.onSizeGuideModalOpen.bind(this));
    this.$tableCell.on('mouseover', this.onSizeGuideTableCellMouseOver.bind(this));
    this.$tableCell.on('mouseout', this.onSizeGuideTableCellMouseOut.bind(this));
    this.$toggles.on('click', this.onSizeGuideTableToggleClick.bind(this));
  };
  
 
  SizeGuide.prototype = $.extend({}, SizeGuide.prototype, {
    onSizeGuideModalOpen: function(e) {

      // if fit is specified by fit:XX tag, then default to that tab in the size guide
      var initFit = $(e.relatedTarget).attr('data-fit');

      if (initFit) {
        var fitName     = initFit;
        var fitCategory = $(e.relatedTarget).attr('data-size-guide-prefix');
        // console.log("fit from sizeguide.js = "+ fitName);
        // console.log("fitcategory from sizeguide.js = "+ 'label_id_'+fitCategory+fitName);
        document.getElementById('label_id_'+fitCategory+fitName).click();
      } else {
        document.querySelector('ul.fit-tabs__list li:first-child a').click();
      }
    },
    onSizeGuideTableToggleClick: function(e) {
      e.preventDefault();
      var $toggle = $(e.currentTarget);
      var units = $toggle.data('size-guide-table-toggle');

      this.$toggles.removeClass(classes.sizeGuideTableToggleActive);
      this.$toggles.filter('[data-size-guide-table-toggle="'+units+'"]').addClass(classes.sizeGuideTableToggleActive);
      this.$tables.hide();
      this.$tables.filter('[data-size-guide-table="'+ units +'"]').show();
    },

    onSizeGuideTableCellMouseOver: function(e) {
      var $tableCell = $(e.currentTarget);
      var $tr = $tableCell.closest('tr');
  
      $tableCell.parent().find('td').addClass(classes.sizeGuideTableColumnRowHover);
      $('.fit-tabs__content .table td:nth-child(' + ($tableCell.index() + 1) + ')').addClass(classes.sizeGuideTableColumnRowHover);
      $tableCell.addClass(classes.sizeGuideTableCellHighlight);
      $('.fit-tabs__content .table th:nth-child(' + ($tableCell.index() + 1) + ')').addClass(classes.sizeGuideTableCellHighlight);
      $tableCell.closest('tr').find("td:nth-child(1)").addClass(classes.sizeGuideTableCellHighlight);
    },

    onSizeGuideTableCellMouseOut: function(e) {
      var $tableCell = $(e.currentTarget);
      $tableCell.parent().find('td').removeClass(classes.sizeGuideTableColumnRowHover);
      $('.fit-tabs__content .table td:nth-child(' + ($tableCell.index() + 1) + ')').removeClass(classes.sizeGuideTableColumnRowHover);
      $tableCell.removeClass(classes.sizeGuideTableCellHighlight);
      $('.fit-tabs__content .table th:nth-child(' + ($tableCell.index() + 1) + ')').removeClass(classes.sizeGuideTableCellHighlight);
      $tableCell.closest('tr').find("td:nth-child(1)").removeClass(classes.sizeGuideTableCellHighlight);
    },  

    onSelect: function() {
      slate.rte.fixTables();

      // in case we're showing it inside a modal
      this.$container.parents(selectors.modal).modal('show');
      
    },

    onDeselect: function() {
      // in case we're showing it inside a modal
      this.$container.parents(selectors.modal).modal('hide');
      
    }

  });

  return SizeGuide;
})(jQuery, slate);

/**
 * Blog Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - blog
 */

theme.Blog = (function($) {

  var $window = $(window);

  var selectors = {
    tagBarList: '[data-blog-tag-bar-list]',
    contentGrid: '.content-grid',
    contentGridItem: '.content-grid__item',
    pagination: '[data-pagination]',
    nextPageLink: '[data-next-page]',
  };

  var classes = {
    tagIsActive: 'is-active'
  };

  function Blog(container) {

    _this = this;
    this.$container = $(container);

    this.name = 'blog';
    this.namespace = '.'+this.name;

    this.$container.on('click', selectors.nextPageLink, this.onNextPageLinkClick.bind(this));

    var $tagBarList = $(selectors.tagBarList);
    var $tagBarListActiveTag = $tagBarList.find('.'+classes.tagIsActive).first();
    var tagBarListActiveTagLeft;

    // If we have an active tag, make sure it's scrolled into view
    if($tagBarListActiveTag.length) {
      tagBarListActiveTagLeft = $tagBarListActiveTag.offset()['left'];

      if(tagBarListActiveTagLeft > $tagBarList.width()) {
        $tagBarList.scrollLeft( tagBarListActiveTagLeft );
      }
    }

  };

  Blog.prototype = $.extend({}, Blog.prototype, {

    onNextPageLinkClick: function(e) {
      e.preventDefault();
      var self     = this;
      var $link    = $(e.currentTarget);
      var url      = $link.attr('href');
      var linkText = $link.html();


      $.ajax({
        url: url,
        beforeSend: function( xhr ) {
          $link.html(theme.strings.loading || 'Loading');
        }
      })
      .done(function( data ) {
        var $dom = $(data);
        var $contentItems = $dom.find(selectors.contentGridItem);
        var $newNextPageLink = $dom.find(selectors.nextPageLink);

        self.$container.find(selectors.contentGrid).append($contentItems);

        if($newNextPageLink.length) {
          $link.replaceWith($newNextPageLink);
        }
        else {
          self.$container.find(selectors.pagination).remove();
        }
      });

    }
  });

  return Blog;
})(jQuery);

/**
 * Search Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - search
 */

theme.Search = (function($) {

  var selectors = {
    productGridItemProduct: '[data-product-grid-product]',
    productCount: '[data-search-product-count]',
    productCountLabel: '[data-search-product-count-label]'
  };

  /**
   * Search section constructor
   *
   * @param {string} container - selector for the section container DOM element
   */
  function Search(container) {
    this.$container = $(container);

    this.name = 'search';
    this.namespace = '.'+this.name;

    this.$productCount = $(selectors.productCount, this.$container);
    this.$productCountLabel = $(selectors.productCountLabel, this.$container);

    if(Flow) {
      Flow.set('on', 'ready', this._clearFlowRestrictedProducts.bind(this));
    }

  }

  Search.prototype = $.extend({}, Search.prototype, {
    /**
     * Removes products from the page that are flagged as "excluded" or "restricted" by Flow.
     *
     */
    _clearFlowRestrictedProducts: function() {

      if(window.Flow) {
        var removedProductCount = 0;
        var experienceKey = Flow.getExperience();
        var productCount = parseInt(this.$productCount.text());
        var flowVariants  = Flow.cache.localizedVariants.store;
        var restrictedVariants;

        if(experienceKey) {

          restrictedVariants = flowVariants.filter(function(variant) { 
            return variant.experience.key === experienceKey;
          }).filter(function(variant) { 
            return variant.status === 'excluded' || variant.status === 'restricted';
          });

          restrictedVariants.forEach(function(variant) {
            var $el = $('[flow-localized-variant='+variant.id+']');
            if($el.length) {
              $el.parents(selectors.productGridItemProduct).remove();
              removedProductCount++;
            }
          });

          var finalProductCount = productCount - removedProductCount;
          this.$productCount.text(finalProductCount);
          this.$productCountLabel.text(finalProductCount == 1 ? 'Result' : 'Results');
        }
      }
      
    }
  });

  return Search;
})(jQuery);

/**
 * Country Selector Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the country selector
 *
 * @namespace - countrySelector
 */

theme.CountrySelector = (function($) {

  var $window = $(window);
  var $body = $('body');

  var selectors = {
    drawer: '[data-country-selector-drawer]',
    open: '[data-country-selector-open]',
    country: '[data-country-key][data-country-code-3]',
    defaultCountry: '[data-default-country]',
    flagImg: '[data-flag-img]'
  };

  var classes = {
    countryIsActive: 'is-active'
  };

  function CountrySelector(container) {
    this.$container = $(container);

    this.name = 'countrySelector';
    this.namespace = '.'+this.name;

    this.events = {
      READY: 'ready' + this.namespace
    };    

    this.flowEnabled = false;

    this.$open           = $(selectors.open); // Don't scope to $container
    this.$drawer         = $(selectors.drawer, this.$container);
    this.$countries      = $(selectors.country, this.$container);
    this.$defaultCountry = $(selectors.defaultCountry, this.$container);

    this.drawer = new slate.Drawer( this.$drawer );

    this.$open.on('click', this.onOpenClick.bind(this));
    this.$countries.on('click', this.onCountryClick.bind(this));

    window.Flow && Flow.set('on', 'ready', this.onFlowReady.bind(this));
  }

  CountrySelector.prototype = $.extend({}, CountrySelector.prototype, {

    updateUIForExperience: function(experience) {
      var $selectedCountry = this.$defaultCountry;

      if(experience) {
        var experienceRegEx = new RegExp(experience);

        this.$countries.each(function(i) {
          var $countryEl = $(this);
          var countryKey = $countryEl.data('country-key');
          var countryRegEx = new RegExp(countryKey);

          if(countryRegEx.test(experience) || experienceRegEx.test(countryKey)) {
            $selectedCountry = $countryEl;
          }
        });
      }
      
      $selectedCountry.addClass(classes.countryIsActive);

      var e = $.Event(this.events.READY, {
        countryTitle: $selectedCountry.data('country-title'),
        countryKey: $selectedCountry.data('country-key'),
        countryCode3: $selectedCountry.data('country-code-3'),
        countryCode2: $selectedCountry.data('country-code-2'),
        imgSrc: $selectedCountry.find(selectors.flagImg).attr('src'),
        shippingMessage: 'Shipping to ' + $selectedCountry.data('country-title')
      });

      $window.trigger(e);      
    },

    /**
     * Handles the actual changing of the user's country
     * Let's flow know, cleans up stuff and then reloads the page
     */
    changeCountry: function(countryCode) {
      var requests = [];

      var promises = {
        flowSetCountry: $.Deferred(),
        flowCartClear: $.Deferred()
      };

      // Create a function for each AJAX request that we need to make
      // Normalize them to all return promises so we can queue them
      function flowSetCountry(countryCode) {
        Flow.setCountry(countryCode, {
          success: function() {
            promises.flowSetCountry.resolve();
          },
          error: function() {
            promises.flowSetCountry.reject();
          }
        });
      }

      function flowCartClear() {
        Flow.cart.clear({
          success: function(status, cart) {
            promises.flowCartClear.resolve(cart);
          },
          error: function(status, error) {
            promises.flowCartClear.reject({
              message: error.messages[0]
            });
          }
        });
      }

      // Now make all the requests and run the call back when they're all done
      if(this.flowEnabled && countryCode) {
        requests.push(flowSetCountry(countryCode));
        requests.push(flowCartClear());
        requests.push($.post('/cart/clear.js'));

        $.when.apply($, requests).then( function() {
          window.location.reload();
        });
      }
    },

    onFlowReady: function() {
      this.flowEnabled = true;
      this.updateUIForExperience( Flow.getExperience() );
    },

    onCountryClick: function(e) {
      e.preventDefault();
      var $el = $(e.currentTarget);
      var countryCode = $el.data('country-code-3') || this.$defaultCountry.data('country-code-3');

      this.changeCountry( countryCode );
    },

    onOpenClick: function(e) {
      e.preventDefault();
      
      if(this.flowEnabled) {
        this.drawer.open();  
      }
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.drawer.open();
    },

    onDeselect: function() {
      this.drawer.close();
    },
  });

  return CountrySelector;
})(jQuery);

/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - FuturePresentPage
 */

theme.FuturePresentPage = (function($) {

    var $window = $(window);

    var selectors = {
      productCard: '.product-card'
    };
    
    /**
     * Pencil Banner section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     *
     * @param {string} container - selector for the section container DOM element
     */
    function FuturePresentPage(container) {
      this.$container = $(container);
  
      this.name = 'FuturePresentPage',
      this.namespace = '.'+this.name;

      this.initProductSlider();
    };
  
    FuturePresentPage.prototype = $.extend({}, FuturePresentPage.prototype, {
        initProductSlider: function() {
          $("#future-present-products-container").on('init', function(event, slick){
            $.each($(selectors.productCard), function(index, product) {
              if($(this).data('tags').indexOf('pre-order') > -1) {
                $(this).find('[data-product-pre-order-badge]').show();
              }
            });
          });

          $("#future-present-products-container").slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            autoplay: true,
            autoplaySpeed: 3000,
            prevArrow: '<a href="#" class="arrow arrow--left arrow--transparent" aria-label="Previous slide"><span class="arrow__icon"></span></a>',
            nextArrow: '<a href="#" class="arrow arrow--right arrow--transparent" aria-label="Next slide"><span class="arrow__icon"></span></a>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll:2,
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                }
            ]           
          });          
        }
    });
  
    return FuturePresentPage;
  })(jQuery);
  
/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - WoolarooPage
 */

theme.WoolarooPage = (function($) {

    var $window = $(window);

    var selectors = {
      productCard: '.product-card'
    };
    
    /**
     * Pencil Banner section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     *
     * @param {string} container - selector for the section container DOM element
     */
    function WoolarooPage(container) {
      this.$container = $(container);
  
      this.name = 'WoolarooPage',
      this.namespace = '.'+this.name;

      this.initBadgeDisplay();
    };
  
    WoolarooPage.prototype = $.extend({}, WoolarooPage.prototype, {
      initBadgeDisplay: function() {
        $.each($(selectors.productCard), function(index, product) {
          if($(this).data('tags').indexOf('woolaroo') > -1) {
            $(this).find('[data-product-woolaroo-badge]').show();
          }
        });       
      }
    });
  
    return WoolarooPage;
  })(jQuery);
  
/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - WoolarooPage
 */

theme.WSLSurfRanchProPage = (function($) {

    var $window = $(window);

    var selectors = {
      productCard: '.product-card'
    };
    
    /**
     * Pencil Banner section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     *
     * @param {string} container - selector for the section container DOM element
     */
    function WSLSurfRanchProPage(container) {
      this.$container = $(container);
  
      this.name = 'WSLSurfRanchProPage',
      this.namespace = '.'+this.name;

      this.initBadgeDisplay();
    };
  
    WSLSurfRanchProPage.prototype = $.extend({}, WSLSurfRanchProPage.prototype, {
      initBadgeDisplay: function() {
        $.each($(selectors.productCard), function(index, product) {
          if($(this).data('tags').indexOf('pre-order') > -1) {
            $(this).find('[data-product-pre-order-badge]').show();
          }
        });       
      }
    });
  
    return WSLSurfRanchProPage;
  })(jQuery);
  
/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - SurfRanchPrivateShop
 */

theme.SurfRanchPrivateShopLogin = (function($, slate) {

  var $window = $(window);

  var selectors = {
    srLoginForm: '[data-sr-login-form]',
    srLoginFormContainer: '[data-sr-login-form-container]',
    alreadyLoggedIn: '[data-already-logged-in]',
    emailAddress: '[data-email-address]',
    password:'[data-login-password]',
    srLoginButton: '[data-sr-login-button]',
    formErrors: '[data-form-errors]',
    access: '[data-access]'
  };

  //cookie to set after user login
  var canAccessSurfRanchPrivateSaleCookieKey = '_ok_canAccessSurfRanchPrivateSale';
  
  /**
   *
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function SurfRanchPrivateShopLogin(container) {
    this.$container = $(container);

    this.name = 'SurfRanchPrivateShop',
    this.namespace = '.'+this.name; 

    this.$formError = $(selectors.formErrors, this.$container);
    this.$access = $(selectors.srLoginForm, this.$container).data('access');
    this.$listID = $(selectors.srLoginForm, this.$container).data('klaviyo-list-id');
    this.$source = $(selectors.srLoginForm, this.$container).data('klaviyo-source');

    //show your'e logged in section so user can navigate to collection pages 
    // if(this.isLoggedIn() == false ) {
    //   $(selectors.alreadyLoggedIn, this.$container).hide();
    //   $(selectors.srLoginFormContainer, this.$container).show();
    // }
    // else {
    //   $(selectors.srLoginFormContainer, this.$container).hide();
    //   $(selectors.alreadyLoggedIn, this.$container).show();
    // }    
   
    if(slate.utils.isThemeEditor() == false) {
      if(this.isLoggedIn()) {
        window.location.replace("/pages/surf-ranch-collection-mens");      
      }
    }  

    this.$container.on('click', selectors.srLoginButton, this.onLoginButtonClick.bind(this));
  };

  SurfRanchPrivateShopLogin.prototype = $.extend({}, SurfRanchPrivateShopLogin.prototype, {
    onLoginButtonClick: function(e) {
      e.preventDefault();
      var $emailAddress = $(selectors.emailAddress, this.$container).val();
      var $password = $(selectors.password, this.$container).val().toLowerCase();
      
      if($emailAddress != "" && $password != "") {
        if(slate.utils.validateEmailAddress($emailAddress) && this.validatePassword($password)) {
            this.submitEmailAddressToKlaviyo($emailAddress);
            return true;
        } else {

          if(!slate.utils.validateEmailAddress($emailAddress) && !this.validatePassword($password)) {
            this.showError('Enter a valid email address and password.');
            return false;
          }

          if(!slate.utils.validateEmailAddress($emailAddress) && this.validatePassword($password)) {
            this.showError("Enter a valid email address.");
            return false;
          }

          if(!this.validatePassword($password) && slate.utils.validateEmailAddress($emailAddress)) {
            this.showError("Invalid password, check your email and try again.");
            return false;
          }          
        }

        return true;

      } else {
        //show enter email address and password message.
        this.showError('Enter a valid email address and password.');
        return false;
      } 
    },
    validatePassword: function(password) {
      return this.$access == password;
    },
    isLoggedIn: function() {
      if(slate.user.getCookieValue(canAccessSurfRanchPrivateSaleCookieKey) == undefined) {
        return false
      }      

      return true;
    },
    submitEmailAddressToKlaviyo: function(email) {
      var requestURL = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
      var _this = this;

      $.ajax({
        async: true,
        crossDomain: true,
        url: requestURL,
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "cache-control": "no-cache"
        },
        data: {
          "g": this.$listID,
          "$fields": "$source",
          "email": email,
          "$source": this.$source,
        }        
      })
      .done(function(data){
        //show your'e logged in section so user can navigate to collection pages
        //$(selectors.srLoginFormContainer, this.$container).hide();
        //$(selectors.alreadyLoggedIn, this.$container).show();
        _this.setTheCookie();
        window.location.replace("/pages/surf-ranch-collection-mens");
      })
      .fail(function(){
        var errors = [];
        if(jqXHR.responseJSON.hasOwnProperty('errors')) {
          errors = jqXHR.responseJSON.errors;
        }
        console.log(errors);
      });
    },
    setTheCookie: function() {
      if(!slate.utils.isThemeEditor()) {
        slate.user.setCookie({name: canAccessSurfRanchPrivateSaleCookieKey, value: true, expiration: 365});
      }
    },
    showError: function(errorMessage) {
      if(errorMessage == 'default') {
        this.$formError.fadeIn();
      } else {
        this.$formError.find("ul li").text("").text(errorMessage);
        this.$formError.fadeIn();
      }
    },
    hideError: function() {
      this.$formError.fadeOut();
    }
  });

  return SurfRanchPrivateShopLogin;
})(jQuery, slate);

/**
 * Merch Strip Video script
 * ------------------------------------------------------------------------------
 *
 * @namespace - MerchStripVideo
 */

theme.MerchStripVideo = (function(container) {

  var selectors = {
    video: '[data-video-player]'
  };

  function MerchStripVideo(container) {
    var self = this;

    this.$container = $(container);
    this.$window = $(window);
    this.$video = $(selectors.video, this.$container);

    this.name = 'merchStripVideo';
    this.namespace = '.'+this.name;

    if (this.$video.data('video-type') == 'youtube') {
      this.$window.on('PlayerReady', function () {
        self.initVideo();
      });
    }    
  }

  MerchStripVideo.prototype = $.extend({}, MerchStripVideo.prototype, {

    initVideo: function () {
      this.video = new slate.models.VideoPlayer(this.$video, this.$container);    
    },
  });

  return MerchStripVideo;
})(jQuery);


/**
 * Triple CTA script
 * ------------------------------------------------------------------------------
 *
 * @namespace - TripleCTA
 */

theme.TripleCTA = (function(container) {

  var selectors = {
    scrollCta: '.smooth-scroll'
  };

  function TripleCTA(container) {

    this.$container = $(container);
    this.name = 'tripleCTA';
    this.namespace = '.'+this.name;

    this.CTA = $(selectors.scrollCta, this.$container);
    this.CTA.on('click', this.onSmoothScroll.bind(this));
  }

  TripleCTA.prototype = $.extend({}, TripleCTA.prototype, {

    onSmoothScroll: function(e) {
      e.preventDefault();

      var $target = $(e.currentTarget);
      var anchor = $target.attr("href");
      var topPos = $(''+anchor+'').offset().top;

      $('html, body').animate({ scrollTop : ( topPos - 50)});   
    },
  });

  return TripleCTA;
})(jQuery);


/**
 * CMS Page Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace - cmsPage
 */

 theme.CMSPage = (function($, Slideshow) {
	 var selectors = {
		slideshowWrapper: "[data-slideshow-wrapper]",
		productSize: '[data-variant-option-value]',
    variantOptionValueList: '[data-variant-option-value-list][data-option-position]',
    variantOptionValue: '[data-variant-option-value]',
    variantHasInseam: '[data-variant-option-value-type]',
    quickAddCopy: '.product-card__quick-add-copy',
    quickAddSubCopy: '.product-card__quick-add-sub-copy',
    quickAddWrap: '.product-card__quick-add-wrap',
    productInseamContainer: '[data-inseam-container]' 
	 }

	 function CMSPage(container) {
		 this.$container = $(container);

		 this.name = "cmsPage";
		 this.namespace = "." + this.name;

		 this.$slideshow = $(selectors.slideshowWrapper, this.$container);

		 this.slideshow = new Slideshow(this.$slideshow);
		 
		 this.$container.on('click', selectors.productSize, this.onSizeClick.bind(this));
		 this.$container.on('mouseenter mouseleave', selectors.quickAddWrap, this.updateQuickAddState.bind(this));
	 }

	 CMSPage.prototype = $.extend({}, CMSPage.prototype, {
    /**
     * Add an item to the cart if it's available
     */
    addToCart(variantId, qty, properties, callback) {
      window.globalCart.ajaxCart.cartProvider.addItem(variantId, qty, properties)
      .then(function(cart){
        return new Promise(function(resolve) {
          slate.utils.sendDataToKlaviyo(cart);
          slate.utils.sendDataToFacebook(cart, variantId);
          resolve(cart);
        });
      })
      .then(function(cart){
        window.globalCart.ajaxCart.onItemAddSuccess(cart);
      })
      .fail(function(data){
        window.globalCart.ajaxCart.onItemAddFail(data);
      });

      if (callback) callback();
    },
    onSizeClick:function(e) {
      var $currentProduct = $(e.currentTarget).parents(".product-card");
      var productId = $($currentProduct).data("product-id");  
      var $option = $(e.currentTarget);
      var value     = $option.data('variant-option-value');
      var position  = $option.data('option-position');
      var Option2List = $('[data-variant-option-value-list][data-option-position="2"]', $currentProduct);
      var Option3List = $('[data-variant-option-value-list][data-option-position="3"]', $currentProduct);
      var productInseam = $(selectors.productInseamContainer, $currentProduct);
      var subCopy = $(selectors.quickAddSubCopy, $currentProduct);
      var $properties = {};

      if($option.hasClass("is-disabled")){
        return;
      }

      var $product = window.ShopifySeedData.collection.find(function(c) {
        return c.id == productId;
      });

      if($product.options_with_values.length <= 2) {
        $product.options_with_values[position -1].selected_value = value;

        var selectedVariant = $product.variants.find(function(v) {
          return $product.options_with_values.every(function(option) {
            return option.selected_value == v.options[option.position -1];
          });
        });
        //add product with color/size to cart
        if($option.hasClass("is-pre-order") && selectedVariant.pre_order_estimated_ship_date != "") {
          $properties["Estimated Shipping"] = selectedVariant.pre_order_estimated_ship_date;
        }
        this.addToCart(selectedVariant.id, 1, $properties);

      } else if($product.options_with_values.length > 2) {
        $product.options_with_values[position -1].selected_value = value;

        if(position == 2) {

          $('.dot', Option3List).hide();

          $product.variants.filter(function(v) {
            return v.options[1] == value && v.available;
          }).forEach(function(v) {
            var currOpts = $('[data-variant-option-value="' + v.options[2] + '"]', Option3List);
            currOpts.show();
          });

          $currentProduct.find('[data-variant-option-value-list][data-option-position="2"]', $currentProduct).hide();
          if(productInseam.length > 0) {
            subCopy.text("Select your inseam");
          }
          Option3List.show();
        } else if(position == 3) {
          
          var selectedVariant = $product.variants.find(function(v) {
            return $product.options_with_values.every(function(option) {
              return option.selected_value == v.options[option.position -1];
            });
          });
    
          //add product with color/size/inseam to cart
          this.addToCart(selectedVariant.id, 1, $properties, function() {
            Option3List.delay(1200).hide(0);
            Option2List.delay(1500).show(0);
          });
        }
      }
    },
    updateQuickAddState: function(e) {
      var $currentProduct = $(e.currentTarget).parents(".product-card");
      var option = $(selectors.variantOptionValue, $currentProduct);
      var copy = $(selectors.quickAddCopy, $currentProduct);
      var subCopy = $(selectors.quickAddSubCopy, $currentProduct);
      var productInseam = $(selectors.productInseamContainer, $currentProduct);
      var Option2List = $('[data-variant-option-value-list][data-option-position="2"]', $currentProduct);
      var Option3List = $('[data-variant-option-value-list][data-option-position="3"]', $currentProduct);

      if(e.type == 'mouseleave') {
        copy.text("Quick Add");

        if(productInseam.length > 0){
          subCopy.text("");
          Option2List.show();
          Option3List.hide();
        }
      }

      if(e.type == 'mouseenter' && productInseam.length > 0) {
        subCopy.text("Select your waist size"); 
      }

      option.on('mouseenter', function(){
        if($(this).hasClass("is-disabled")) {
          copy.text("Notify me when restocked");
        } else if($(this).hasClass("is-pre-order")){
          copy.text("Pre-order this product");
        } else {
          copy.text("Quick Add");
        }
      });
    }
  });
	 return CMSPage;
 })(jQuery, theme.Slideshow)
// =require sections/archetype.js

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  var selectors = {
    addressNewToggle: '[data-address-new-toggle]',
    addressEditToggle: '[data-address-edit-toggle][data-form-id]',
    addressDelete: '[data-address-delete][data-form-id]'
  };

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $(selectors.addressNewToggle).on('click', function(e) {
    e.preventDefault();
    $newAddressForm.toggleClass('hide');
  });

  $(selectors.addressEditToggle).on('click', function(e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $(selectors.addressDelete).on('click', function(e) {
    e.preventDefault();
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#RecoverPassword').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Customers Order
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the customers/order.liquid template
 *
 * @namespace customerOrder 
 */

 theme.customerOrder = (function($, undefined) {
  
  var selectors = {
    shopifyTotalLines: '[data-shopify-total-lines]',
    flowTotalLines: '[data-flow-total-lines]'
  }

  if( !$('body').is('.template-order')){
    return;
  }

  if(Flow) {
    Flow.set('on', 'ready', function() {
      // If there is a localized content for the order (inside $(selectors.flowTotalLines)), hide the shopify stuff
      // We don't need to check Flow.getExperience() here because the order has already been placed.  The user can switch between experiences, but we need to display the order details for the experience set when it was placed.
      if($(selectors.flowTotalLines).text().replace(/\s/g,'').trim().length) {
        $(selectors.shopifyTotalLines).remove();
      }
      else {
        $(selectors.flowTotalLines).remove();
      }  
    });
  }

})(jQuery);

/**
 * Customers Account
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the customers/account.liquid template
 *
 * @namespace customerAccount
 */

 theme.customerAccount = (function($, undefined) {
  
  var selectors = {
    klaviyoForm: '[data-klaviyo-account-form]'
  }

  if( !$('body').is('.template-account')){
    return;
  }

  var emailCollectedCookie = slate.user.createCookie('emailCollected');
  var $klaviyoForm = $(selectors.klaviyoForm).first();
  var ajaxKlaviyoForm;

  function removeKlaviyoForm() {
    $klaviyoForm.length && $klaviyoForm.remove();
  }

  function ajaxFormCallback() {
    slate.user.setCookie(emailCollectedCookie);  // Set the cookie here so prevent this from running every time they hit this page
    removeKlaviyoForm();
  }

  if($klaviyoForm.length) {
    if(!slate.user.hasCookie(emailCollectedCookie.name)) {
      ajaxKlaviyoForm = new slate.AjaxKlaviyoForm($klaviyoForm, {
        listId: $klaviyoForm.data('klaviyo-list-id'),
        source: $klaviyoForm.data('klaviyo-source'),
        onSubscribeSuccess: ajaxFormCallback,
        onSubmitFail: ajaxFormCallback
      });

      // Silently subscribe them
      $klaviyoForm.submit();
    }
    else {
      // Already collected their email, just remove the form
      removeKlaviyoForm();
    }
  }

})(jQuery);

/**
 * Cart Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart
 * template.
 *
 * @namespace cart
 */

theme.cart = (function ($, undefined) {

  /**
   * Custom Exception for Quantity Limits
   * @param {*} message 
   * @param {*} variantID 
   */
  function QuantityException(message, variantID) {
    var error = new Error(message);
    error.variantID = variantID
    return error;
  }
  QuantityException.prototype = Object.create(Error.prototype);

  var selectors = {
    form: '[data-cart-form]',
    itemQtySelect: '[data-item-quantity-select]',
    giftPackageSelect: '[data-package-select]',
    giftMessageSelect: '[data-message-select]',
    helperMessage: 'data-helper-message' // not including [], since will use dinamically with variant ID
  }

  var data = {
    quantityLimit: 'quantity-limit'
  };

  if (!$('body').is('.template-cart')) {
    return;
  }

  function Cart() {
    this.$form = $(selectors.form);

    this.$giftSelects = $(selectors.giftPackageSelect + ", " + selectors.giftMessageSelect, this.$form);
    this.$helperMessage = $(selectors.helperMessage, this.$form);

    if (Flow) {
      Flow.set('on', 'ready', function () {
        if (Flow.getExperience()) {
          Flow.cart.redirectToCart();
        }
      });
    }

    var self = this;
    // Since we have more than 1 quantity select per row (1 for mobile, 1 for desktop)
    // We need to use single input per row, which is responsible for sending the form data for that line item
    // Watch for changes on the quantity selects, and then update the input.  These two are tied together using a data attribute
    $(selectors.itemQtySelect).on('change', function () {
      var $itemQtyInput = $('[id="' + $(this).data('item-quantity-select') + '"]'); // Have to do '[id=".."]' instead of '#id' because id is generated using {{ item.key }} which has semi-colons in it - breaks normal id select
      $itemQtyInput.val($(this).val());
      self.$form.submit();
    });

    this.$giftSelects.on('change', function () {
      // relies on /slate/ajaxCart to run first to initialize ShopifyAPI
      if (!ShopifyAPI) {
        return;
      }

      var $select = $(this);
      var idVal = $select.val();
      var quantityLimit = $select.data(data.quantityLimit);

      if (idVal) {
        var id = parseInt(idVal);
        ShopifyAPI.getCart().then(function (cart) {
          var giftVariant = cart && Array.isArray(cart.items) && cart.items.find(function (item) {
            return item.id === id;
          });

          if (quantityLimit && giftVariant && giftVariant.quantity + 1 > quantityLimit) {
            throw new QuantityException(
              "Maximum " + quantityLimit + " items can be added to the cart",
              giftVariant.id
            );
          }

          ShopifyAPI.addItem(id, 1).then(function () {
            location.reload();
          });
        }).catch(function (err) {
          // If that's QuantityException 
          if (err.variantID && err.message) {
            // reset select elemt
            $select.prop('selectedIndex', 0).trigger("change");
            $select.trigger('chosen:updated');
            // display helper message
            var $helperMessage = $('[' + selectors.helperMessage + '="' + err.variantID + '"]', self.$form);
            self.addHelperMessage(err.message, $helperMessage);
          }
        });
      }
    });
  }

  Cart.prototype = $.extend({}, Cart.prototype, {
    addHelperMessage: function (text, $helperMessage) {
      if ($helperMessage && $helperMessage.length && text) {
        var errorHTML = '<p class="Cart-list__helper-text">' + text + '</p>';
        $helperMessage.html();
        $helperMessage.html(errorHTML);
      }
    }
  });

  return new Cart();
})(jQuery);

/**
 * Styleguide Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the styleguide page template.
 *
 * Use this to hook up any JS necessary to show element functionality.
 */

 theme.styleguide = (function() {
  
  var $body = $(document.body);
  
  var selectors = {
    dot: '.dot'
  }

  if( !$body.is('#styleguide') ){
    return;
  }

  $body.on('click', selectors.dot, function(){
    $(this).toggleClass('is-active');
  });

  $body.on('click', 'a[href="#"]', function(){
    return false;
  });

})();


/*================ Components ================*/

theme.components.StickyNav = (function () {
  var selectors = {
    nav: "#sticky-nav",
    navContainer: "#sticky-nav-container",
    stickyNavCTA: ".sticky-nav__cta",
  };
  var $header = $(".header"),
    $window = $(window),
    headerHeight = $header.outerHeight();

  function StickyNav(container) {
    var self = this;
    this.$container = $(container);

    this.name = "StickyNav";
    this.namespace = "." + this.name;

    this.$nav = $(selectors.nav, this.$container);
    this.$stickyNavContainer = $(selectors.navContainer);
    this.$cta = $(selectors.stickyNavCTA, this.$container);
    if (this.$nav.length > 0) {
      this.navTop = this.$nav.offset().top;
      this.navHeight = this.$nav.outerHeight();
    }
    this.isStuck = false;

    $window.on("resize", function () {
      if (self.$nav.length > 0) {
        self.navTop = self.$nav.offset().top,
        self.navHeight = self.$nav.outerHeight(),
        headerHeight = $header.outerHeight();
      }
    });

    $(document).on("scroll", $.throttle(20, this.stickCheck.bind(this)));
    $(this.$cta).click(this.smoothScroll.bind(this));
  }

  StickyNav.prototype = $.extend({}, StickyNav.prototype, {
    stickCheck: function () {
      if (
        $(window).scrollTop() + headerHeight >= this.navTop &&
        !this.isStuck
      ) {
        this.stickNav();
      } else if (
        $(window).scrollTop() + headerHeight < this.navTop &&
        this.isStuck
      ) {
        this.unstickNav();
      }
    },
    stickNav: function () {
      this.$nav.css({ top: headerHeight });
      this.$nav.addClass("sticky-fixed");
      this.$stickyNavContainer.css("padding-bottom", 72 + "px");
      this.isStuck = true;
    },
    unstickNav: function () {
      this.$nav.css({ top: "initial" });
      this.$nav.removeClass("sticky-fixed");
      this.$stickyNavContainer.css("padding-bottom", 0);
      this.isStuck = false;
    },
    smoothScroll: function (e) {
      e.preventDefault();
      var anchor;
      if (e.target !== e.currentTarget) {
        target = $(e.target).parents(".sticky-nav__cta");
        anchor = $(target).attr("href");
      } else {
        anchor = $(e.target).attr("href");
      }
      var $scrollEl = $(anchor);
      if ($scrollEl) {
        $("html, body").animate({ scrollTop: $(anchor).offset().top });
      }
    },
  });
  return StickyNav;
})(jQuery);


(function($, undefined) {
  var $window = $(window);
  var $document = $(document);
  var $body = $(document.body);

  var name = "ok";
  var namespace = "." + this.name;

  $(document).ready(function() {
    var sections = new slate.Sections();
    sections.register("product", theme.Product);
    sections.register("collection", theme.Collection);
    sections.register("pencil-banner", theme.PencilBanner);
    sections.register("subscription-slideup", theme.SubscriptionSlideUp);
    sections.register("instagram-feed", theme.InstagramFeed);
    sections.register("slideshow", theme.Slideshow);
    sections.register("header", theme.Header);
    sections.register("footer", theme.Footer);
    sections.register("mobile-menu", theme.MobileMenu);
    sections.register("hero", theme.Hero);
    sections.register("ajax-cart", theme.AjaxCart);
    sections.register("collection-list-page", theme.CollectionListPage);
    sections.register("size-guide", theme.SizeGuide);
    sections.register("blog", theme.Blog);
    sections.register("search", theme.Search);
    sections.register("country-selector", theme.CountrySelector);
    sections.register("future-present-page", theme.FuturePresentPage);
    sections.register("woolaroo-page", theme.WoolarooPage);
    sections.register("wsl-surf-ranch-pro-page", theme.WSLSurfRanchProPage);
    sections.register(
      "surf-ranch-private-shop-login",
      theme.SurfRanchPrivateShopLogin
    );
    sections.register("merch-strip", theme.MerchStripVideo);
    sections.register("triple-cta", theme.TripleCTA);
    sections.register("cms-page", theme.CMSPage);
    sections.register("archetype", theme.Archetype);
    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $(".in-page-link").on("click", function(evt) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Wrap videos in div to force responsive layout.
    slate.rte.fixTables();
    slate.rte.iframeReset();

    // Apply UA classes to the document
    slate.utils.userAgentBodyClass();

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
      document.documentElement.className = document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      );
    }

    // Chosen JS plugin for select boxes
    slate.utils.chosenSelects();

    // Modals
    $(".modal").on("show.bs.modal", function(e) {
      var $modal = $(e.currentTarget);

      // If it's a full screen modal, make sure the backdrop is transparent and that we remove the class after the modal closes
      if ($modal.hasClass("modal--fullscreen")) {
        $body.addClass("modal-transparent-backdrop");

        $modal.one("hidden.bs.modal", function() {
          $body.removeClass("modal-transparent-backdrop");
        });
      }
    });

    // Link entire content blocks to CTA 1 url
    $(document).delegate(".data-block-link-cta1", "click", function() {
      window.location = $(this)
        .find(".cta-link")
        .attr("href");
    });

    // Open outside links in a new window
    $('a[href^="http"]')
      .not('a[href^="' + $(location).attr("hostname") + '"]')
      .attr("target", "_blank");

    // Check if there is a stickynav
    var stickyNavContainer = $("#sticky-nav-container");
    if (stickyNavContainer) {
      this.stickyNav = new window.theme.components.StickyNav(
        stickyNavContainer
      );
    }

    function applyFlowBodyClass() {
      $body.addClass("template-flow-checkout");
    }

    // Localize pricing
    if (Flow) {
      Flow.set("on", "ready", function() {
        Flow.getExperience() && Flow.localize();
      });

      Flow.set("on", "pageview.cart", applyFlowBodyClass);
      Flow.set("on", "pageview.checkout_step_1", applyFlowBodyClass);
      Flow.set("on", "pageview.checkout_step_2", applyFlowBodyClass);
      Flow.set("on", "pageview.checkout_step_3", applyFlowBodyClass);

      // begin - added for INTL Google analytics order conversion tag
      Flow.set("on", "pageview.checkout_thank_you", function handlePageView(
        data
      ) {
        $body.addClass("template-flow-checkout");
        var amount = 0;
        var currency;
        var shipping = 0;
        var tax = 0;
        var duties = 0;
        var discounts = 0;

        if (
          !sessionStorage.ga_flow_conversion_event ||
          sessionStorage.ga_flow_conversion_event != data.order.number
        ) {
          ga("require", "ec");

          for (var i = 0; i < data.order.items.length; i++) {
            ga("ec:addProduct", {
              id: data.order.items[i].number,
              name: data.order.items[i].name,
              price: data.order.items[i].local.prices[0].base.amount,
              quantity: data.order.items[i].quantity,
            });
          }

          // find subtotal amount and currency in order price components (IE9+)
          data.order.prices.some(function(price) {
            if (price.key === "subtotal") {
              amount = price.base.amount;
              currency = price.base.currency;
              return true;
            }
            return false;
          });

          data.order.prices.some(function(price) {
            if (price.key === "discount") {
              // is a negative number
              discounts = price.base.amount;
              return true;
            }
            return false;
          });

          data.order.prices.some(function(price) {
            if (price.key === "shipping") {
              shipping = price.base.amount;
              return true;
            }
            return false;
          });

          data.order.prices.some(function(price) {
            if (price.key === "vat") {
              tax = price.base.amount;
              return true;
            }
            return false;
          });

          data.order.prices.some(function(price) {
            if (price.key === "duty") {
              duties = price.base.amount;
              return true;
            }
            return false;
          });

          ga("ec:setAction", "purchase", {
            id: data.order.number,
            // discounts is a negative number
            revenue: amount + discounts + shipping + tax + duties,
            currency_code: currency,
            shipping: shipping,
            tax: tax + duties,
          });

          ga("send", "pageview");
          sessionStorage.ga_flow_conversion_event = data.order.number;
        }
      });
      // end - added for INTL Google analytics order conversion tag
    }

    onYouTubeIframeAPIReady = function() {
      $(window).trigger("PlayerReady");
    };

    // Archetypes - trigger archetype on trigger click
    if (window.reactAPI && window.reactAPI.ArchetypeManager) {
      $body.on("click", "[data-archetype-trigger]", function(e) {
        var $target = $(e.currentTarget);
        var handle = $target.attr("data-archetype-trigger");
        if (handle) {
          window.reactAPI.ArchetypeManager.trigger(handle);
        }
      });
    }
  });
})(jQuery);
